import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';
import { DefaultService } from "@psnb/psnb-api";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  searchHieArray:any;
  constructor(private powerSupplyService: DefaultService) { }

  public getApuReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getAPUReports(this.searchHieArray);
  }

  public getInspectionReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getInspectionReports(this.searchHieArray);
  }

  public getPowerSupplyReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getPowerSupplyReports(this.searchHieArray);
  }

  public getLocationReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getLocationReports(this.searchHieArray);
  }

  public getTransponderReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getTransponderReports(this.searchHieArray);
  }

  public getSpatialNetReport(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getSpatialNetIdReport(this.searchHieArray);
  }

  public getPowerSupplyRemoteTestReport(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getPowerSupplyRemoteTestReport(this.searchHieArray);
  }

  public getEqJobsReportByNodeIdAndDates(nodeId,nwtstartDate,nwtendDate) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"createDate":"'+nwtstartDate+'","endDate":"'+nwtendDate+'"}'));
    return this.powerSupplyService.getEqJobsReportByNodeIdAndDates(this.searchHieArray);
  }

  public getEQJobCertReportByHieAndDates(nodeId,nwtcertstartDate,nwtcertendDate) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"createDate":"'+nwtcertstartDate+'","endDate":"'+nwtcertendDate+'"}'));
    return this.powerSupplyService.getEQJobCertReportByHieAndDates(this.searchHieArray);
  }
  public getPowerSupplyNwtReport(nodeId, regionName,startdate,enddate) {
    return this.powerSupplyService.getPowerSupplyRemoteTestReport(nodeId, regionName);
  }

  public getReliabilityReport(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getReliabilityReport(this.searchHieArray);
  }

  public getVulnerabilityReport(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getVulnerabilityReport(this.searchHieArray);
  }

  public getCombinedInventoryPowerSupplyReportsExport(PowerSupplyCombinedInventoryReportsRequest) {
    return this.powerSupplyService.getCombinedInventoryPowerSupplyReportsExport(PowerSupplyCombinedInventoryReportsRequest);
  }

  public getPowerSupplyDeletedReport(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getPowerSupplyDeletedReport(this.searchHieArray);
  }

  public getPsCertificationReport(nodeId, regionName ,isActive) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'","isActive":"'+isActive+'"}'));
    return this.powerSupplyService.getPsCertificationReport(this.searchHieArray);
  }

  public getPowerSupplyNodeAssociationReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getPowerSupplyNodeAssociationReports(this.searchHieArray);
  }

  public getPowerSupplyNetworkSyncReport(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getPowerSupplyNetworkSyncReport(this.searchHieArray);
  }
  public exportAsExcelFile(json: any[], excelFileName: string, fileType: string) {
    const workbook = new Excel.Workbook;
    workbook.addWorksheet(excelFileName);
    const sheet = workbook.getWorksheet(1);
    sheet.columns = this.getHeaders(fileType, json);
    sheet.addRows(json);
    if (fileType !== 'BATTERY') {
      sheet.eachRow(function (row, rowNumber) {
        row.eachCell({ includeEmpty: true }, function (cell) {
          if (rowNumber === 1) {
            sheet.getCell(cell.address.toString()).fill = {
              type: 'gradient', gradient: 'angle', degree: 0, stops: [
                { position: 0, color: { argb: 'd9f1fa' } },
                { position: 0.5, color: { argb: 'd9f1fa' } },
                { position: 1, color: { argb: 'd9f1fa' } }
              ]
            };
            sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
            sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
            sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
          } else {
            sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
            sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8 };
            sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
          }
        });
      });
    }
    if (fileType === 'RELIABILITY' || fileType === 'VULNERABILITY') {
      workbook.addWorksheet('Fields Definition');
      const sheet = workbook.getWorksheet(2);
      sheet.columns = [
        { header: 'Field', key: 'field', width: 25 },
        { header: 'Definition', key: 'definition', width: 100 }
      ]
      sheet.addRows(this.getDefinition(fileType));
      sheet.eachRow(function (row, rowNumber) {
        row.eachCell({ includeEmpty: true }, function (cell) {
          if (rowNumber === 1) {
            sheet.getCell(cell.address.toString()).fill = {
              type: 'gradient', gradient: 'angle', degree: 0, stops: [
                { position: 0, color: { argb: 'd9f1fa' } },
                { position: 0.5, color: { argb: 'd9f1fa' } },
                { position: 1, color: { argb: 'd9f1fa' } }
              ]
            };
            sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle' };
            sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
            sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
          } else {
            sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle' };
            sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8 };
            sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
          }
        });
      });
    }
    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
    })
    return false;
  }

  getHeaders(fileType: string, json: any[]) {
    if (fileType === 'NETWORKSYNC') {
      //Default Width's
      let wchregionName = 20;
      let wchpowerSupplyId = 15;
      let wchegisNumber = 20;
      let wchcommonLogicalIdStatus = 17;
      let wchmacAddress = 20;
      let wchsysLocation = 20;
      let wchsysName = 20;
      let wchsysNameStatus = 20;
      let wchprocessedTime = 20;

      return [
        { header: 'Region Name', key: 'regionName', width: wchregionName },
        { header: 'Powersupply ID', key: 'powerSupplyId', width: wchpowerSupplyId},
        { header: 'MacAddress',key: 'macAddress',width:wchmacAddress},
        { header: 'EGIS Number', key: 'egisNumber', width: wchegisNumber },
        { header: 'CommonLogicalIdStatus', key: 'commonLogicalIdStatus', width: wchcommonLogicalIdStatus },
        { header: 'SysLocation', key: 'sysLocation', width: wchsysLocation },
        { header: 'SysName', key: 'sysName', width: wchsysName },
        { header: 'SysNameStatus', key: 'sysNameStatus', width: wchsysNameStatus },
        { header: 'Processed Time', key: 'processedTime', width: wchprocessedTime },
      ];
    }

    if (fileType === 'NODEASSOCIATION') {
      //Default Width's
      let wchregionName = 20;
      let wchpowerSupplyId = 15;
      let wchpowerSupplyName = 20;
      let wchip = 17;
      let wchmacAddress = 20;
      let wchhierarchyPathLabels = 20;
      let wchegisName = 20;
      let wchnode = 20;
      let wchnode2 = 20;
      let wchnode3 = 20;
      let wchnode4 = 20;
      let wchnode5 = 20;
      let wchnode6 = 20;
      let wchnode7 = 20;
      let wchnode8 = 20;
      let wchnode9 = 20;
      let wchnode10 = 20;
      let wchnode11 = 20;
      let wchnode12 = 20;
      let wchnode13 = 20;
      let wchnode14 = 20;
      let wchnode15 = 20;
      let wchnode16 = 20;
      let wchnode17 = 20;
      let wchnode18 = 20;
      let wchnode19 = 20;
      let wchnode20 = 20;
      let wchnode21 = 20;
      let wchnode22 = 20;
      let wchnode23 = 20;
      let wchnode24 = 20;
      let wchnode25 = 20;
      let wchnode26 = 20;
      let wchnode27 = 20;
      let wchnode28 = 20;
      let wchnode29 = 20;
      let wchnode30 = 20;
      let wchnode31 = 20;
      let wchnode32 = 20;

      return [
        { header: 'Powersupply ID', key: 'powerSupplyId', width: wchpowerSupplyId},
        { header: 'MacAddress', key: 'macAddress',width:wchmacAddress},
        { header: 'Ip Address',key: 'ip',width:wchip},
        { header: 'PowerSupply Name', key: 'powerSupplyName', width: wchpowerSupplyName },
        { header: 'Hierarchy Path', key: 'hierarchyPathLabels', width: wchhierarchyPathLabels },
        { header: 'EGIS Key', key: 'egisName', width: wchegisName },
        { header: 'Region Name', key: 'regionName', width: wchregionName },
        //{ header: 'Node Name', key: 'node', width: wchnode },
        { header: 'Node', key: 'node', width: wchnode },
        { header: 'Node2', key: 'node2', width: wchnode2 },
        { header: 'Node3', key: 'node3', width: wchnode3 },
        { header: 'Node4', key: 'node4', width: wchnode4 },
        { header: 'Node5', key: 'node5', width: wchnode5 },
        { header: 'Node6', key: 'node6', width: wchnode6 },
        { header: 'Node7', key: 'node7', width: wchnode7 },
        { header: 'Node8', key: 'node8', width: wchnode8 },
        { header: 'Node9', key: 'node9', width: wchnode9 },
        { header: 'Node10', key: 'node10', width: wchnode10 },
        { header: 'Node11', key: 'node11', width: wchnode11 },
        { header: 'Node12', key: 'node12', width: wchnode12 },
        { header: 'Node13', key: 'node13', width: wchnode13 },
        { header: 'Node14', key: 'node14', width: wchnode14 },
        { header: 'Node15', key: 'node15', width: wchnode15 },
        { header: 'Node16', key: 'node16', width: wchnode16 },
        { header: 'Node17', key: 'node17', width: wchnode17 },
        { header: 'Node18', key: 'node18', width: wchnode18 },
        { header: 'Node19', key: 'node19', width: wchnode19 },
        { header: 'Node20', key: 'node20', width: wchnode20 },
        { header: 'Node21', key: 'node21', width: wchnode21 },
        { header: 'Node22', key: 'node22', width: wchnode22 },
        { header: 'Node23', key: 'node23', width: wchnode23 },
        { header: 'Node24', key: 'node24', width: wchnode24 },
        { header: 'Node25', key: 'node25', width: wchnode25 },
        { header: 'Node26', key: 'node26', width: wchnode26 },
        { header: 'Node27', key: 'node27', width: wchnode27 },
        { header: 'Node28', key: 'node28', width: wchnode28 },
        { header: 'Node29', key: 'node29', width: wchnode29 },
        { header: 'Node30', key: 'node30', width: wchnode30 },
        { header: 'Node31', key: 'node31', width: wchnode31 },
        { header: 'Node32', key: 'node32', width: wchnode32 },
      ];
    }

    if (fileType === 'NWTJBREPORT') {
      //Default Width's
      let wchjobid = 14;
      let wchpsId = 14;
      let wchteamName = 14;
      let wchnode = 14;
      let wchjobStatus = 14;
      let wchtaskType = 14;
      let wchcmts = 20;
      let wchcreateDate = 20;
      let wchendDate = 20;

      return [
        { header: 'Job ID', key: 'jobId', width: wchjobid },
        { header: 'PowerSupply Name', key: 'powerSupplyName', width: wchendDate },
        { header: 'Powersupply ID', key: 'psId', width: wchpsId},
        { header: 'Hierarchy Path', key: 'hierarchyPath', width: wchendDate },
        { header: 'Job Status', key: 'jobStatus', width: wchjobStatus },
        { header: 'CMTS', key: 'cmts', width: wchteamName },
        { header: 'Node Name', key: 'node', width: wchnode },
        { header: 'Team Name', key: 'teamName', width: wchnode },
        { header: 'Task Type', key: 'taskType', width: wchtaskType },
        { header: 'Create Date', key: 'createDateValue', width: wchcreateDate },
        { header: 'End Date', key: 'endDateValue', width: wchendDate },

      ];
    }
    if (fileType === 'NWTCERTJBREPORT') {
       //Default Width's
      let wchAcInputVoltageSpec=20;
      let wchBatteriesReplaced=20;
      let wchBusinessPartnerRestriction=20;
      let wchCity=20;
      let wchCommunityName=20;
      //let wchControllerCardType=20;
      let wchCurrentAmpOutputUsed=20;
      let wchEgisName=20;
      let wchFeedsMultipleNodes=20;
      let wchHeadendName=20;
      let wchHouseNumber=20;
      let wchMacAddress=20;
      let wchMapNumber=20;
      let wchNextGenNode=20;
      let wchNitroCompletionDate=20;
      let wchNode=20;
      let wchOutputVoltageSpec=20;
      let wchPoleNumber=20;
      let wchPowerSupplyId=20;
      let wchBillingCodes=30;
      let wchmaterialBillingCodes = 30;
      let wchPowerSupplyModel=20;
      let wchPowerSupplyNumber=20;
      let wchPowerSupplyType9360=20;
      let wchState=20;
      let wchnwtTeam=20;
      let wchTransponderModel=20;
      let wchZipCode=20;
      let wchAcIndicatorGreenLight=20;
      let wchAerialUnderground=20;
      let wchAlertLevel=20;
      let wchApuBatteryConductance=20;
      let wchApuBatteryConductanceCorrected=24;
      let wchApuBatteryDateCode=20;
      let wchApuBatteryManufacturerType=21;
      let wchApuBatteryTerminalsCleaned=21;
      let wchApuBatteryTorque=20;
      let wchApuBatteryVoltageNoLoad=20;
      let wchApuChargerCurrentAmps=20;
      let wchApuCompletedBy=20;
      let wchApuDeviceId=20;
      let wchApuEnclosureMake=20;
      let wchApuFrequency=20;
      let wchApuLoadVoltage=20;
      let wchApuMakeModel=20;
      let wchApuNoLoadVoltage=20;
      let wchApuOutputVoltageRating=20;
      let wchApuRunTime=20;
      let wchApuSerialNumber=20;
      let wchApuStarterBatteryChrgrVlt=20;
      let wchApuTestRun=20;
      let wchApuVisitComments=20;
      let wchBatteryBalancerString=25;
      let wchBatteryHeaterMatQuantity=20;
      let wchBatteryHeaterMatType=20;
      let wchBatteryString1Fused=20;
      let wchBatteryString2Fused=20;
      let wchBatteryString3Fused=20;
      let wchBatteryString4Fused=20;
      let wchBootFile=27;
      let wchBootr=20;
      let wchCabinetBatteryCapacity=20;
      let wchCabinetLocked=20;
      let wchCabinetVendor=20;
      let wchChangeCleanEnclosureAirFilter=22;
      let wchCheckForGasLeaks=20;
      let wchCheckForRodentDamage=20;
      let wchCheckGroundCabinet=20;
      let wchCheckLampsLed=20;
      let wchCheckLampsLeds=20;
      let wchCheckLaps=20;
      let wchCheckMagneticBreaker=20;
      let wchCheckOilLevel=20;
      let wchCheckOperatingLights=20;
      let wchCheckRegroutPadConduit=20;
      let wchCheckSeizureAltBox=20;
      let wchCleanEnclosure=20;
      let wchCleanUpGarbage=20;
      let wchClearApuEventLog=20;
      let wchClearWeeds=20;
      let wchCoaxTvssPresent=20;
      let wchCommTech=20;
      let wchCompanyAccountNumber=20;
      let wchConfigFile=25;
      let wchCrossStreet=20;
      let wchCurrentAmpRatingSpec=20;
      let wchEcmAcm=20;
      let wchElectricMeterNumber=20;
      let wchEnclosureDamageVandalism=20;
      let wchEnclosureSnowShield=20;
      let wchcalculatedRuntime=20;
      let wchFollowUpActionNeeded=20;
      let wchFollowUpNeeded=20;
      let wchFollowUpReason=20;
      let wchGasMeterNumber=20;
      let wchGasMeterReading=20;
      let wchGeneratorDcBusFunction=20;
      let wchGpsLatitude=20;
      let wchGpsLongitude=20;
      let wchGroundMountPadUndermining=21;
      let wchHierarchyPathLabels=50;
      let wchHwRev=20;
      let wchInputSurgeArrestor=20;
      let wchInspectConnectors=20;
      let wchInspectGeneratorAirFilter=20;
      let wchInspectProbes=20;
      let wchInspectSparkPlug=20;
      let wchInspectionDate=20;
      let wchInstallDate11=20;
      let wchInstallDate12=20;
      let wchInstallDate13=20;
      let wchInstallDate14=20;
      let wchInstallDate21=20;
      let wchInstallDate22=20;
      let wchInstallDate23=20;
      let wchInstallDate24=20;
      let wchInstallDate31=20;
      let wchInstallDate32=20;
      let wchInstallDate33=20;
      let wchInstallDate34=20;
      let wchInstallDate41=20;
      let wchInstallDate42=20;
      let wchInstallDate43=20;
      let wchInstallDate44=20;
      let wchInstallDate51=20;
      let wchInstallDate52=20;
      let wchInstallDate53=20;
      let wchInstallDate54=20;
      let wchInstallDate61=20;
      let wchInstallDate62=20;
      let wchInstallDate63=20;
      let wchInstallDate64=20;
      let wchInternalBreaker=20;
      let wchIp=20;
      let wchLocalRemoteIndicator=20;
      let wchLpTankCapacity=20;
      let wchMacAddressPrevious=20;
      let wchMeterPanCondition=20;
      let wchNcpCmts=33;
      let wchNgLp=20;
      let wchNgPressure=20;
      let wchNgProvider=20;
      let wchNitroReasonNotCompleted=20;
      let wchNumberOfBatteries=20;
      let wchNumberTanksInstalled=20;
      let wchOilAddedAmount=20;
      let wchOilFilterTight=20;
      let wchOutputSurgeArrestor=20;
      let wchPowerAccountType=20;
      let wchPowerCoRiserCondition=20;
      let wchPowerSupplyAddress=30;
      let wchPowerSupplyIdLegible=20;
      let wchPowerSupplyName=20;
      let wchPowerSupplyType=20;
      let wchPowersNode=20;
      let wchPsAlertProfile=20;
      let wchPsCertificationId=20;
      let wchReceptacleType=20;
      let wchRecordAsFoundAlarms=20;
      let wchRemoteStandbyOperation2=20;
      let wchRemoteStandbyOperation3=20;
      let wchRemoteStandbyOperation4=20;
      let wchRemoteStandbyOperation5=20;
      let wchSecurityBarPresent=20;
      let wchServiceEntrance=20;
      let wchShowActualLocation=20;
      let wchSpecialLocationDetails=20;
      let wchStandByOperation=20;
      let wchString1Battery1DateCode=20;
      let wchString1Battery2DateCode=20;
      let wchString1Battery3DateCode=20;
      let wchString1Battery4DateCode=20;
      let wchString2Battery1DateCode=20;
      let wchString2Battery2DateCode=20;
      let wchString2Battery3DateCode=20;
      let wchString2Battery4DateCode=20;
      let wchString3Battery1DateCode=20;
      let wchString3Battery2DateCode=20;
      let wchString3Battery3DateCode=20;
      let wchString3Battery4DateCode=20;
      let wchString4Battery1DateCode=20;
      let wchString4Battery2DateCode=20;
      let wchString4Battery3DateCode=20;
      let wchString4Battery4DateCode=20;
      let wchString5Battery1DateCode=20;
      let wchString5Battery2DateCode=20;
      let wchString5Battery3DateCode=20;
      let wchString5Battery4DateCode=20;
      let wchString6Battery1DateCode=20;
      let wchString6Battery2DateCode=20;
      let wchString6Battery3DateCode=20;
      let wchString6Battery4DateCode=20;
      let wchSubmittedBy=20;
      let wchSwRev=28;
      let wchSysDescr=105;
      let wchSysName=20;
      let wchTamperInstalledFunctioning=20;
      let wchTankOneLevel=20;
      let wchTankTwoLevel=20;
      let wchTechnicianName=20;
      let wchTechnicianNtUsername=20;
      let wchTechnicianNumber=20;
      let wchTemperatures=20;
      let wchTestCombustibleGasAlarm=20;
      let wchTestHighTempAlarm=20;
      let wchTestOilPressureAlarm=20;
      let wchTestPadShearAlarm=20;
      let wchTestTamperAlarm=20;
      let wchTestWaterIntrusionAlarm=20;
      let wchTightenHardware=20;
      let wchTransponderVendor=20;
      let wchType11=20;
      let wchType12=20;
      let wchType13=20;
      let wchType14=20;
      let wchType21=20;
      let wchType22=20;
      let wchType23=20;
      let wchType24=20;
      let wchType31=20;
      let wchType32=20;
      let wchType33=20;
      let wchType34=20;
      let wchType41=20;
      let wchType42=20;
      let wchType43=20;
      let wchType44=20;
      let wchType51=20;
      let wchType52=20;
      let wchType53=20;
      let wchType54=20;
      let wchType61=20;
      let wchType62=20;
      let wchType63=20;
      let wchType64=20;
      let wchTypeOfVisit=20;
      let wchUtilityProvider=20;
      let wchVisitStatus=20;
      let wchVisualCabinetInspection=20;
      let wchVoltage11=20;
      let wchVoltage12=20;
      let wchVoltage13=20;
      let wchVoltage14=20;
      let wchVoltage21=20;
      let wchVoltage22=20;
      let wchVoltage23=20;
      let wchVoltage24=20;
      let wchVoltage31=20;
      let wchVoltage32=20;
      let wchVoltage33=20;
      let wchVoltage34=20;
      let wchVoltage41=20;
      let wchVoltage42=20;
      let wchVoltage43=20;
      let wchVoltage44=20;
      let wchVoltage51=20;
      let wchVoltage52=20;
      let wchVoltage53=20;
      let wchVoltage54=20;
      let wchVoltage61=20;
      let wchVoltage62=20;
      let wchVoltage63=20;
      let wchVoltage64=20;
      let wchXocVerified=20;
     let wchtaskType=20;
     let wchjobStatus=20;
     let wchendDate=20;
     let wchcertificationDate=20;
     let wchdateApuInstalled=20;
     let wchdateEntered=20;
     let wchapuBatteryInstallDate=20;
     let wchbatteryReplacementDate=20;
     let wchjobId=14;
     let wchjbCreation = 20;
     let wchcreateDate=20;
     let wchphotoUploadedDate=20;
     let wchteamName=25;
     let wchphotouploadeddate=33;

     let wchbilling = 20;

      return [
        { header: 'Job ID', key: 'jobId', width: wchjobId },
        { header: 'JB Creation type', key: 'jbCreationType', width: wchjbCreation },
        { header: 'PowerSupplyId', key: 'powerSupplyId',width:wchPowerSupplyId},
        { header: 'Job Status',key:'jobStatus',width:wchjobStatus},
        { header: 'Task Type',key:'taskType',width:wchtaskType},
        { header: 'Team Name',key:'teamName',width:wchteamName},
        { header: 'Created Date',key:'createDateValue',width:wchcreateDate},
        { header: 'End Date',key:'endDateValue',width:wchendDate},
        { header: 'PsCertificationId',key: 'psCertificationId',width:wchPsCertificationId},
        { header: 'certificationDate',key:'certificationDate',width:wchcertificationDate},
        // { header: 'Billing Codes',key:'billingCodes',width:wchBillingCodes},
        // { header: 'Material Codes',key:'materialBillingCodes',width:wchmaterialBillingCodes},
        { header: 'HeadendName', key: 'headendName',width:wchHeadendName},
        { header: 'CommunityName', key: 'communityName',width:wchCommunityName},
        { header: 'Node Name', key: 'node',width:wchNode},
        { header: 'Hierarchy Path',key: 'hierarchyPathLabels',width:wchHierarchyPathLabels},
        { header: 'PowerSupplyName',key: 'powerSupplyName',width:wchPowerSupplyName},
        { header: 'Ip Address',key: 'ip',width:wchIp},
        { header: 'MacAddress', key: 'macAddress',width:wchMacAddress},
        { header: 'Previous MacAddress',key: 'macAddressPrevious',width:wchMacAddressPrevious},
        { header: 'CMTS',key: 'ncpCmts',width:wchNcpCmts},
        { header: 'HouseNumber', key: 'houseNumber',width:wchHouseNumber},
        { header: 'PowerSupply Address',key: 'powerSupplyAddress',width:wchPowerSupplyAddress},
        { header: 'CrossStreet',key: 'crossStreet',width:wchCrossStreet},
        { header: 'City', key: 'city',width:wchCity},
        { header: 'State', key: 'state',width:wchState},
        { header: 'ZipCode', key: 'zipCode',width:wchZipCode},
        { header: 'FeedsMultipleNodes', key: 'feedsMultipleNodes',width:wchFeedsMultipleNodes},
        { header: 'Gps Latitude',key: 'gpsLatitude',width:wchGpsLatitude},
        { header: 'Gps Longitude',key: 'gpsLongitude',width:wchGpsLongitude},
        { header: 'Calculated Runtime(in Minutes)',key: 'calculatedRuntime',width:wchcalculatedRuntime},
        { header: 'PowersNode',key: 'powersNode',width:wchPowersNode},
        { header: 'SpecialLocationDetails',key: 'specialLocationDetails',width:wchSpecialLocationDetails},
        { header: 'ShowActualLocation',key: 'showActualLocation',width:wchShowActualLocation},
        { header: 'AerialUnderground',key: 'aerialUnderground',width:wchAerialUnderground},
        { header: 'Pole Number', key: 'poleNumber',width:wchPoleNumber},
        { header: 'PowerCompany',key: 'utilityProvider',width:wchUtilityProvider},
        { header: 'CompanyAccountNumber',key: 'companyAccountNumber',width:wchCompanyAccountNumber},

        { header: 'NWTTeam', key: 'nwtTeam',width:wchnwtTeam},

        { header: 'NitroCompletionDate', key: 'nitroCompletionDate',width:wchNitroCompletionDate},
        { header: 'PowerAccountType',key: 'powerAccountType',width:wchPowerAccountType},
        { header: 'Meter#',key: 'electricMeterNumber',width:wchElectricMeterNumber},
        { header: 'MapNumber', key: 'mapNumber',width:wchMapNumber},
        { header: 'BusinessPartnerRestriction', key: 'businessPartnerRestriction',width:wchBusinessPartnerRestriction},

        { header: 'PowerSupplyType',key: 'powerSupplyType',width:wchPowerSupplyType},
        { header: 'PowerSupply Number', key: 'powerSupplyNumber',width:wchPowerSupplyNumber},
        { header: 'NextGenNode', key: 'nextGenNode',width:wchNextGenNode},
        { header: 'TransponderVendor',key: 'transponderVendor',width:wchTransponderVendor},
        { header: 'TransponderModel', key: 'transponderModel',width:wchTransponderModel},
        { header: 'PowerSupplyModel', key: 'powerSupplyModel',width:wchPowerSupplyModel},
        { header: 'PowerSupplyType9360', key: 'powerSupplyType9360',width:wchPowerSupplyType9360},
        { header: 'AcInputVoltageSpec', key: 'acInputVoltageSpec',width:wchAcInputVoltageSpec},
        { header: 'OutputVoltageSpec', key: 'outputVoltageSpec',width:wchOutputVoltageSpec},
        { header: 'CurrentAmpRatingSpec',key: 'currentAmpRatingSpec',width:wchCurrentAmpRatingSpec},
        { header: 'CurrentAmpOutputUsed', key: 'currentAmpOutputUsed',width:wchCurrentAmpOutputUsed},
        { header: 'PsAlertProfile',key: 'psAlertProfile',width:wchPsAlertProfile},
        // { header: 'ControllerCardType', key: 'controllerCardType',width:wchControllerCardType},
        { header: 'EgisName', key: 'egisName',width:wchEgisName},
        { header: 'SubmittedBy',key: 'submittedBy',width:wchSubmittedBy},

        { header: 'NumberOfBatteries',key: 'numberOfBatteries',width:wchNumberOfBatteries},
        { header: 'BatteriesReplaced', key: 'batteriesReplaced',width:wchBatteriesReplaced},
        { header: 'batteryReplacementDate',key:'batteryReplacementDate',width:wchbatteryReplacementDate},
        { header: 'Temperatures',key: 'temperatures',width:wchTemperatures},
        { header: 'BatteryBalancerString',key: 'batteryBalancerString',width:wchBatteryBalancerString},
        { header: 'Manufacturer Type11',key: 'type11',width:wchType11},
        { header: 'Manufacturer Type12',key: 'type12',width:wchType12},
        { header: 'Manufacturer Type13',key: 'type13',width:wchType13},
        { header: 'Manufacturer Type14',key: 'type14',width:wchType14},
        { header: 'Manufacturer Type21',key: 'type21',width:wchType21},
        { header: 'Manufacturer Type22',key: 'type22',width:wchType22},
        { header: 'Manufacturer Type23',key: 'type23',width:wchType23},
        { header: 'Manufacturer Type24',key: 'type24',width:wchType24},
        { header: 'Manufacturer Type31',key: 'type31',width:wchType31},
        { header: 'Manufacturer Type32',key: 'type32',width:wchType32},
        { header: 'Manufacturer Type33',key: 'type33',width:wchType33},
        { header: 'Manufacturer Type34',key: 'type34',width:wchType34},
        { header: 'Manufacturer Type41',key: 'type41',width:wchType41},
        { header: 'Manufacturer Type42',key: 'type42',width:wchType42},
        { header: 'Manufacturer Type43',key: 'type43',width:wchType43},
        { header: 'Manufacturer Type44',key: 'type44',width:wchType44},
        { header: 'Manufacturer Type51',key: 'type51',width:wchType51},
        { header: 'Manufacturer Type52',key: 'type52',width:wchType52},
        { header: 'Manufacturer Type53',key: 'type53',width:wchType53},
        { header: 'Manufacturer Type54',key: 'type54',width:wchType54},
        { header: 'Manufacturer Type61',key: 'type61',width:wchType61},
        { header: 'Manufacturer Type62',key: 'type62',width:wchType62},
        { header: 'Manufacturer Type63',key: 'type63',width:wchType63},
        { header: 'Manufacturer Type64',key: 'type64',width:wchType64},
        { header: 'String1Battery1DateCode',key: 'string1Battery1DateCode',width:wchString1Battery1DateCode},
        { header: 'String1Battery2DateCode',key: 'string1Battery2DateCode',width:wchString1Battery2DateCode},
        { header: 'String1Battery3DateCode',key: 'string1Battery3DateCode',width:wchString1Battery3DateCode},
        { header: 'String1Battery4DateCode',key: 'string1Battery4DateCode',width:wchString1Battery4DateCode},
        { header: 'String2Battery1DateCode',key: 'string2Battery1DateCode',width:wchString2Battery1DateCode},
        { header: 'String2Battery2DateCode',key: 'string2Battery2DateCode',width:wchString2Battery2DateCode},
        { header: 'String2Battery3DateCode',key: 'string2Battery3DateCode',width:wchString2Battery3DateCode},
        { header: 'String2Battery4DateCode',key: 'string2Battery4DateCode',width:wchString2Battery4DateCode},
        { header: 'String3Battery1DateCode',key: 'string3Battery1DateCode',width:wchString3Battery1DateCode},
        { header: 'String3Battery2DateCode',key: 'string3Battery2DateCode',width:wchString3Battery2DateCode},
        { header: 'String3Battery3DateCode',key: 'string3Battery3DateCode',width:wchString3Battery3DateCode},
        { header: 'String3Battery4DateCode',key: 'string3Battery4DateCode',width:wchString3Battery4DateCode},
        { header: 'String4Battery1DateCode',key: 'string4Battery1DateCode',width:wchString4Battery1DateCode},
        { header: 'String4Battery2DateCode',key: 'string4Battery2DateCode',width:wchString4Battery2DateCode},
        { header: 'String4Battery3DateCode',key: 'string4Battery3DateCode',width:wchString4Battery3DateCode},
        { header: 'String4Battery4DateCode',key: 'string4Battery4DateCode',width:wchString4Battery4DateCode},
        { header: 'String5Battery1DateCode',key: 'string5Battery1DateCode',width:wchString5Battery1DateCode},
        { header: 'String5Battery2DateCode',key: 'string5Battery2DateCode',width:wchString5Battery2DateCode},
        { header: 'String5Battery3DateCode',key: 'string5Battery3DateCode',width:wchString5Battery3DateCode},
        { header: 'String5Battery4DateCode',key: 'string5Battery4DateCode',width:wchString5Battery4DateCode},
        { header: 'String6Battery1DateCode',key: 'string6Battery1DateCode',width:wchString6Battery1DateCode},
        { header: 'String6Battery2DateCode',key: 'string6Battery2DateCode',width:wchString6Battery2DateCode},
        { header: 'String6Battery3DateCode',key: 'string6Battery3DateCode',width:wchString6Battery3DateCode},
        { header: 'String6Battery4DateCode',key: 'string6Battery4DateCode',width:wchString6Battery4DateCode},
        { header: 'InstallDate11',key: 'installDate11',width:wchInstallDate11},
        { header: 'InstallDate12',key: 'installDate12',width:wchInstallDate12},
        { header: 'InstallDate13',key: 'installDate13',width:wchInstallDate13},
        { header: 'InstallDate14',key: 'installDate14',width:wchInstallDate14},
        { header: 'InstallDate21',key: 'installDate21',width:wchInstallDate21},
        { header: 'InstallDate22',key: 'installDate22',width:wchInstallDate22},
        { header: 'InstallDate23',key: 'installDate23',width:wchInstallDate23},
        { header: 'InstallDate24',key: 'installDate24',width:wchInstallDate24},
        { header: 'InstallDate31',key: 'installDate31',width:wchInstallDate31},
        { header: 'InstallDate32',key: 'installDate32',width:wchInstallDate32},
        { header: 'InstallDate33',key: 'installDate33',width:wchInstallDate33},
        { header: 'InstallDate34',key: 'installDate34',width:wchInstallDate34},
        { header: 'InstallDate41',key: 'installDate41',width:wchInstallDate41},
        { header: 'InstallDate42',key: 'installDate42',width:wchInstallDate42},
        { header: 'InstallDate43',key: 'installDate43',width:wchInstallDate43},
        { header: 'InstallDate44',key: 'installDate44',width:wchInstallDate44},
        { header: 'InstallDate51',key: 'installDate51',width:wchInstallDate51},
        { header: 'InstallDate52',key: 'installDate52',width:wchInstallDate52},
        { header: 'InstallDate53',key: 'installDate53',width:wchInstallDate53},
        { header: 'InstallDate54',key: 'installDate54',width:wchInstallDate54},
        { header: 'InstallDate61',key: 'installDate61',width:wchInstallDate61},
        { header: 'InstallDate62',key: 'installDate62',width:wchInstallDate62},
        { header: 'InstallDate63',key: 'installDate63',width:wchInstallDate63},
        { header: 'InstallDate64',key: 'installDate64',width:wchInstallDate64},
        { header: 'Voltage11',key: 'voltage11',width:wchVoltage11},
        { header: 'Voltage12',key: 'voltage12',width:wchVoltage12},
        { header: 'Voltage13',key: 'voltage13',width:wchVoltage13},
        { header: 'Voltage14',key: 'voltage14',width:wchVoltage14},
        { header: 'Voltage21',key: 'voltage21',width:wchVoltage21},
        { header: 'Voltage22',key: 'voltage22',width:wchVoltage22},
        { header: 'Voltage23',key: 'voltage23',width:wchVoltage23},
        { header: 'Voltage24',key: 'voltage24',width:wchVoltage24},
        { header: 'Voltage31',key: 'voltage31',width:wchVoltage31},
        { header: 'Voltage32',key: 'voltage32',width:wchVoltage32},
        { header: 'Voltage33',key: 'voltage33',width:wchVoltage33},
        { header: 'Voltage34',key: 'voltage34',width:wchVoltage34},
        { header: 'Voltage41',key: 'voltage41',width:wchVoltage41},
        { header: 'Voltage42',key: 'voltage42',width:wchVoltage42},
        { header: 'Voltage43',key: 'voltage43',width:wchVoltage43},
        { header: 'Voltage44',key: 'voltage44',width:wchVoltage44},
        { header: 'Voltage51',key: 'voltage51',width:wchVoltage51},
        { header: 'Voltage52',key: 'voltage52',width:wchVoltage52},
        { header: 'Voltage53',key: 'voltage53',width:wchVoltage53},
        { header: 'Voltage54',key: 'voltage54',width:wchVoltage54},
        { header: 'Voltage61',key: 'voltage61',width:wchVoltage61},
        { header: 'Voltage62',key: 'voltage62',width:wchVoltage62},
        { header: 'Voltage63',key: 'voltage63',width:wchVoltage63},
        { header: 'Voltage64',key: 'voltage64',width:wchVoltage64},

        { header: 'ApuMakeModel',key: 'apuMakeModel',width:wchApuMakeModel},
        { header: 'ApuSerialNumber',key: 'apuSerialNumber',width:wchApuSerialNumber},
        { header: 'ApuDeviceId',key: 'apuDeviceId',width:wchApuDeviceId},
        { header: 'ApuRunTime',key: 'apuRunTime',width:wchApuRunTime},
        { header: 'EcmAcm',key: 'ecmAcm',width:wchEcmAcm},
        { header: 'dateApuInstalled',key:'dateApuInstalled',width:wchdateApuInstalled},
        { header: 'ApuOutputVoltageRating',key: 'apuOutputVoltageRating',width:wchApuOutputVoltageRating},
        { header: 'ApuNoLoadVoltage',key: 'apuNoLoadVoltage',width:wchApuNoLoadVoltage},
        { header: 'ApuLoadVoltage',key: 'apuLoadVoltage',width:wchApuLoadVoltage},
        { header: 'ApuEnclosureMake',key: 'apuEnclosureMake',width:wchApuEnclosureMake},
        { header: 'NgLp',key: 'ngLp',width:wchNgLp},
        { header: 'NgProvider',key: 'ngProvider',width:wchNgProvider},
        { header: 'LpTankCapacity',key: 'lpTankCapacity',width:wchLpTankCapacity},
        { header: 'NumberTanksInstalled',key: 'numberTanksInstalled',width:wchNumberTanksInstalled},

        { header: 'ApuCompletedBy',key: 'apuCompletedBy',width:wchApuCompletedBy},
        { header: 'ApuBatteryManufacturerType',key: 'apuBatteryManufacturerType',width:wchApuBatteryManufacturerType},
        { header: 'ApuBatteryDateCode',key: 'apuBatteryDateCode',width:wchApuBatteryDateCode},
        { header: 'ApuBatteryInstallDate',key:'apuBatteryInstallDate',width:wchapuBatteryInstallDate},
        { header: 'ApuBatteryVoltageNoLoad',key: 'apuBatteryVoltageNoLoad',width:wchApuBatteryVoltageNoLoad},
        { header: 'ApuBatteryConductance',key: 'apuBatteryConductance',width:wchApuBatteryConductance},
        { header: 'ApuBatteryConductanceCorrected',key: 'apuBatteryConductanceCorrected',width:wchApuBatteryConductanceCorrected},
        { header: 'ApuBatteryTorque',key: 'apuBatteryTorque',width:wchApuBatteryTorque},
        { header: 'ApuBatteryTerminalsCleaned',key: 'apuBatteryTerminalsCleaned',width:wchApuBatteryTerminalsCleaned},
        { header: 'ApuStarterBatteryChrgrVlt',key: 'apuStarterBatteryChrgrVlt',width:wchApuStarterBatteryChrgrVlt},
        { header: 'ApuChargerCurrentAmps',key: 'apuChargerCurrentAmps',width:wchApuChargerCurrentAmps},
        { header: 'FollowUpActionNeeded',key: 'followUpActionNeeded',width:wchFollowUpActionNeeded},
        { header: 'RecordAsFoundAlarms',key: 'recordAsFoundAlarms',width:wchRecordAsFoundAlarms},
        { header: 'ApuTestRun',key: 'apuTestRun',width:wchApuTestRun},
        { header: 'CheckOilLevel',key: 'checkOilLevel',width:wchCheckOilLevel},
        { header: 'OilAddedAmount',key: 'oilAddedAmount',width:wchOilAddedAmount},
        { header: 'OilFilterTight',key: 'oilFilterTight',width:wchOilFilterTight},
        { header: 'InspectGeneratorAirFilter',key: 'inspectGeneratorAirFilter',width:wchInspectGeneratorAirFilter},
        { header: 'InspectSparkPlug',key: 'inspectSparkPlug',width:wchInspectSparkPlug},
        { header: 'ClearApuEventLog',key: 'clearApuEventLog',width:wchClearApuEventLog},
        { header: 'ApuFrequency',key: 'apuFrequency',width:wchApuFrequency},
        { header: 'TankOneLevel',key: 'tankOneLevel',width:wchTankOneLevel},
        { header: 'TankTwoLevel',key: 'tankTwoLevel',width:wchTankTwoLevel},
        { header: 'GasMeterNumber',key: 'gasMeterNumber',width:wchGasMeterNumber},
        { header: 'GasMeterReading',key: 'gasMeterReading',width:wchGasMeterReading},
        { header: 'NgPressure',key: 'ngPressure',width:wchNgPressure},
        { header: 'ChangeCleanEnclosureAirFilter',key: 'changeCleanEnclosureAirFilter',width:wchChangeCleanEnclosureAirFilter},
        { header: 'CheckForRodentDamage',key: 'checkForRodentDamage',width:wchCheckForRodentDamage},
        { header: 'CheckLampsLed',key: 'checkLampsLed',width:wchCheckLampsLed},
        { header: 'ClearWeeds',key: 'clearWeeds',width:wchClearWeeds},
        { header: 'CheckRegroutPadConduit',key: 'checkRegroutPadConduit',width:wchCheckRegroutPadConduit},
        { header: 'GroundMountPadUndermining',key: 'groundMountPadUndermining',width:wchGroundMountPadUndermining},
        { header: 'EnclosureDamageVandalism',key: 'enclosureDamageVandalism',width:wchEnclosureDamageVandalism},
        { header: 'CleanUpGarbage',key: 'cleanUpGarbage',width:wchCleanUpGarbage},
        { header: 'TestOilPressureAlarm',key: 'testOilPressureAlarm',width:wchTestOilPressureAlarm},
        { header: 'TestHighTempAlarm',key: 'testHighTempAlarm',width:wchTestHighTempAlarm},
        { header: 'GeneratorDcBusFunction',key: 'generatorDcBusFunction',width:wchGeneratorDcBusFunction},
        { header: 'CheckForGasLeaks',key: 'checkForGasLeaks',width:wchCheckForGasLeaks},
        { header: 'TestCombustibleGasAlarm',key: 'testCombustibleGasAlarm',width:wchTestCombustibleGasAlarm},
        { header: 'TestTamperAlarm',key: 'testTamperAlarm',width:wchTestTamperAlarm},
        { header: 'TestWaterIntrusionAlarm',key: 'testWaterIntrusionAlarm',width:wchTestWaterIntrusionAlarm},
        { header: 'TestPadShearAlarm',key: 'testPadShearAlarm',width:wchTestPadShearAlarm},
        { header: 'ApuVisitComments',key: 'apuVisitComments',width:wchApuVisitComments},

        { header: 'InspectionDate',key: 'inspectionDate',width:wchInspectionDate},
        { header: 'TypeOfVisit',key: 'typeOfVisit',width:wchTypeOfVisit},
        { header: 'VisitStatus',key: 'visitStatus',width:wchVisitStatus},
        { header: 'FollowUpReason',key: 'followUpReason',width:wchFollowUpReason},
        { header: 'XocVerified',key: 'xocVerified',width:wchXocVerified},
        { header: 'CleanEnclosure',key: 'cleanEnclosure',width:wchCleanEnclosure},
        { header: 'TightenHardware',key: 'tightenHardware',width:wchTightenHardware},
        { header: 'InspectConnectors',key: 'inspectConnectors',width:wchInspectConnectors},
        { header: 'InspectProbes',key: 'inspectProbes',width:wchInspectProbes},
        { header: 'MeterPanCondition',key: 'meterPanCondition',width:wchMeterPanCondition},
        { header: 'PowerCoRiserCondition',key: 'powerCoRiserCondition',width:wchPowerCoRiserCondition},
        { header: 'BatteryHeaterMatType',key: 'batteryHeaterMatType',width:wchBatteryHeaterMatType},
        { header: 'BatteryHeaterMatQuantity',key: 'batteryHeaterMatQuantity',width:wchBatteryHeaterMatQuantity},
        { header: 'EnclosureSnowShield',key: 'enclosureSnowShield',width:wchEnclosureSnowShield},
        { header: 'InternalBreaker',key: 'internalBreaker',width:wchInternalBreaker},
        { header: 'ServiceEntrance',key: 'serviceEntrance',width:wchServiceEntrance},
        { header: 'ReceptacleType',key: 'receptacleType',width:wchReceptacleType},
        { header: 'CheckSeizureAltBox',key: 'checkSeizureAltBox',width:wchCheckSeizureAltBox},
        { header: 'PowerSupplyIdLegible',key: 'powerSupplyIdLegible',width:wchPowerSupplyIdLegible},
        { header: 'CheckLampsLeds',key: 'checkLampsLeds',width:wchCheckLampsLeds},
        { header: 'CheckMagneticBreaker',key: 'checkMagneticBreaker',width:wchCheckMagneticBreaker},
        { header: 'VisualCabinetInspection',key: 'visualCabinetInspection',width:wchVisualCabinetInspection},
        { header: 'CabinetLocked',key: 'cabinetLocked',width:wchCabinetLocked},
        { header: 'SecurityBarPresent',key: 'securityBarPresent',width:wchSecurityBarPresent},
        { header: 'CheckGroundCabinet',key: 'checkGroundCabinet',width:wchCheckGroundCabinet},
        { header: 'BatteryString1Fused',key: 'batteryString1Fused',width:wchBatteryString1Fused},
        { header: 'BatteryString2Fused',key: 'batteryString2Fused',width:wchBatteryString2Fused},
        { header: 'BatteryString3Fused',key: 'batteryString3Fused',width:wchBatteryString3Fused},
        { header: 'BatteryString4Fused',key: 'batteryString4Fused',width:wchBatteryString4Fused},
        { header: 'TamperInstalledFunctioning',key: 'tamperInstalledFunctioning',width:wchTamperInstalledFunctioning},
        { header: 'CheckLaps',key: 'checkLaps',width:wchCheckLaps},
        { header: 'CabinetVendor',key: 'cabinetVendor',width:wchCabinetVendor},
        { header: 'CabinetBatteryCapacity',key: 'cabinetBatteryCapacity',width:wchCabinetBatteryCapacity},
        { header: 'CheckOperatingLights',key: 'checkOperatingLights',width:wchCheckOperatingLights},
        { header: 'FollowUpNeeded',key: 'followUpNeeded',width:wchFollowUpNeeded},
        { header: 'InputSurgeArrestor',key: 'inputSurgeArrestor',width:wchInputSurgeArrestor},
        { header: 'OutputSurgeArrestor',key: 'outputSurgeArrestor',width:wchOutputSurgeArrestor},
        { header: 'CoaxTvssPresent',key: 'coaxTvssPresent',width:wchCoaxTvssPresent},
        { header: 'AcIndicatorGreenLight',key: 'acIndicatorGreenLight',width:wchAcIndicatorGreenLight},
        { header: 'LocalRemoteIndicator',key: 'localRemoteIndicator',width:wchLocalRemoteIndicator},
        { header: 'CommTech',key: 'commTech',width:wchCommTech},
        { header: 'TechnicianNtUsername',key: 'technicianNtUsername',width:wchTechnicianNtUsername},
        { header: 'StandByOperation',key: 'standByOperation',width:wchStandByOperation},
        { header: 'RemoteStandbyOperation2',key: 'remoteStandbyOperation2',width:wchRemoteStandbyOperation2},
        { header: 'RemoteStandbyOperation3',key: 'remoteStandbyOperation3',width:wchRemoteStandbyOperation3},
        { header: 'RemoteStandbyOperation4',key: 'remoteStandbyOperation4',width:wchRemoteStandbyOperation4},
        { header: 'RemoteStandbyOperation5',key: 'remoteStandbyOperation5',width:wchRemoteStandbyOperation5},

        //Photos
        { header: '1. 25’ away from PS showing general surroundings of PS', key: 'catDate1',width: wchphotouploadeddate },
        { header: '2. Before maintenance starts, show open door view of PS and all batteries	', key: 'catDate2',width: wchphotouploadeddate },
        { header: '3. Picture of PS display of MAC', key: 'catDate3',width: wchphotouploadeddate },
        { header: '4. If no display is available or it’s an External Transponder, picture of sticker', key: 'catDate4',width: wchphotouploadeddate},
        { header: '5. Picture of string of batteries that shows separation, wiring and Temp probe', key: 'catDate5',width: wchphotouploadeddate },
        { header: '6. Battery date stamp', key: 'catDate6',width: wchphotouploadeddate },
        { header: '7. Coaxial ground block in PS cabinet to include input RF', key: 'catDate7',width: wchphotouploadeddate },
        { header: '8. PS ground', key: 'catDate8',width: wchphotouploadeddate },
        { header: '9. Commercial power outlet showing LAP and PS connector', key: 'catDate9',width: wchphotouploadeddate },
        { header: '10. Repeat step 2 after work is completed', key: 'catDate10',width: wchphotouploadeddate },
        { header: '11. Power Company Electric Meter', key: 'catDate11',width: wchphotouploadeddate },

        { header: 'Alert Level',key: 'alertLevel',width:wchAlertLevel},

        { header: 'TechnicianName',key: 'technicianName',width:wchTechnicianName},
        { header: 'TechnicianNumber',key: 'technicianNumber',width:wchTechnicianNumber},

        { header: 'SysDescr',key: 'sysDescr',width:wchSysDescr},
        { header: 'Bootr',key: 'bootr',width:wchBootr},
        { header: 'ConfigFile',key: 'configFile',width:wchConfigFile},
        { header: 'HwRev',key: 'hwRev',width:wchHwRev},
        { header: 'SwRev',key: 'swRev',width:wchSwRev},
        { header: 'BootFile',key: 'bootFile',width:wchBootFile},
        { header: 'SysName',key: 'sysName',width:wchSysName},
        { header: 'dateEntered',key:'dateEntered',width:wchdateEntered},

        //Adding workitem and material items
        { header: 'BPS1: Repair/Replace Pole Mounted Power Supply',key:'billingCodes1',width:wchbilling},
        { header: 'BPS2: Repair/Replace Ground Mounted Power Supply',key:'billingCodes2',width:wchbilling},
        { header: 'BPS3: Wreck Out Old Aerial Power Supply',key:'billingCodes3',width:wchbilling},
        { header: 'BPS4: Wreck Out Old UG Power Supply',key:'billingCodes4',width:wchbilling},
        { header: 'BPS5: Replace Active Power Supply Batteries',key:'billingCodes5',width:wchbilling},
        { header: 'BPS6: Replace Active Power Supply Module',key:'billingCodes6',width:wchbilling},
        { header: 'BPS7: Re-Powering Coax Plant',key:'billingCodes7',width:wchbilling},
        { header: 'BPSE8: Composite full PM of Power Supply Location – no component change',key:'billingCodes8',width:wchbilling},
        { header: 'BPSC9: Composite full PM of Power Supply Location – with component change',key:'billingCodes9',width:wchbilling},
        { header: 'BPSE10: Hourly Rate',key:'billingCodes10',width:wchbilling},
        { header: 'BPSE11: Emergency/Storm Support Hourly Rate',key:'billingCodes11',width:wchbilling},
        { header: 'BPSE12: No Locate/Trip Charge (Return to Complete) (Requires Comcast approval)',key:'billingCodes12',width:wchbilling},
        { header: 'BPS13: Survey/Power Supply Investigation',key:'billingCodes13',width:wchbilling},
        { header: 'BPS14: Lock/Security Strap Installation',key:'billingCodes14',width:wchbilling},
        { header: 'BQCON7: Traffic Control',key:'billingCodes15',width:wchbilling},
        { header: 'BQCON17: Electrician charge for Meter installation and hookup – by Region',key:'billingCodes16',width:wchbilling},
        //{ header: 'BQCON7: Traffic Control',key:'dateEntered',width:wchbilling},

        { header: 'Material Codes: Entry 1',key:'materialType1',width:wchbilling},
        { header: 'Material Codes: Entry 2',key:'materialType2',width:wchbilling},
        { header: 'Material Codes: Entry 3',key:'materialType3',width:wchbilling},
        { header: 'Material Codes: Entry 4',key:'materialType4',width:wchbilling},
        { header: 'Material Codes: Entry 5',key:'materialType5',width:wchbilling},
      ];
    }

    if (fileType === 'TRANSPONDER') {
      //Default Width's
      let wchPowerSupplyId = 14;
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchName = 5;
      let wchPowerSupplyName = 20;
      let wchIp = 3;
      let wchMacAddress = 11;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 5;
      let wchState = 6;
      let wchZip = 4;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchPowerSupplyType = 16;
      let wchEdfa = 5;
      let wchMacAddressPrevious = 18;
      let wchPowerSupplyNumber = 18;
      let wchTransponderVendor = 18;
      let wchTransponderModel = 17;
      let wchPsAlertProfile = 15;
      let wchExternalSensor = 18;

      json.forEach(jsonPowerSupplyReport => {
        if (jsonPowerSupplyReport.city !== null && wchCity <= jsonPowerSupplyReport.city.length) {
          wchCity = jsonPowerSupplyReport.city.length;
        }
        if (jsonPowerSupplyReport.communityName !== null && wchCommunityName <= jsonPowerSupplyReport.communityName.length) {
          wchCommunityName = jsonPowerSupplyReport.communityName.length;
        }
        if (jsonPowerSupplyReport.edfa !== null && wchEdfa <= jsonPowerSupplyReport.edfa.length) {
          wchEdfa = jsonPowerSupplyReport.edfa.length;
        }
        if (jsonPowerSupplyReport.headendName !== null && wchHeadendName <= jsonPowerSupplyReport.headendName.length) {
          wchHeadendName = jsonPowerSupplyReport.headendName.length;
        }
        if (jsonPowerSupplyReport.houseNumber !== null && wchHouseNumber <= jsonPowerSupplyReport.houseNumber.length) {
          wchHouseNumber = jsonPowerSupplyReport.houseNumber.length;
        }
        if (jsonPowerSupplyReport.ip !== null && wchIp <= jsonPowerSupplyReport.ip.length) {
          wchIp = jsonPowerSupplyReport.ip.length;
        }
        if (jsonPowerSupplyReport.macAddress !== null && wchMacAddress <= jsonPowerSupplyReport.macAddress.length) {
          wchMacAddress = jsonPowerSupplyReport.macAddress.length;
        }
        if (jsonPowerSupplyReport.macAddressPrevious !== null && wchMacAddressPrevious <= jsonPowerSupplyReport.macAddressPrevious.length) {
          wchMacAddressPrevious = jsonPowerSupplyReport.macAddressPrevious.length;
        }
        if (jsonPowerSupplyReport.name !== null && wchName <= jsonPowerSupplyReport.name.length) {
          wchName = jsonPowerSupplyReport.name.length;
        }
        if (jsonPowerSupplyReport.node10 !== null && wchNode10 <= jsonPowerSupplyReport.node10.length) {
          wchNode10 = jsonPowerSupplyReport.node10.length;
        }
        if (jsonPowerSupplyReport.node2 !== null && wchNode2 <= jsonPowerSupplyReport.node2.length) {
          wchNode2 = jsonPowerSupplyReport.node2.length;
        }
        if (jsonPowerSupplyReport.node3 !== null && wchNode3 <= jsonPowerSupplyReport.node3.length) {
          wchNode3 = jsonPowerSupplyReport.node3.length;
        }
        if (jsonPowerSupplyReport.node4 !== null && wchNode4 <= jsonPowerSupplyReport.node4.length) {
          wchNode4 = jsonPowerSupplyReport.node4.length;
        }
        if (jsonPowerSupplyReport.node5 !== null && wchNode5 <= jsonPowerSupplyReport.node5.length) {
          wchNode5 = jsonPowerSupplyReport.node5.length;
        }
        if (jsonPowerSupplyReport.node6 !== null && wchNode6 <= jsonPowerSupplyReport.node6.length) {
          wchNode6 = jsonPowerSupplyReport.node6.length;
        }
        if (jsonPowerSupplyReport.node7 !== null && wchNode7 <= jsonPowerSupplyReport.node7.length) {
          wchNode7 = jsonPowerSupplyReport.node7.length;
        }
        if (jsonPowerSupplyReport.node8 !== null && wchNode8 <= jsonPowerSupplyReport.node8.length) {
          wchNode8 = jsonPowerSupplyReport.node8.length;
        }
        if (jsonPowerSupplyReport.node9 !== null && wchNode9 <= jsonPowerSupplyReport.node9.length) {
          wchNode9 = jsonPowerSupplyReport.node9.length;
        }
        if (jsonPowerSupplyReport.node11 !== null && wchNode11 <= jsonPowerSupplyReport.node11.length) {
          wchNode11 = jsonPowerSupplyReport.node11.length;
        }
        if (jsonPowerSupplyReport.node12 !== null && wchNode12 <= jsonPowerSupplyReport.node12.length) {
          wchNode12 = jsonPowerSupplyReport.node12.length;
        }
        if (jsonPowerSupplyReport.node13 !== null && wchNode13 <= jsonPowerSupplyReport.node13.length) {
          wchNode13 = jsonPowerSupplyReport.node13.length;
        }
        if (jsonPowerSupplyReport.node14 !== null && wchNode14 <= jsonPowerSupplyReport.node14.length) {
          wchNode14 = jsonPowerSupplyReport.node14.length;
        }
        if (jsonPowerSupplyReport.node15 !== null && wchNode15 <= jsonPowerSupplyReport.node15.length) {
          wchNode15 = jsonPowerSupplyReport.node15.length;
        }
        if (jsonPowerSupplyReport.powerSupplyId !== null && wchPowerSupplyId <= jsonPowerSupplyReport.powerSupplyId.toString.length) {
          wchPowerSupplyId = jsonPowerSupplyReport.powerSupplyId.toString.length;
        }
        if (jsonPowerSupplyReport.powerSupplyNumber !== null && wchPowerSupplyNumber <= jsonPowerSupplyReport.powerSupplyNumber.length) {
          wchPowerSupplyNumber = jsonPowerSupplyReport.powerSupplyNumber.length;
        }
        if (jsonPowerSupplyReport.powerSupplyType !== null && wchPowerSupplyType <= jsonPowerSupplyReport.powerSupplyType.length) {
          wchPowerSupplyType = jsonPowerSupplyReport.powerSupplyType.length;
        }
        if (jsonPowerSupplyReport.psAlertProfile !== null && wchPsAlertProfile <= jsonPowerSupplyReport.psAlertProfile.length) {
          wchPsAlertProfile = jsonPowerSupplyReport.psAlertProfile.length;
        }
        if (jsonPowerSupplyReport.regionName !== null && wchRegionName <= jsonPowerSupplyReport.regionName.length) {
          wchRegionName = jsonPowerSupplyReport.regionName.length;
        }
        if (jsonPowerSupplyReport.state !== null && wchState <= jsonPowerSupplyReport.state.length) {
          wchState = jsonPowerSupplyReport.state.length;
        }
        if (jsonPowerSupplyReport.transponderModel !== null && wchTransponderModel <= jsonPowerSupplyReport.transponderModel.length) {
          wchTransponderModel = jsonPowerSupplyReport.transponderModel.length;
        }
        if (jsonPowerSupplyReport.transponderVendor !== null && wchTransponderVendor <= jsonPowerSupplyReport.transponderVendor.length) {
          wchTransponderVendor = jsonPowerSupplyReport.transponderVendor.length;
        }
        if (jsonPowerSupplyReport.zip !== null && wchZip <= jsonPowerSupplyReport.zip.length) {
          wchZip = jsonPowerSupplyReport.zip.length;
        }
        if (jsonPowerSupplyReport.externalSensor !== null && wchExternalSensor <= jsonPowerSupplyReport.externalSensor.length) {
          wchExternalSensor = jsonPowerSupplyReport.externalSensor.length;
        }
      });
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId },
        { header: 'RegionName', key: 'regionName', width: wchRegionName },
        { header: 'HeadendName', key: 'headendName', width: wchHeadendName },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName },
        { header: 'Name', key: 'name', width: wchName },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
        { header: 'IP', key: 'ip', width: wchIp },
        { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
        { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: wchPowerSupplyAddress },
        { header: 'CrossStreet', key: 'crossStreet', width: wchCrossStreet },
        { header: 'City', key: 'city', width: wchCity },
        { header: 'State', key: 'state', width: wchState },
        { header: 'Zip', key: 'zip', width: wchZip },
        { header: 'Node2', key: 'node2', width: wchNode2 },
        { header: 'Node3', key: 'node3', width: wchNode3 },
        { header: 'Node4', key: 'node4', width: wchNode4 },
        { header: 'Node5', key: 'node5', width: wchNode5 },
        { header: 'Node6', key: 'node6', width: wchNode6 },
        { header: 'Node7', key: 'node7', width: wchNode7 },
        { header: 'Node8', key: 'node8', width: wchNode8 },
        { header: 'Node9', key: 'node9', width: wchNode9 },
        { header: 'Node10', key: 'node10', width: wchNode10 },
        { header: 'Node11', key: 'node11', width: wchNode11 },
        { header: 'Node12', key: 'node12', width: wchNode12 },
        { header: 'Node13', key: 'node13', width: wchNode13 },
        { header: 'Node14', key: 'node14', width: wchNode14 },
        { header: 'Node15', key: 'node15', width: wchNode15 },
        { header: 'PowerSupplyType', key: 'powerSupplyType', width: wchPowerSupplyType },
        { header: 'Edfa', key: 'edfa', width: wchEdfa },
        { header: 'MacAddressPrevious', key: 'macAddressPrevious', width: wchMacAddressPrevious },
        { header: 'PowerSupplyNumber', key: 'powerSupplyNumber', width: wchPowerSupplyNumber },
        { header: 'TransponderVendor', key: 'transponderVendor', width: wchTransponderVendor },
        { header: 'TransponderModel', key: 'transponderModel', width: wchTransponderModel },
        { header: 'PsAlertProfile', key: 'psAlertProfile', width: wchPsAlertProfile },
        { header: 'EthernetConnectedDevice', key: 'externalSensor', width: wchExternalSensor }
      ];
    }
    if (fileType === 'APU') {
      //Default Width's
      let wchPowerSupplyId = 14;
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchName = 5;
      let wchPowerSupplyName = 20;
      let wchIp = 3;
      let wchMacAddress = 11;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 5;
      let wchState = 6;
      let wchZip = 4;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchApuMakeModel = 13;
      let wchApuSerialNumber = 16;
      let wchApuDeviceId = 12;
      let wchApuRunTime = 11;
      let wchEcmAcm = 7;
      let wchDateApuInstalled = 17;
      let wchApuOutputVoltageRating = 23;
      let wchApuNoLoadVoltage = 17;
      let wchApuLoadVoltage = 15;
      let wchApuEnclosureMake = 17;
      let wchNgLp = 7;
      let wchNgProvider = 11;
      let wchLpTankCapacity = 15;
      let wchNumberTanksInstalled = 21;
      json.forEach(jsonTestPsApuReports => {
        if (jsonTestPsApuReports.powerSupplyId !== null && wchPowerSupplyId <= jsonTestPsApuReports.powerSupplyId.toString.length) {
          wchPowerSupplyId = jsonTestPsApuReports.powerSupplyId.toString.length;
        }
        if (jsonTestPsApuReports.regionName !== null && wchRegionName <= jsonTestPsApuReports.regionName.length) {
          wchRegionName = jsonTestPsApuReports.regionName.length;
        }
        if (jsonTestPsApuReports.headendName !== null && wchHeadendName <= jsonTestPsApuReports.headendName.length) {
          wchHeadendName = jsonTestPsApuReports.headendName.length;
        }
        if (jsonTestPsApuReports.communityName !== null && wchCommunityName <= jsonTestPsApuReports.communityName.length) {
          wchCommunityName = jsonTestPsApuReports.communityName.length;
        }
        if (jsonTestPsApuReports.name !== null && wchName <= jsonTestPsApuReports.name.length) {
          wchName = jsonTestPsApuReports.name.length;
        }
        if (jsonTestPsApuReports.ip !== null && wchIp <= jsonTestPsApuReports.ip.length) {
          wchIp = jsonTestPsApuReports.ip.length;
        }
        if (jsonTestPsApuReports.macAddress !== null && wchMacAddress <= jsonTestPsApuReports.macAddress.length) {
          wchMacAddress = jsonTestPsApuReports.macAddress.length;
        }
        if (jsonTestPsApuReports.houseNumber !== null && wchHouseNumber <= jsonTestPsApuReports.houseNumber.length) {
          wchHouseNumber = jsonTestPsApuReports.houseNumber.length;
        }
        if (jsonTestPsApuReports.city !== null && wchCity <= jsonTestPsApuReports.city.length) {
          wchCity = jsonTestPsApuReports.city.length;
        }
        if (jsonTestPsApuReports.state !== null && wchState <= jsonTestPsApuReports.state.length) {
          wchState = jsonTestPsApuReports.state.length;
        }
        if (jsonTestPsApuReports.zip !== null && wchZip <= jsonTestPsApuReports.zip.length) {
          wchZip = jsonTestPsApuReports.zip.length;
        }
        if (jsonTestPsApuReports.node2 !== null && wchNode2 <= jsonTestPsApuReports.node2.length) {
          wchNode2 = jsonTestPsApuReports.node2.length;
        }
        if (jsonTestPsApuReports.node3 !== null && wchNode3 <= jsonTestPsApuReports.node3.length) {
          wchNode3 = jsonTestPsApuReports.node3.length;
        }
        if (jsonTestPsApuReports.node4 !== null && wchNode4 <= jsonTestPsApuReports.node4.length) {
          wchNode4 = jsonTestPsApuReports.node4.length;
        }
        if (jsonTestPsApuReports.node5 !== null && wchNode5 <= jsonTestPsApuReports.node5.length) {
          wchNode5 = jsonTestPsApuReports.node5.length;
        }
        if (jsonTestPsApuReports.node6 !== null && wchNode6 <= jsonTestPsApuReports.node6.length) {
          wchNode6 = jsonTestPsApuReports.node6.length;
        }
        if (jsonTestPsApuReports.node7 !== null && wchNode7 <= jsonTestPsApuReports.node7.length) {
          wchNode7 = jsonTestPsApuReports.node7.length;
        }
        if (jsonTestPsApuReports.node8 !== null && wchNode8 <= jsonTestPsApuReports.node8.length) {
          wchNode8 = jsonTestPsApuReports.node8.length;
        }
        if (jsonTestPsApuReports.node9 !== null && wchNode9 <= jsonTestPsApuReports.node9.length) {
          wchNode9 = jsonTestPsApuReports.node9.length;
        }
        if (jsonTestPsApuReports.node10 !== null && wchNode10 <= jsonTestPsApuReports.node10.length) {
          wchNode10 = jsonTestPsApuReports.node10.length;
        }
        if (jsonTestPsApuReports.node11 !== null && wchNode11 <= jsonTestPsApuReports.node11.length) {
          wchNode11 = jsonTestPsApuReports.node11.length;
        }
        if (jsonTestPsApuReports.node12 !== null && wchNode12 <= jsonTestPsApuReports.node12.length) {
          wchNode12 = jsonTestPsApuReports.node12.length;
        }
        if (jsonTestPsApuReports.node13 !== null && wchNode13 <= jsonTestPsApuReports.node13.length) {
          wchNode13 = jsonTestPsApuReports.node13.length;
        }
        if (jsonTestPsApuReports.node14 !== null && wchNode14 <= jsonTestPsApuReports.node14.length) {
          wchNode14 = jsonTestPsApuReports.node14.length;
        }
        if (jsonTestPsApuReports.node15 !== null && wchNode15 <= jsonTestPsApuReports.node15.length) {
          wchNode15 = jsonTestPsApuReports.node15.length;
        }
        if (jsonTestPsApuReports.apuMakeModel !== null && wchApuMakeModel <= jsonTestPsApuReports.apuMakeModel.length) {
          wchApuMakeModel = jsonTestPsApuReports.apuMakeModel.length;
        }
        if (jsonTestPsApuReports.apuSerialNumber !== null && wchApuSerialNumber <= jsonTestPsApuReports.apuSerialNumber.length) {
          wchApuSerialNumber = jsonTestPsApuReports.apuSerialNumber.length;
        }
        if (jsonTestPsApuReports.apuDeviceId !== null && wchApuDeviceId <= jsonTestPsApuReports.apuDeviceId.toString.length) {
          wchApuDeviceId = jsonTestPsApuReports.apuDeviceId.toString.length;
        }
        if (jsonTestPsApuReports.apuRunTime !== null && wchApuRunTime <= jsonTestPsApuReports.apuRunTime.length) {
          wchApuRunTime = jsonTestPsApuReports.apuRunTime.length;
        }
        if (jsonTestPsApuReports.ecmAcm !== null && wchEcmAcm <= jsonTestPsApuReports.ecmAcm.length) {
          wchEcmAcm = jsonTestPsApuReports.ecmAcm.length;
        }
        if (jsonTestPsApuReports.dateApuInstalled !== null && wchDateApuInstalled <= jsonTestPsApuReports.dateApuInstalled.toString.length) {
          wchDateApuInstalled = jsonTestPsApuReports.dateApuInstalled.toString.length;
        }
        if (jsonTestPsApuReports.apuOutputVoltageRating !== null && wchApuOutputVoltageRating <= jsonTestPsApuReports.apuOutputVoltageRating.length) {
          wchApuOutputVoltageRating = jsonTestPsApuReports.apuOutputVoltageRating.length;
        }
        if (jsonTestPsApuReports.apuNoLoadVoltage !== null && wchApuNoLoadVoltage <= jsonTestPsApuReports.apuNoLoadVoltage.toString.length) {
          wchApuNoLoadVoltage = jsonTestPsApuReports.apuNoLoadVoltage.toString.length;
        }
        if (jsonTestPsApuReports.apuLoadVoltage !== null && wchApuLoadVoltage <= jsonTestPsApuReports.apuLoadVoltage.toString.length) {
          wchApuLoadVoltage = jsonTestPsApuReports.apuLoadVoltage.toString.length;
        }
        if (jsonTestPsApuReports.apuEnclosureMake !== null && wchApuEnclosureMake <= jsonTestPsApuReports.apuEnclosureMake.length) {
          wchApuEnclosureMake = jsonTestPsApuReports.apuEnclosureMake.length;
        }
        if (jsonTestPsApuReports.ngLp !== null && wchNgLp <= jsonTestPsApuReports.ngLp.length) {
          wchNgLp = jsonTestPsApuReports.ngLp.length;
        }
        if (jsonTestPsApuReports.ngProvider !== null && wchNgProvider <= jsonTestPsApuReports.ngProvider.length) {
          wchNgProvider = jsonTestPsApuReports.ngProvider.length;
        }
        if (jsonTestPsApuReports.lpTankCapacity !== null && wchLpTankCapacity <= jsonTestPsApuReports.lpTankCapacity.length) {
          wchLpTankCapacity = jsonTestPsApuReports.lpTankCapacity.length;
        }
        if (jsonTestPsApuReports.numberTanksInstalled !== null && wchNumberTanksInstalled <= jsonTestPsApuReports.numberTanksInstalled.toString.length) {
          wchNumberTanksInstalled = jsonTestPsApuReports.numberTanksInstalled.toString.length;
        }
      });
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId },
        { header: 'RegionName', key: 'regionName', width: wchRegionName },
        { header: 'HeadendName', key: 'headendName', width: wchHeadendName },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName },
        { header: 'Name', key: 'name', width: wchName },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
        { header: 'IP', key: 'ip', width: wchIp },
        { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
        { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: wchPowerSupplyAddress },
        { header: 'CrossStreet', key: 'crossStreet', width: wchCrossStreet },
        { header: 'City', key: 'city', width: wchCity },
        { header: 'State', key: 'state', width: wchState },
        { header: 'Zip', key: 'zip', width: wchZip },
        { header: 'Node2', key: 'node2', width: wchNode2 },
        { header: 'Node3', key: 'node3', width: wchNode3 },
        { header: 'Node4', key: 'node4', width: wchNode4 },
        { header: 'Node5', key: 'node5', width: wchNode5 },
        { header: 'Node6', key: 'node6', width: wchNode6 },
        { header: 'Node7', key: 'node7', width: wchNode7 },
        { header: 'Node8', key: 'node8', width: wchNode8 },
        { header: 'Node9', key: 'node9', width: wchNode9 },
        { header: 'Node10', key: 'node10', width: wchNode10 },
        { header: 'Node11', key: 'node11', width: wchNode11 },
        { header: 'Node12', key: 'node12', width: wchNode12 },
        { header: 'Node13', key: 'node13', width: wchNode13 },
        { header: 'Node14', key: 'node14', width: wchNode14 },
        { header: 'Node15', key: 'node15', width: wchNode15 },
        { header: 'ApuMakeModel', key: 'apuMakeModel', width: wchApuMakeModel },
        { header: 'ApuSerialNumber', key: 'apuSerialNumber', width: wchApuSerialNumber },
        { header: 'ApuDeviceId', key: 'apuDeviceId', width: wchApuDeviceId },
        { header: 'ApuRunTime', key: 'apuRunTime', width: wchApuRunTime },
        { header: 'EcmAcm', key: 'ecmAcm', width: wchEcmAcm },
        { header: 'DateApuInstalled', key: 'dateApuInstalled', width: wchDateApuInstalled },
        { header: 'ApuOutputVoltageRating', key: 'apuOutputVoltageRating', width: wchApuOutputVoltageRating },
        { header: 'ApuNoLoadVoltage', key: 'apuNoLoadVoltage', width: wchApuNoLoadVoltage },
        { header: 'ApuLoadVoltage', key: 'apuLoadVoltage', width: wchApuLoadVoltage },
        { header: 'ApuEnclosureMake', key: 'apuEnclosureMake', width: wchApuEnclosureMake },
        { header: 'NgLp', key: 'ngLp', width: wchNgLp },
        { header: 'NgProvider', key: 'ngProvider', width: wchNgProvider },
        { header: 'LpTankCapacity', key: 'lpTankCapacity', width: wchLpTankCapacity },
        { header: 'NumberTanksInstalled', key: 'numberTanksInstalled', width: wchNumberTanksInstalled }
      ]
    }
    if (fileType === 'LOCATION') {
      //Default Width's
      let wchPowerSupplyId = 14;
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchName = 5;
      let wchPowerSupplyName = 20;
      let wchIp = 3;
      let wchMacAddress = 11;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 5;
      let wchState = 6;
      let wchZip = 4;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchFeedsMutipleNodes = 18;
      let wchGpsLatitude = 12;
      let wchGpsLongitude = 13;
      let wchcalculatedRuntime = 23;
      let wchPowersNode = 11;
      let wchAerialUnderground = 18;
      let wchPoleNumber = 11;
      let wchPowerSupplyVendor = 18;
      let wchCompanyAccountNumber = 21;
      let wchElectricMeterNumber = 20;
      let wchMapNumber = 10;
      let wchnwtTeam = 15;
      let wchBusinessPartnerRestriction=20;
      let wchnitroCompletionDate = 15;
      let wchnitroReasonNotCompleted = 30;

      json.forEach(jsonTestPsLocationReports => {
        if (jsonTestPsLocationReports.powerSupplyId !== null && wchPowerSupplyId <= jsonTestPsLocationReports.powerSupplyId.toString.length) {
          wchPowerSupplyId = jsonTestPsLocationReports.powerSupplyId.toString.length;
        }
        if (jsonTestPsLocationReports.regionName !== null && wchRegionName <= jsonTestPsLocationReports.regionName.length) {
          wchRegionName = jsonTestPsLocationReports.regionName.length;
        }
        if (jsonTestPsLocationReports.headendName !== null && wchHeadendName <= jsonTestPsLocationReports.headendName.length) {
          wchHeadendName = jsonTestPsLocationReports.headendName.length;
        }
        if (jsonTestPsLocationReports.communityName !== null && wchCommunityName <= jsonTestPsLocationReports.communityName.length) {
          wchCommunityName = jsonTestPsLocationReports.communityName.length;
        }
        if (jsonTestPsLocationReports.name !== null && wchName <= jsonTestPsLocationReports.name.length) {
          wchName = jsonTestPsLocationReports.name.length;
        }
        if (jsonTestPsLocationReports.ip !== null && wchIp <= jsonTestPsLocationReports.ip.length) {
          wchIp = jsonTestPsLocationReports.ip.length;
        }
        if (jsonTestPsLocationReports.macAddress !== null && wchMacAddress <= jsonTestPsLocationReports.macAddress.length) {
          wchMacAddress = jsonTestPsLocationReports.macAddress.length;
        }
        if (jsonTestPsLocationReports.houseNumber !== null && wchHouseNumber <= jsonTestPsLocationReports.houseNumber.length) {
          wchHouseNumber = jsonTestPsLocationReports.houseNumber.length;
        }
        if (jsonTestPsLocationReports.city !== null && wchCity <= jsonTestPsLocationReports.city.length) {
          wchCity = jsonTestPsLocationReports.city.length;
        }
        if (jsonTestPsLocationReports.state !== null && wchState <= jsonTestPsLocationReports.state.length) {
          wchState = jsonTestPsLocationReports.state.length;
        }
        if (jsonTestPsLocationReports.zip !== null && wchZip <= jsonTestPsLocationReports.zip.length) {
          wchZip = jsonTestPsLocationReports.zip.length;
        }
        if (jsonTestPsLocationReports.node2 !== null && wchNode2 <= jsonTestPsLocationReports.node2.length) {
          wchNode2 = jsonTestPsLocationReports.node2.length;
        }
        if (jsonTestPsLocationReports.node3 !== null && wchNode3 <= jsonTestPsLocationReports.node3.length) {
          wchNode3 = jsonTestPsLocationReports.node3.length;
        }
        if (jsonTestPsLocationReports.node4 !== null && wchNode4 <= jsonTestPsLocationReports.node4.length) {
          wchNode4 = jsonTestPsLocationReports.node4.length;
        }
        if (jsonTestPsLocationReports.node5 !== null && wchNode5 <= jsonTestPsLocationReports.node5.length) {
          wchNode5 = jsonTestPsLocationReports.node5.length;
        }
        if (jsonTestPsLocationReports.node6 !== null && wchNode6 <= jsonTestPsLocationReports.node6.length) {
          wchNode6 = jsonTestPsLocationReports.node6.length;
        }
        if (jsonTestPsLocationReports.node7 !== null && wchNode7 <= jsonTestPsLocationReports.node7.length) {
          wchNode7 = jsonTestPsLocationReports.node7.length;
        }
        if (jsonTestPsLocationReports.node8 !== null && wchNode8 <= jsonTestPsLocationReports.node8.length) {
          wchNode8 = jsonTestPsLocationReports.node8.length;
        }
        if (jsonTestPsLocationReports.node9 !== null && wchNode9 <= jsonTestPsLocationReports.node9.length) {
          wchNode9 = jsonTestPsLocationReports.node9.length;
        }
        if (jsonTestPsLocationReports.node10 !== null && wchNode10 <= jsonTestPsLocationReports.node10.length) {
          wchNode10 = jsonTestPsLocationReports.node10.length;
        }
        if (jsonTestPsLocationReports.node11 !== null && wchNode11 <= jsonTestPsLocationReports.node11.length) {
          wchNode11 = jsonTestPsLocationReports.node11.length;
        }
        if (jsonTestPsLocationReports.node12 !== null && wchNode12 <= jsonTestPsLocationReports.node12.length) {
          wchNode12 = jsonTestPsLocationReports.node12.length;
        }
        if (jsonTestPsLocationReports.node13 !== null && wchNode13 <= jsonTestPsLocationReports.node13.length) {
          wchNode13 = jsonTestPsLocationReports.node13.length;
        }
        if (jsonTestPsLocationReports.node14 !== null && wchNode14 <= jsonTestPsLocationReports.node14.length) {
          wchNode14 = jsonTestPsLocationReports.node14.length;
        }
        if (jsonTestPsLocationReports.node15 !== null && wchNode15 <= jsonTestPsLocationReports.node15.length) {
          wchNode15 = jsonTestPsLocationReports.node15.length;
        }
        if (jsonTestPsLocationReports.feedsMultipleNodes !== null && wchFeedsMutipleNodes <= jsonTestPsLocationReports.feedsMultipleNodes.length) {
          wchFeedsMutipleNodes = jsonTestPsLocationReports.feedsMultipleNodes.length;
        }
        if (jsonTestPsLocationReports.gpsLatitude !== null && wchGpsLatitude <= jsonTestPsLocationReports.gpsLatitude.toString.length) {
          wchGpsLatitude = jsonTestPsLocationReports.gpsLatitude.toString.length;
        }
        if (jsonTestPsLocationReports.gpsLongitude !== null && wchGpsLongitude <= jsonTestPsLocationReports.gpsLongitude.toString.length) {
          wchGpsLongitude = jsonTestPsLocationReports.gpsLongitude.toString.length;
        }
        if (jsonTestPsLocationReports.calculatedRuntime !== null && wchcalculatedRuntime <= jsonTestPsLocationReports.calculatedRuntime.length) {
          wchcalculatedRuntime = jsonTestPsLocationReports.calculatedRuntime.length;
        }
        if (jsonTestPsLocationReports.powersNode !== null && wchPowersNode <= jsonTestPsLocationReports.powersNode.length) {
          wchPowersNode = jsonTestPsLocationReports.powersNode.length;
        }
        if (jsonTestPsLocationReports.aerialUnderground !== null && wchAerialUnderground <= jsonTestPsLocationReports.aerialUnderground.length) {
          wchAerialUnderground = jsonTestPsLocationReports.aerialUnderground.length;
        }
        if (jsonTestPsLocationReports.poleNumber !== null && wchPoleNumber <= jsonTestPsLocationReports.poleNumber.length) {
          wchPoleNumber = jsonTestPsLocationReports.poleNumber.length;
        }
        if (jsonTestPsLocationReports.powerSupplyVendor !== null && wchPowerSupplyVendor <= jsonTestPsLocationReports.powerSupplyVendor.length) {
          wchPowerSupplyVendor = jsonTestPsLocationReports.powerSupplyVendor.length;
        }
        if (jsonTestPsLocationReports.companyAccountNumber !== null && wchCompanyAccountNumber <= jsonTestPsLocationReports.companyAccountNumber.length) {
          wchCompanyAccountNumber = jsonTestPsLocationReports.companyAccountNumber.length;
        }
        if (jsonTestPsLocationReports.electricMeterNumber !== null && wchElectricMeterNumber <= jsonTestPsLocationReports.electricMeterNumber.length) {
          wchElectricMeterNumber = jsonTestPsLocationReports.electricMeterNumber.length;
        }
        if (jsonTestPsLocationReports.mapNumber !== null && wchMapNumber <= jsonTestPsLocationReports.mapNumber.length) {
          wchMapNumber = jsonTestPsLocationReports.mapNumber.length;
        }
        if (jsonTestPsLocationReports.nwtTeam !== null && wchCompanyAccountNumber <= jsonTestPsLocationReports.nwtTeam.length) {
          wchnwtTeam = jsonTestPsLocationReports.nwtTeam.length;
        }
        if (jsonTestPsLocationReports.nitroCompletionDate !== null && wchElectricMeterNumber <= jsonTestPsLocationReports.nitroCompletionDate.length) {
          wchnitroCompletionDate = jsonTestPsLocationReports.nitroCompletionDate.length;
        }
        if (jsonTestPsLocationReports.powerAccountType !== null && wchMapNumber <= jsonTestPsLocationReports.powerAccountType.length) {
          wchnitroReasonNotCompleted = jsonTestPsLocationReports.powerAccountType.length;
        }
        if(jsonTestPsLocationReports.businessPartnerRestriction !== null && wchBusinessPartnerRestriction <= jsonTestPsLocationReports.businessPartnerRestriction.length) {
        wchBusinessPartnerRestriction=jsonTestPsLocationReports.businessPartnerRestriction.length;
        }
      });
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId },
        { header: 'RegionName', key: 'regionName', width: wchRegionName },
        { header: 'HeadendName', key: 'headendName', width: wchHeadendName },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName },
        { header: 'Name', key: 'name', width: wchName },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
        { header: 'IP', key: 'ip', width: wchIp },
        { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
        { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: wchPowerSupplyAddress },
        { header: 'CrossStreet', key: 'crossStreet', width: wchCrossStreet },
        { header: 'City', key: 'city', width: wchCity },
        { header: 'State', key: 'state', width: wchState },
        { header: 'Zip', key: 'zip', width: wchZip },
        { header: 'Node2', key: 'node2', width: wchNode2 },
        { header: 'Node3', key: 'node3', width: wchNode3 },
        { header: 'Node4', key: 'node4', width: wchNode4 },
        { header: 'Node5', key: 'node5', width: wchNode5 },
        { header: 'Node6', key: 'node6', width: wchNode6 },
        { header: 'Node7', key: 'node7', width: wchNode7 },
        { header: 'Node8', key: 'node8', width: wchNode8 },
        { header: 'Node9', key: 'node9', width: wchNode9 },
        { header: 'Node10', key: 'node10', width: wchNode10 },
        { header: 'Node11', key: 'node11', width: wchNode11 },
        { header: 'Node12', key: 'node12', width: wchNode12 },
        { header: 'Node13', key: 'node13', width: wchNode13 },
        { header: 'Node14', key: 'node14', width: wchNode14 },
        { header: 'Node15', key: 'node15', width: wchNode15 },
        { header: 'FeedsMultipleNodes', key: 'feedsMultipleNodes', width: wchFeedsMutipleNodes },
        { header: 'GpsLatitude', key: 'gpsLatitude', width: wchGpsLatitude },
        { header: 'GpsLongitude', key: 'gpsLongitude', width: wchGpsLongitude },
        { header: 'Calculated Runtime(in Minutes)', key: 'calculatedRuntime', width: wchcalculatedRuntime },
        { header: 'PowersNode', key: 'powersNode', width: wchPowersNode },
        { header: 'AerialUnderground', key: 'aerialUnderground', width: wchAerialUnderground },
        { header: 'PoleNumber', key: 'poleNumber', width: wchPoleNumber },
        { header: 'PowerSupplyVendor', key: 'powerSupplyVendor', width: wchPowerSupplyVendor },
        { header: 'Team', key: 'companyAccountNumber', width: wchCompanyAccountNumber },
        { header: 'PowerAccountType', key: 'powerAccountType', width: wchnitroReasonNotCompleted },
        { header: 'ElectricMeterNumber', key: 'electricMeterNumber', width: wchElectricMeterNumber },
        { header: 'MapNumber', key: 'mapNumber', width: wchMapNumber },

        { header: 'NWTTeam', key: 'nwtTeam', width: wchnwtTeam },

        { header: 'NitroCompletionDate', key: 'nitroCompletionDate', width: wchnitroCompletionDate },
        { header: 'BusinessPartnerRestriction', key: 'businessPartnerRestriction', width: wchBusinessPartnerRestriction }
      ]
    }
    if (fileType === 'INSPECTION') {
      //Default Width's
      let wchPowerSupplyId = 14;
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchName = 5;
      let wchPowerSupplyName = 20;
      let wchIp = 3;
      let wchMacAddress = 11;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 5;
      let wchState = 6;
      let wchZip = 4;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchInspectionDate = 15;
      let wchTypeOfVisit = 12;
      let wchXocVerified = 12;
      let wchCleanEnclosure = 15;
      let wchTightenHardware = 16;
      let wchInspectConnectors = 18;
      let wchInspectProbes = 14;
      let wchMeterPanCondition = 18;
      let wchPowerCoRiserCondition = 22;
      let wchBatteryHeaterMatType = 21;
      let wchBatteryHeaterMatQuantity = 25;
      let wchEnclosureSnowShield = 20;
      let wchInternalBreaker = 16;
      let wchServiceEntrance = 16;
      let wchReceptacleType = 15;
      let wchCheckSeizureAltBox = 19;
      let wchPowerSupplyIdLegible = 21;
      let wchCheckLampsLeds = 15;
      let wchCheckMagneticBreaker = 21;
      let wchVisualCabinetInspection = 24;
      let wchCabinetLocked = 14;
      let wchSecurityBarPresent = 19;
      let wchCheckGroundCabinet = 19;
      let wchBatteryString1Fused = 20;
      let wchBatteryString2Fused = 20;
      let wchBatteryString3Fused = 20;
      let wchBatteryString4Fused = 20;
      let wchTamperInstalledFunctioning = 27;
      let wchCheckLaps = 10;
      let wchCabinetVendor = 14;
      let wchCabinetBatteryCapacity = 23;
      let wchCheckOperatingLights = 21;
      let wchStandByOperation = 17;
      let wchRemoteStandbyOperation2 = 24;
      let wchRemoteStandbyOperation3 = 24;
      let wchRemoteStandbyOperation4 = 24;
      let wchRemoteStandbyOperation5 = 24;
      let wchFollowUpNeeded = 15;
      let wchInputSurgeArrestor = 19;
      let wchOutputSurgeArrestor = 20;
      let wchCoaxTvssPresent = 16;
      let wchAcIndicatorGreenLight = 22;
      let wchLocalRemoteIndicator = 21;
      let wchCommTech = 9;
      json.forEach(jsonTestPsInspectionReports => {
        if (jsonTestPsInspectionReports.powerSupplyId !== null && wchPowerSupplyId <= jsonTestPsInspectionReports.powerSupplyId.toString.length) {
          wchPowerSupplyId = jsonTestPsInspectionReports.powerSupplyId.toString.length;
        }
        if (jsonTestPsInspectionReports.regionName !== null && wchRegionName <= jsonTestPsInspectionReports.regionName.length) {
          wchRegionName = jsonTestPsInspectionReports.regionName.length;
        }
        if (jsonTestPsInspectionReports.headendName !== null && wchHeadendName <= jsonTestPsInspectionReports.headendName.length) {
          wchHeadendName = jsonTestPsInspectionReports.headendName.length;
        }
        if (jsonTestPsInspectionReports.communityName !== null && wchCommunityName <= jsonTestPsInspectionReports.communityName.length) {
          wchCommunityName = jsonTestPsInspectionReports.communityName.length;
        }
        if (jsonTestPsInspectionReports.name !== null && wchName <= jsonTestPsInspectionReports.name.length) {
          wchName = jsonTestPsInspectionReports.name.length;
        }
        if (jsonTestPsInspectionReports.ip !== null && wchIp <= jsonTestPsInspectionReports.ip.length) {
          wchIp = jsonTestPsInspectionReports.ip.length;
        }
        if (jsonTestPsInspectionReports.macAddress !== null && wchMacAddress <= jsonTestPsInspectionReports.macAddress.length) {
          wchMacAddress = jsonTestPsInspectionReports.macAddress.length;
        }
        if (jsonTestPsInspectionReports.houseNumber !== null && wchHouseNumber <= jsonTestPsInspectionReports.houseNumber.length) {
          wchHouseNumber = jsonTestPsInspectionReports.houseNumber.length;
        }
        if (jsonTestPsInspectionReports.city !== null && wchCity <= jsonTestPsInspectionReports.city.length) {
          wchCity = jsonTestPsInspectionReports.city.length;
        }
        if (jsonTestPsInspectionReports.state !== null && wchState <= jsonTestPsInspectionReports.state.length) {
          wchState = jsonTestPsInspectionReports.state.length;
        }
        if (jsonTestPsInspectionReports.zip !== null && wchZip <= jsonTestPsInspectionReports.zip.length) {
          wchZip = jsonTestPsInspectionReports.zip.length;
        }
        if (jsonTestPsInspectionReports.node2 !== null && wchNode2 <= jsonTestPsInspectionReports.node2.length) {
          wchNode2 = jsonTestPsInspectionReports.node2.length;
        }
        if (jsonTestPsInspectionReports.node3 !== null && wchNode3 <= jsonTestPsInspectionReports.node3.length) {
          wchNode3 = jsonTestPsInspectionReports.node3.length;
        }
        if (jsonTestPsInspectionReports.node4 !== null && wchNode4 <= jsonTestPsInspectionReports.node4.length) {
          wchNode4 = jsonTestPsInspectionReports.node4.length;
        }
        if (jsonTestPsInspectionReports.node5 !== null && wchNode5 <= jsonTestPsInspectionReports.node5.length) {
          wchNode5 = jsonTestPsInspectionReports.node5.length;
        }
        if (jsonTestPsInspectionReports.node6 !== null && wchNode6 <= jsonTestPsInspectionReports.node6.length) {
          wchNode6 = jsonTestPsInspectionReports.node6.length;
        }
        if (jsonTestPsInspectionReports.node7 !== null && wchNode7 <= jsonTestPsInspectionReports.node7.length) {
          wchNode7 = jsonTestPsInspectionReports.node7.length;
        }
        if (jsonTestPsInspectionReports.node8 !== null && wchNode8 <= jsonTestPsInspectionReports.node8.length) {
          wchNode8 = jsonTestPsInspectionReports.node8.length;
        }
        if (jsonTestPsInspectionReports.node9 !== null && wchNode9 <= jsonTestPsInspectionReports.node9.length) {
          wchNode9 = jsonTestPsInspectionReports.node9.length;
        }
        if (jsonTestPsInspectionReports.node10 !== null && wchNode10 <= jsonTestPsInspectionReports.node10.length) {
          wchNode10 = jsonTestPsInspectionReports.node10.length;
        }
        if (jsonTestPsInspectionReports.node11 !== null && wchNode11 <= jsonTestPsInspectionReports.node11.length) {
          wchNode11 = jsonTestPsInspectionReports.node11.length;
        }
        if (jsonTestPsInspectionReports.node12 !== null && wchNode12 <= jsonTestPsInspectionReports.node12.length) {
          wchNode12 = jsonTestPsInspectionReports.node12.length;
        }
        if (jsonTestPsInspectionReports.node13 !== null && wchNode13 <= jsonTestPsInspectionReports.node13.length) {
          wchNode13 = jsonTestPsInspectionReports.node13.length;
        }
        if (jsonTestPsInspectionReports.node14 !== null && wchNode14 <= jsonTestPsInspectionReports.node14.length) {
          wchNode14 = jsonTestPsInspectionReports.node14.length;
        }
        if (jsonTestPsInspectionReports.node15 !== null && wchNode15 <= jsonTestPsInspectionReports.node15.length) {
          wchNode15 = jsonTestPsInspectionReports.node15.length;
        }
        if (jsonTestPsInspectionReports.inspectionDate !== null && wchInspectionDate <= jsonTestPsInspectionReports.inspectionDate.length) {
          wchInspectionDate = jsonTestPsInspectionReports.inspectionDate.length;
        }
        if (jsonTestPsInspectionReports.typeOfVisit !== null && wchTypeOfVisit <= jsonTestPsInspectionReports.typeOfVisit.length) {
          wchTypeOfVisit = jsonTestPsInspectionReports.typeOfVisit.length;
        }
        if (jsonTestPsInspectionReports.xocVerified !== null && wchXocVerified <= jsonTestPsInspectionReports.xocVerified.length) {
          wchXocVerified = jsonTestPsInspectionReports.xocVerified.length;
        }
        if (jsonTestPsInspectionReports.cleanEnclosure !== null && wchCleanEnclosure <= jsonTestPsInspectionReports.cleanEnclosure.length) {
          wchCleanEnclosure = jsonTestPsInspectionReports.cleanEnclosure.length;
        }
        if (jsonTestPsInspectionReports.tightenHardware !== null && wchTightenHardware <= jsonTestPsInspectionReports.tightenHardware.length) {
          wchTightenHardware = jsonTestPsInspectionReports.tightenHardware.length;
        }
        if (jsonTestPsInspectionReports.inspectConnectors !== null && wchInspectConnectors <= jsonTestPsInspectionReports.inspectConnectors.length) {
          wchInspectConnectors = jsonTestPsInspectionReports.inspectConnectors.length;
        }
        if (jsonTestPsInspectionReports.inspectProbes !== null && wchInspectProbes <= jsonTestPsInspectionReports.inspectProbes.length) {
          wchInspectProbes = jsonTestPsInspectionReports.inspectProbes.length;
        }
        if (jsonTestPsInspectionReports.meterPanCondition !== null && wchMeterPanCondition <= jsonTestPsInspectionReports.meterPanCondition.length) {
          wchMeterPanCondition = jsonTestPsInspectionReports.meterPanCondition.length;
        }
        if (jsonTestPsInspectionReports.powerCoRiserCondition !== null && wchPowerCoRiserCondition <= jsonTestPsInspectionReports.powerCoRiserCondition.length) {
          wchPowerCoRiserCondition = jsonTestPsInspectionReports.powerCoRiserCondition.length;
        }
        if (jsonTestPsInspectionReports.batteryHeaterMatType !== null && wchBatteryHeaterMatType <= jsonTestPsInspectionReports.batteryHeaterMatType.length) {
          wchBatteryHeaterMatType = jsonTestPsInspectionReports.batteryHeaterMatType.length;
        }
        if (jsonTestPsInspectionReports.batteryHeaterMatQuantity !== null && wchBatteryHeaterMatQuantity <= jsonTestPsInspectionReports.batteryHeaterMatQuantity.length) {
          wchBatteryHeaterMatQuantity = jsonTestPsInspectionReports.batteryHeaterMatQuantity.length;
        }
        if (jsonTestPsInspectionReports.enclosureSnowShield !== null && wchEnclosureSnowShield <= jsonTestPsInspectionReports.enclosureSnowShield.length) {
          wchEnclosureSnowShield = jsonTestPsInspectionReports.enclosureSnowShield.length;
        }
        if (jsonTestPsInspectionReports.internalBreaker !== null && wchInternalBreaker <= jsonTestPsInspectionReports.internalBreaker.length) {
          wchInternalBreaker = jsonTestPsInspectionReports.internalBreaker.length;
        }
        if (jsonTestPsInspectionReports.serviceEntrance !== null && wchServiceEntrance <= jsonTestPsInspectionReports.serviceEntrance.length) {
          wchServiceEntrance = jsonTestPsInspectionReports.serviceEntrance.length;
        }
        if (jsonTestPsInspectionReports.receptacleType !== null && wchReceptacleType <= jsonTestPsInspectionReports.receptacleType.length) {
          wchReceptacleType = jsonTestPsInspectionReports.receptacleType.length;
        }
        if (jsonTestPsInspectionReports.checkSeizureAltBox !== null && wchCheckSeizureAltBox <= jsonTestPsInspectionReports.checkSeizureAltBox.length) {
          wchCheckSeizureAltBox = jsonTestPsInspectionReports.checkSeizureAltBox.length;
        }
        if (jsonTestPsInspectionReports.powerSupplyIdLegible !== null && wchPowerSupplyIdLegible <= jsonTestPsInspectionReports.powerSupplyIdLegible.length) {
          wchPowerSupplyIdLegible = jsonTestPsInspectionReports.powerSupplyIdLegible.length;
        }
        if (jsonTestPsInspectionReports.checkLampsLeds !== null && wchCheckLampsLeds <= jsonTestPsInspectionReports.checkLampsLeds.length) {
          wchCheckLampsLeds = jsonTestPsInspectionReports.checkLampsLeds.length;
        }
        if (jsonTestPsInspectionReports.checkMagneticBreaker !== null && wchCheckMagneticBreaker <= jsonTestPsInspectionReports.checkMagneticBreaker.length) {
          wchCheckMagneticBreaker = jsonTestPsInspectionReports.checkMagneticBreaker.length;
        }
        if (jsonTestPsInspectionReports.visualCabinetInspection !== null && wchVisualCabinetInspection <= jsonTestPsInspectionReports.visualCabinetInspection.length) {
          wchVisualCabinetInspection = jsonTestPsInspectionReports.visualCabinetInspection.length;
        }
        if (jsonTestPsInspectionReports.cabinetLocked !== null && wchCabinetLocked <= jsonTestPsInspectionReports.cabinetLocked.length) {
          wchCabinetLocked = jsonTestPsInspectionReports.cabinetLocked.length;
        }
        if (jsonTestPsInspectionReports.securityBarPresent !== null && wchSecurityBarPresent <= jsonTestPsInspectionReports.securityBarPresent.length) {
          wchSecurityBarPresent = jsonTestPsInspectionReports.securityBarPresent.length;
        }
        if (jsonTestPsInspectionReports.checkGroundCabinet !== null && wchCheckGroundCabinet <= jsonTestPsInspectionReports.checkGroundCabinet.length) {
          wchCheckGroundCabinet = jsonTestPsInspectionReports.checkGroundCabinet.length;
        }
        if (jsonTestPsInspectionReports.batteryString1Fused !== null && wchBatteryString1Fused <= jsonTestPsInspectionReports.batteryString1Fused.length) {
          wchBatteryString1Fused = jsonTestPsInspectionReports.batteryString1Fused.length;
        }
        if (jsonTestPsInspectionReports.batteryString2Fused !== null && wchBatteryString2Fused <= jsonTestPsInspectionReports.batteryString2Fused.length) {
          wchBatteryString2Fused = jsonTestPsInspectionReports.batteryString2Fused.length;
        }
        if (jsonTestPsInspectionReports.batteryString3Fused !== null && wchBatteryString3Fused <= jsonTestPsInspectionReports.batteryString3Fused.length) {
          wchBatteryString3Fused = jsonTestPsInspectionReports.batteryString3Fused.length;
        }
        if (jsonTestPsInspectionReports.batteryString4Fused !== null && wchBatteryString4Fused <= jsonTestPsInspectionReports.batteryString4Fused.length) {
          wchBatteryString4Fused = jsonTestPsInspectionReports.batteryString4Fused.length;
        }
        if (jsonTestPsInspectionReports.tamperInstalledFunctioning !== null && wchTamperInstalledFunctioning <= jsonTestPsInspectionReports.tamperInstalledFunctioning.length) {
          wchTamperInstalledFunctioning = jsonTestPsInspectionReports.tamperInstalledFunctioning.length;
        }
        if (jsonTestPsInspectionReports.checkLaps !== null && wchCheckLaps <= jsonTestPsInspectionReports.checkLaps.length) {
          wchCheckLaps = jsonTestPsInspectionReports.checkLaps.length;
        }
        if (jsonTestPsInspectionReports.cabinetVendor !== null && wchCabinetVendor <= jsonTestPsInspectionReports.cabinetVendor.length) {
          wchCabinetVendor = jsonTestPsInspectionReports.cabinetVendor.length;
        }
        if (jsonTestPsInspectionReports.cabinetBatteryCapacity !== null && wchCabinetBatteryCapacity <= jsonTestPsInspectionReports.cabinetBatteryCapacity.length) {
          wchCabinetBatteryCapacity = jsonTestPsInspectionReports.cabinetBatteryCapacity.length;
        }
        if (jsonTestPsInspectionReports.checkOperatingLights !== null && wchCheckOperatingLights <= jsonTestPsInspectionReports.checkOperatingLights.length) {
          wchCheckOperatingLights = jsonTestPsInspectionReports.checkOperatingLights.length;
        }
        if (jsonTestPsInspectionReports.standByOperation !== null && wchStandByOperation <= jsonTestPsInspectionReports.standByOperation.length) {
          wchStandByOperation = jsonTestPsInspectionReports.standByOperation.length;
        }
        if (jsonTestPsInspectionReports.remoteStandbyOperation2 !== null && wchRemoteStandbyOperation2 <= jsonTestPsInspectionReports.remoteStandbyOperation2.length) {
          wchRemoteStandbyOperation2 = jsonTestPsInspectionReports.remoteStandbyOperation2.length;
        }
        if (jsonTestPsInspectionReports.remoteStandbyOperation3 !== null && wchRemoteStandbyOperation3 <= jsonTestPsInspectionReports.remoteStandbyOperation3.length) {
          wchRemoteStandbyOperation3 = jsonTestPsInspectionReports.remoteStandbyOperation3.length;
        }
        if (jsonTestPsInspectionReports.remoteStandbyOperation4 !== null && wchRemoteStandbyOperation4 <= jsonTestPsInspectionReports.remoteStandbyOperation4.length) {
          wchRemoteStandbyOperation4 = jsonTestPsInspectionReports.remoteStandbyOperation4.length;
        }
        if (jsonTestPsInspectionReports.remoteStandbyOperation5 !== null && wchRemoteStandbyOperation5 <= jsonTestPsInspectionReports.remoteStandbyOperation5.length) {
          wchRemoteStandbyOperation5 = jsonTestPsInspectionReports.remoteStandbyOperation5.length;
        }
        if (jsonTestPsInspectionReports.followUpNeeded !== null && wchFollowUpNeeded <= jsonTestPsInspectionReports.followUpNeeded.length) {
          wchFollowUpNeeded = jsonTestPsInspectionReports.followUpNeeded.length;
        }
        if (jsonTestPsInspectionReports.inputSurgeArrestor !== null && wchInputSurgeArrestor <= jsonTestPsInspectionReports.inputSurgeArrestor.length) {
          wchInputSurgeArrestor = jsonTestPsInspectionReports.inputSurgeArrestor.length;
        }
        if (jsonTestPsInspectionReports.outputSurgeArrestor !== null && wchOutputSurgeArrestor <= jsonTestPsInspectionReports.outputSurgeArrestor.length) {
          wchOutputSurgeArrestor = jsonTestPsInspectionReports.outputSurgeArrestor.length;
        }
        if (jsonTestPsInspectionReports.coaxTvssPresent !== null && wchCoaxTvssPresent <= jsonTestPsInspectionReports.coaxTvssPresent.length) {
          wchCoaxTvssPresent = jsonTestPsInspectionReports.coaxTvssPresent.length;
        }
        if (jsonTestPsInspectionReports.acIndicatorGreenLight !== null && wchAcIndicatorGreenLight <= jsonTestPsInspectionReports.acIndicatorGreenLight.length) {
          wchAcIndicatorGreenLight = jsonTestPsInspectionReports.acIndicatorGreenLight.length;
        }
        if (jsonTestPsInspectionReports.localRemoteIndicator !== null && wchLocalRemoteIndicator <= jsonTestPsInspectionReports.localRemoteIndicator.length) {
          wchLocalRemoteIndicator = jsonTestPsInspectionReports.localRemoteIndicator.length;
        }
        if (jsonTestPsInspectionReports.commTech !== null && wchCommTech <= jsonTestPsInspectionReports.commTech.length) {
          wchCommTech = jsonTestPsInspectionReports.commTech.length;
        }
      });
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId },
        { header: 'RegionName', key: 'regionName', width: wchRegionName },
        { header: 'HeadendName', key: 'headendName', width: wchHeadendName },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName },
        { header: 'Name', key: 'name', width: wchName },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
        { header: 'IP', key: 'ip', width: wchIp },
        { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
        { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: wchPowerSupplyAddress },
        { header: 'CrossStreet', key: 'crossStreet', width: wchCrossStreet },
        { header: 'City', key: 'city', width: wchCity },
        { header: 'State', key: 'state', width: wchState },
        { header: 'Zip', key: 'zip', width: wchZip },
        { header: 'Node2', key: 'node2', width: wchNode2 },
        { header: 'Node3', key: 'node3', width: wchNode3 },
        { header: 'Node4', key: 'node4', width: wchNode4 },
        { header: 'Node5', key: 'node5', width: wchNode5 },
        { header: 'Node6', key: 'node6', width: wchNode6 },
        { header: 'Node7', key: 'node7', width: wchNode7 },
        { header: 'Node8', key: 'node8', width: wchNode8 },
        { header: 'Node9', key: 'node9', width: wchNode9 },
        { header: 'Node10', key: 'node10', width: wchNode10 },
        { header: 'Node11', key: 'node11', width: wchNode11 },
        { header: 'Node12', key: 'node12', width: wchNode12 },
        { header: 'Node13', key: 'node13', width: wchNode13 },
        { header: 'Node14', key: 'node14', width: wchNode14 },
        { header: 'Node15', key: 'node15', width: wchNode15 },
        { header: 'InspectionDate', key: 'inspectionDate', width: wchInspectionDate },
        { header: 'TypeOfVisit', key: 'typeOfVisit', width: wchTypeOfVisit },
        { header: 'XocVerified', key: 'xocVerified', width: wchXocVerified },
        { header: 'CleanEnclosure', key: 'cleanEnclosure', width: wchCleanEnclosure },
        { header: 'TightenHardware', key: 'tightenHardware', width: wchTightenHardware },
        { header: 'InspectConnectors', key: 'inspectConnectors', width: wchInspectConnectors },
        { header: 'InspectProbes', key: 'inspectProbes', width: wchInspectProbes },
        { header: 'MeterPanCondition', key: 'meterPanCondition', width: wchMeterPanCondition },
        { header: 'PowerCoRiserCondition', key: 'powerCoRiserCondition', width: wchPowerCoRiserCondition },
        { header: 'BatteryHeaterMatType', key: 'batteryHeaterMatType', width: wchBatteryHeaterMatType },
        { header: 'BatteryHeaterMatQuantity', key: 'batteryHeaterMatQuantity', width: wchBatteryHeaterMatQuantity },
        { header: 'EnclosureSnowShield', key: 'enclosureSnowShield', width: wchEnclosureSnowShield },
        { header: 'InternalBreaker', key: 'internalBreaker', width: wchInternalBreaker },
        { header: 'ServiceEntrance', key: 'serviceEntrance', width: wchServiceEntrance },
        { header: 'ReceptacleType', key: 'receptacleType', width: wchReceptacleType },
        { header: 'CheckSeizureAltBox', key: 'checkSeizureAltBox', width: wchCheckSeizureAltBox },
        { header: 'PowerSupplyIdLegible', key: 'powerSupplyIdLegible', width: wchPowerSupplyIdLegible },
        { header: 'CheckLampsLeds', key: 'checkLampsLeds', width: wchCheckLampsLeds },
        { header: 'CheckMagneticBreaker', key: 'checkMagneticBreaker', width: wchCheckMagneticBreaker },
        { header: 'VisualCabinetInspection', key: 'visualCabinetInspection', width: wchVisualCabinetInspection },
        { header: 'CabinetLocked', key: 'cabinetLocked', width: wchCabinetLocked },
        { header: 'SecurityBarPresent', key: 'securityBarPresent', width: wchSecurityBarPresent },
        { header: 'CheckGroundCabinet', key: 'checkGroundCabinet', width: wchCheckGroundCabinet },
        { header: 'BatteryString1Fused', key: 'batteryString1Fused', width: wchBatteryString1Fused },
        { header: 'BatteryString2Fused', key: 'batteryString2Fused', width: wchBatteryString2Fused },
        { header: 'BatteryString3Fused', key: 'batteryString3Fused', width: wchBatteryString3Fused },
        { header: 'BatteryString4Fused', key: 'batteryString4Fused', width: wchBatteryString4Fused },
        { header: 'TamperInstalledFunctioning', key: 'tamperInstalledFunctioning', width: wchTamperInstalledFunctioning },
        { header: 'CheckLaps', key: 'checkLaps', width: wchCheckLaps },
        { header: 'CabinetVendor', key: 'cabinetVendor', width: wchCabinetVendor },
        { header: 'CabinetBatteryCapacity', key: 'cabinetBatteryCapacity', width: wchCabinetBatteryCapacity },
        { header: 'CheckOperatingLights', key: 'checkOperatingLights', width: wchCheckOperatingLights },
        { header: 'StandByOperation', key: 'standByOperation', width: wchStandByOperation },
        { header: 'RemoteStandbyOperation2', key: 'remoteStandbyOperation2', width: wchRemoteStandbyOperation2 },
        { header: 'RemoteStandbyOperation3', key: 'remoteStandbyOperation3', width: wchRemoteStandbyOperation3 },
        { header: 'RemoteStandbyOperation4', key: 'remoteStandbyOperation4', width: wchRemoteStandbyOperation4 },
        { header: 'RemoteStandbyOperation5', key: 'remoteStandbyOperation5', width: wchRemoteStandbyOperation5 },
        { header: 'FollowUpNeeded', key: 'followUpNeeded', width: wchFollowUpNeeded },
        { header: 'InputSurgeArrestor', key: 'inputSurgeArrestor', width: wchInputSurgeArrestor },
        { header: 'OutputSurgeArrestor', key: 'outputSurgeArrestor', width: wchOutputSurgeArrestor },
        { header: 'CoaxTvssPresent', key: 'coaxTvssPresent', width: wchCoaxTvssPresent },
        { header: 'AcIndicatorGreenLight', key: 'acIndicatorGreenLight', width: wchAcIndicatorGreenLight },
        { header: 'LocalRemoteIndicator', key: 'localRemoteIndicator', width: wchLocalRemoteIndicator },
        { header: 'CommTech', key: 'commTech', width: wchCommTech }
      ]
    }
    if (fileType === 'POWERSUPPLY') {
      let wchPowerSupplyId = 14;
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchName = 5;
      let wchPowerSupplyName = 20;
      let wchIp = 3;
      let wchMacAddress = 11;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 5;
      let wchState = 6;
      let wchZip = 4;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchDeviceId = 9;
      let wchPowerSupplyModel = 17;
      let wchSerialNumber = 13;
      let wchPowerSupplyEventCount = 21;
      let wchPowerSupplyEventTime = 21;
      let wchEventLogCleared = 17;
      let wchTotalRunDays = 13;
      let wchACInputVoltage = 15;
      let wchOutputVoltage = 14;
      let wchCurrentAmpOutput = 17;
      let wchPimAlphaDocInstalled = 21;
      let wchAlphaAppsCardInstalled = 23;
      //let wchControllerCardType = 19;
      let wchDcReady = 8;
      let wchOutputCurrentAmps1 = 19;
      let wchOutputCurrentAmps2 = 19;
      let wchFirmwareVersion = 16;
      let wchCpnDateCode = 12;
      let wchRefurbDate = 11;
      let wchEgisName = 9;
      let wchDeviceId2 = 10;
      let wchModel2 = 18;
      let wchSerialNumber2 = 14;
      let wchPowerSupplyEventCount2 = 22;
      let wchPowerSupplyEventTime2 = 22;
      let wchEventLogCleared2 = 18;
      let wchTotalRunDays2 = 14;
      let wchACInputVoltage2 = 16;
      let wchOutputVoltage2 = 15;
      let wchCurrentAmpOutput2 = 18;
      let wchPimAlphaDocInstalled2 = 22;
      let wchAlphaAppsCardInstalled2 = 24;
      //let wchControllerCardType2 = 20;
      let wchDcReady2 = 9;
      let wchOutputCurrentAmps12 = 20;
      let wchOutputCurrentAmps22 = 20;
      let wchFirmwareVersion2 = 17;
      let wchCpnDateCode2 = 13;
      let wchRefurbDate2 = 12;
      let wchDeviceId3 = 10;
      let wchModel3 = 7;
      let wchSerialNumber3 = 14;
      let wchPowerSupplyEventCount3 = 22;
      let wchPowerSupplyEventTime3 = 22;
      let wchEventLogCleared3 = 17;
      let wchTotalRunDays3 = 14;
      let wchACInputVoltage3 = 16;
      let wchOutputVoltage3 = 15;
      let wchCurrentAmpOutput3 = 18;
      let wchPimAlphaDocInstalled3 = 22;
      let wchAlphaAppsCardInstalled3 = 24;
      //let wchControllerCardType3 = 20;
      let wchDcReady3 = 9;
      let wchOutputCurrentAmps13 = 20;
      let wchOutputCurrentAmps23 = 20;
      let wchFirmwareVersion3 = 17;
      let wchCpnDateCode3 = 13;
      let wchRefurbDate3 = 11;
      let wchDeviceId4 = 10;
      let wchModel4 = 7;
      let wchSerialNumber4 = 14;
      let wchPowerSupplyEventCount4 = 21;
      let wchPowerSupplyEventTime4 = 20;
      let wchEventLogCleared4 = 17;
      let wchTotalRunDays4 = 14;
      let wchACInputVoltage4 = 16;
      let wchOutputVoltage4 = 14;
      let wchCurrentAmpOutput4 = 18;
      let wchPimAlphaDocInstalled4 = 22;
      let wchAlphaAppsCardInstalled4 = 23;
      //let wchControllerCardType4 = 20;
      let wchDcReady4 = 9;
      let wchOutputCurrentAmps14 = 20;
      let wchOutputCurrentAmps24 = 20;
      let wchFirmwareVersion4 = 17;
      let wchCpnDateCode4 = 12;
      let wchRefurbDate4 = 12;
      let wchDeviceId5 = 10;
      let wchModel5 = 7;
      let wchSerialNumber5 = 14;
      let wchPowerSupplyEventCount5 = 22;
      let wchPowerSupplyEventTime5 = 22;
      let wchEventLogCleared5 = 17;
      let wchTotalRunDays5 = 14;
      let wchACInputVoltage5 = 16;
      let wchOutputVoltage5 = 15;
      let wchCurrentAmpOutput5 = 18;
      let wchPimAlphaDocInstalled5 = 22;
      let wchAlphaAppsCardInstalled5 = 24;
      //let wchControllerCardType5 = 20;
      let wchDcReady5 = 9;
      let wchOutputCurrentAmps15 = 20;
      let wchOutputCurrentAmps25 = 20;
      let wchFirmwareVersion5 = 17;
      let wchCpnDateCode5 = 13;
      let wchRefurbDate5 = 12;

      let wchCurrentAmpRating2 = 15;
      let wchPowerSupplyAlertProfile2 = 15;
      let wchEgisNumber2 = 15;
      let wchGlobalId2 = 15;


      let wchCurrentAmpRating3 = 15;
      let wchPowerSupplyAlertProfile3 = 15;
      let wchEgisNumber3 = 15;
      let wchGlobalId3 = 15;

      json.forEach(jsonTestPsApuReports => {
        if (jsonTestPsApuReports.powerSupplyId !== null && wchPowerSupplyId <= jsonTestPsApuReports.powerSupplyId.toString.length) {
          wchPowerSupplyId = jsonTestPsApuReports.powerSupplyId.toString.length;
        }
        if (jsonTestPsApuReports.regionName !== null && wchRegionName <= jsonTestPsApuReports.regionName.length) {
          wchRegionName = jsonTestPsApuReports.regionName.length;
        }
        if (jsonTestPsApuReports.headendName !== null && wchHeadendName <= jsonTestPsApuReports.headendName.length) {
          wchHeadendName = jsonTestPsApuReports.headendName.length;
        }
        if (jsonTestPsApuReports.communityName !== null && wchCommunityName <= jsonTestPsApuReports.communityName.length) {
          wchCommunityName = jsonTestPsApuReports.communityName.length;
        }
        if (jsonTestPsApuReports.name !== null && wchName <= jsonTestPsApuReports.name.length) {
          wchName = jsonTestPsApuReports.name.length;
        }
        if (jsonTestPsApuReports.ip !== null && wchIp <= jsonTestPsApuReports.ip.length) {
          wchIp = jsonTestPsApuReports.ip.length;
        }
        if (jsonTestPsApuReports.macAddress !== null && wchMacAddress <= jsonTestPsApuReports.macAddress.length) {
          wchMacAddress = jsonTestPsApuReports.macAddress.length;
        }
        if (jsonTestPsApuReports.houseNumber !== null && wchHouseNumber <= jsonTestPsApuReports.houseNumber.length) {
          wchHouseNumber = jsonTestPsApuReports.houseNumber.length;
        }
        if (jsonTestPsApuReports.city !== null && wchCity <= jsonTestPsApuReports.city.length) {
          wchCity = jsonTestPsApuReports.city.length;
        }
        if (jsonTestPsApuReports.state !== null && wchState <= jsonTestPsApuReports.state.length) {
          wchState = jsonTestPsApuReports.state.length;
        }
        if (jsonTestPsApuReports.zip !== null && wchZip <= jsonTestPsApuReports.zip.length) {
          wchZip = jsonTestPsApuReports.zip.length;
        }
        if (jsonTestPsApuReports.node2 !== null && wchNode2 <= jsonTestPsApuReports.node2.length) {
          wchNode2 = jsonTestPsApuReports.node2.length;
        }
        if (jsonTestPsApuReports.node3 !== null && wchNode3 <= jsonTestPsApuReports.node3.length) {
          wchNode3 = jsonTestPsApuReports.node3.length;
        }
        if (jsonTestPsApuReports.node4 !== null && wchNode4 <= jsonTestPsApuReports.node4.length) {
          wchNode4 = jsonTestPsApuReports.node4.length;
        }
        if (jsonTestPsApuReports.node5 !== null && wchNode5 <= jsonTestPsApuReports.node5.length) {
          wchNode5 = jsonTestPsApuReports.node5.length;
        }
        if (jsonTestPsApuReports.node6 !== null && wchNode6 <= jsonTestPsApuReports.node6.length) {
          wchNode6 = jsonTestPsApuReports.node6.length;
        }
        if (jsonTestPsApuReports.node7 !== null && wchNode7 <= jsonTestPsApuReports.node7.length) {
          wchNode7 = jsonTestPsApuReports.node7.length;
        }
        if (jsonTestPsApuReports.node8 !== null && wchNode8 <= jsonTestPsApuReports.node8.length) {
          wchNode8 = jsonTestPsApuReports.node8.length;
        }
        if (jsonTestPsApuReports.node9 !== null && wchNode9 <= jsonTestPsApuReports.node9.length) {
          wchNode9 = jsonTestPsApuReports.node9.length;
        }
        if (jsonTestPsApuReports.node10 !== null && wchNode10 <= jsonTestPsApuReports.node10.length) {
          wchNode10 = jsonTestPsApuReports.node10.length;
        }
        if (jsonTestPsApuReports.node11 !== null && wchNode11 <= jsonTestPsApuReports.node11.length) {
          wchNode11 = jsonTestPsApuReports.node11.length;
        }
        if (jsonTestPsApuReports.node12 !== null && wchNode12 <= jsonTestPsApuReports.node12.length) {
          wchNode12 = jsonTestPsApuReports.node12.length;
        }
        if (jsonTestPsApuReports.node13 !== null && wchNode13 <= jsonTestPsApuReports.node13.length) {
          wchNode13 = jsonTestPsApuReports.node13.length;
        }
        if (jsonTestPsApuReports.node14 !== null && wchNode14 <= jsonTestPsApuReports.node14.length) {
          wchNode14 = jsonTestPsApuReports.node14.length;
        }
        if (jsonTestPsApuReports.node15 !== null && wchNode15 <= jsonTestPsApuReports.node15.length) {
          wchNode15 = jsonTestPsApuReports.node15.length;
        }
        if (jsonTestPsApuReports.deviceId !== null && wchDeviceId <= jsonTestPsApuReports.deviceId.length) {
          wchDeviceId = jsonTestPsApuReports.deviceId.length;
        }
        if (jsonTestPsApuReports.powerSupplyModel !== null && wchPowerSupplyModel <= jsonTestPsApuReports.powerSupplyModel.length) {
          wchPowerSupplyModel = jsonTestPsApuReports.powerSupplyModel.length;
        }
        if (jsonTestPsApuReports.serialNumber !== null && wchSerialNumber <= jsonTestPsApuReports.serialNumber.length) {
          wchSerialNumber = jsonTestPsApuReports.serialNumber.length;
        }
        if (jsonTestPsApuReports.powerSupplyEventCount !== null && wchPowerSupplyEventCount <= jsonTestPsApuReports.powerSupplyEventCount.length) {
          wchPowerSupplyEventCount = jsonTestPsApuReports.powerSupplyEventCount.length;
        }
        if (jsonTestPsApuReports.powerSupplyEventTime !== null && wchPowerSupplyEventTime <= jsonTestPsApuReports.powerSupplyEventTime.length) {
          wchPowerSupplyEventTime = jsonTestPsApuReports.powerSupplyEventTime.length;
        }
        if (jsonTestPsApuReports.eventLogCleared !== null && wchEventLogCleared <= jsonTestPsApuReports.eventLogCleared.length) {
          wchEventLogCleared = jsonTestPsApuReports.eventLogCleared.length;
        }
        if (jsonTestPsApuReports.totalRunDays !== null && wchTotalRunDays <= jsonTestPsApuReports.totalRunDays.length) {
          wchTotalRunDays = jsonTestPsApuReports.totalRunDays.length;
        }
        if (jsonTestPsApuReports.acInputVoltage !== null && wchACInputVoltage <= jsonTestPsApuReports.acInputVoltage.length) {
          wchACInputVoltage = jsonTestPsApuReports.acInputVoltage.length;
        }
        if (jsonTestPsApuReports.outputVoltage !== null && wchOutputVoltage <= jsonTestPsApuReports.outputVoltage.length) {
          wchOutputVoltage = jsonTestPsApuReports.outputVoltage.length;
        }
        if (jsonTestPsApuReports.currentAmpOutput !== null && wchCurrentAmpOutput <= jsonTestPsApuReports.currentAmpOutput.length) {
          wchCurrentAmpOutput = jsonTestPsApuReports.currentAmpOutput.length;
        }
        if (jsonTestPsApuReports.pimAlphaDocInstalled !== null && wchPimAlphaDocInstalled <= jsonTestPsApuReports.pimAlphaDocInstalled.length) {
          wchPimAlphaDocInstalled = jsonTestPsApuReports.pimAlphaDocInstalled.length;
        }
        if (jsonTestPsApuReports.alphaAppsCardInstalled !== null && wchAlphaAppsCardInstalled <= jsonTestPsApuReports.alphaAppsCardInstalled.length) {
          wchAlphaAppsCardInstalled = jsonTestPsApuReports.alphaAppsCardInstalled.length;
        }
        // if (jsonTestPsApuReports.controllerCardType !== null && wchControllerCardType <= jsonTestPsApuReports.controllerCardType.length) {
        //   wchControllerCardType = jsonTestPsApuReports.controllerCardType.length;
        // }
        if (jsonTestPsApuReports.dcReady !== null && wchDcReady <= jsonTestPsApuReports.dcReady.length) {
          wchDcReady = jsonTestPsApuReports.dcReady.length;
        }
        if (jsonTestPsApuReports.outputCurrentAmps1 !== null && wchOutputCurrentAmps1 <= jsonTestPsApuReports.outputCurrentAmps1.length) {
          wchOutputCurrentAmps1 = jsonTestPsApuReports.outputCurrentAmps1.length;
        }
        if (jsonTestPsApuReports.outputCurrentAmps2 !== null && wchOutputCurrentAmps2 <= jsonTestPsApuReports.outputCurrentAmps2.length) {
          wchOutputCurrentAmps2 = jsonTestPsApuReports.outputCurrentAmps2.length;
        }
        if (jsonTestPsApuReports.firmwareVersion !== null && wchFirmwareVersion <= jsonTestPsApuReports.firmwareVersion.length) {
          wchFirmwareVersion = jsonTestPsApuReports.firmwareVersion.length;
        }
        if (jsonTestPsApuReports.cpnDateCode !== null && wchCpnDateCode <= jsonTestPsApuReports.cpnDateCode.length) {
          wchCpnDateCode = jsonTestPsApuReports.cpnDateCode.length;
        }
        if (jsonTestPsApuReports.refurbDate !== null && wchRefurbDate <= jsonTestPsApuReports.refurbDate.length) {
          wchRefurbDate = jsonTestPsApuReports.refurbDate.length;
        }
        if (jsonTestPsApuReports.egisName !== null && wchEgisName <= jsonTestPsApuReports.egisName.length) {
          wchEgisName = jsonTestPsApuReports.egisName.length;
        }
        //if (jsonTestPsApuReports.deviceId2 !== null && wchDeviceId2 <= jsonTestPsApuReports.deviceId2.length) {
         // wchDeviceId2 = jsonTestPsApuReports.deviceId2.length;
       // }
        if (jsonTestPsApuReports.model2 !== null && wchModel2 <= jsonTestPsApuReports.model2.length) {
          wchModel2 = jsonTestPsApuReports.model2.length;
        }
        if (jsonTestPsApuReports.serialNumber2 !== null && wchSerialNumber2 <= jsonTestPsApuReports.serialNumber2.length) {
          wchSerialNumber2 = jsonTestPsApuReports.serialNumber2.length;
        }
        if (jsonTestPsApuReports.acInputVoltage2 !== null && wchACInputVoltage2 <= jsonTestPsApuReports.acInputVoltage2.length) {
          wchACInputVoltage2 = jsonTestPsApuReports.acInputVoltage2.length;
        }
        if (jsonTestPsApuReports.outputVoltage2 !== null && wchOutputVoltage2 <= jsonTestPsApuReports.outputVoltage2.length) {
          wchOutputVoltage2 = jsonTestPsApuReports.outputVoltage2.length;
        }

        if (jsonTestPsApuReports.currentAmpRating2 !== null && wchCurrentAmpRating2 <= jsonTestPsApuReports.currentAmpRating2.length) {
          wchCurrentAmpRating2 = jsonTestPsApuReports.currentAmpRating2.length;
        }
        if (jsonTestPsApuReports.powerSupplyAlertProfile2 !== null && wchPowerSupplyAlertProfile2 <= jsonTestPsApuReports.powerSupplyAlertProfile2.length) {
          wchPowerSupplyAlertProfile2 = jsonTestPsApuReports.powerSupplyAlertProfile2.length;
        }
        if (jsonTestPsApuReports.egisNumber2 !== null && wchEgisNumber2 <= jsonTestPsApuReports.egisNumber2.length) {
          wchEgisNumber2 = jsonTestPsApuReports.egisNumber2.length;
        }
        if (jsonTestPsApuReports.globalId2 !== null && wchGlobalId2 <= jsonTestPsApuReports.globalId2.length) {
          wchGlobalId2 = jsonTestPsApuReports.globalId2.length;
        }

        if (jsonTestPsApuReports.model3 !== null && wchModel3 <= jsonTestPsApuReports.model3.length) {
          wchModel3 = jsonTestPsApuReports.model3.length;
        }
        if (jsonTestPsApuReports.serialNumber3 !== null && wchSerialNumber3 <= jsonTestPsApuReports.serialNumber3.length) {
          wchSerialNumber3 = jsonTestPsApuReports.serialNumber3.length;
        }

        if (jsonTestPsApuReports.currentAmpRating3 !== null && wchCurrentAmpRating3 <= jsonTestPsApuReports.currentAmpRating3.length) {
          wchCurrentAmpRating3 = jsonTestPsApuReports.currentAmpRating3.length;
        }
        if (jsonTestPsApuReports.powerSupplyAlertProfile3 !== null && wchPowerSupplyAlertProfile3 <= jsonTestPsApuReports.powerSupplyAlertProfile3.length) {
          wchPowerSupplyAlertProfile3 = jsonTestPsApuReports.powerSupplyAlertProfile3.length;
        }
        if (jsonTestPsApuReports.egisNumber3 !== null && wchEgisNumber3 <= jsonTestPsApuReports.egisNumber3.length) {
          wchEgisNumber3 = jsonTestPsApuReports.egisNumber3.length;
        }
        if (jsonTestPsApuReports.globalId3 !== null && wchGlobalId3 <= jsonTestPsApuReports.globalId3.length) {
          wchGlobalId3 = jsonTestPsApuReports.globalId3.length;
        }


      });
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId },
        { header: 'RegionName', key: 'regionName', width: wchRegionName },
        { header: 'HeadendName', key: 'headendName', width: wchHeadendName },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName },
        { header: 'Name', key: 'name', width: wchName },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
        { header: 'IP', key: 'ip', width: wchIp },
        { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
        { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: wchPowerSupplyAddress },
        { header: 'CrossStreet', key: 'crossStreet', width: wchCrossStreet },
        { header: 'City', key: 'city', width: wchCity },
        { header: 'State', key: 'state', width: wchState },
        { header: 'Zip', key: 'zip', width: wchZip },
        { header: 'Node2', key: 'node2', width: wchNode2 },
        { header: 'Node3', key: 'node3', width: wchNode3 },
        { header: 'Node4', key: 'node4', width: wchNode4 },
        { header: 'Node5', key: 'node5', width: wchNode5 },
        { header: 'Node6', key: 'node6', width: wchNode6 },
        { header: 'Node7', key: 'node7', width: wchNode7 },
        { header: 'Node8', key: 'node8', width: wchNode8 },
        { header: 'Node9', key: 'node9', width: wchNode9 },
        { header: 'Node10', key: 'node10', width: wchNode10 },
        { header: 'Node11', key: 'node11', width: wchNode11 },
        { header: 'Node12', key: 'node12', width: wchNode12 },
        { header: 'Node13', key: 'node13', width: wchNode13 },
        { header: 'Node14', key: 'node14', width: wchNode14 },
        { header: 'Node15', key: 'node15', width: wchNode15 },
        { header: 'DeviceId', key: 'deviceId', width: wchDeviceId },
        { header: 'PowerSupplyModel', key: 'powerSupplyModel', width: wchPowerSupplyModel },
        { header: 'SerialNumber', key: 'serialNumber', width: wchSerialNumber },
        //{ header: 'PowerSupplyEventCount', key: 'powerSupplyEventCount', width: wchPowerSupplyEventCount },
        //{ header: 'PowerSupplyEventTime', key: 'powerSupplyEventTime', width: wchPowerSupplyEventTime },
        //{ header: 'EventLogCleared', key: 'eventLogCleared', width: wchEventLogCleared },
        { header: 'totalRunDays', key: 'totalRunDays', width: wchTotalRunDays },
        { header: 'ACInputVoltage', key: 'acInputVoltage', width: wchACInputVoltage },
        { header: 'OutputVoltage', key: 'outputVoltage', width: wchOutputVoltage },
        { header: 'CurrentAmpOutput', key: 'currentAmpOutput', width: wchCurrentAmpOutput },
        //{ header: 'PimAlphaDocInstalled', key: 'pimAlphaDocInstalled', width: wchPimAlphaDocInstalled },
        //{ header: 'AlphaAppsCardInstalled', key: 'alphaAppsCardInstalled', width: wchAlphaAppsCardInstalled },
        // { header: 'ControllerCardType', key: 'controllerCardType', width: wchControllerCardType },
        { header: 'DcReady', key: 'dcReady', width: wchDcReady },
        //{ header: 'OutputCurrentAmps1', key: 'outputCurrentAmps1', width: wchOutputCurrentAmps1 },
        //{ header: 'OutputCurrentAmps2', key: 'outputCurrentAmps2', width: wchOutputCurrentAmps2 },
        //{ header: 'FirmwareVersion', key: 'firmwareVersion', width: wchFirmwareVersion },
        //{ header: 'CpnDateCode', key: 'cpnDateCode', width: wchCpnDateCode },
        //{ header: 'RefurbDate', key: 'refurbDate', width: wchRefurbDate },
        { header: 'EgisName', key: 'egisName', width: wchEgisName },
        // { header: 'DeviceId2', key: 'deviceId2', width: wchDeviceId2 },
        { header: 'Model2', key: 'model2', width: wchModel2 },
        { header: 'SerialNumber2', key: 'serialNumber2', width: wchSerialNumber2 },
        //{ header: 'PowerSupplyEventCount2', key: 'powerSupplyEventCount2', width: wchPowerSupplyEventCount2 },
        //{ header: 'PowerSupplyEventTime2', key: 'powerSupplyEventTime2', width: wchPowerSupplyEventTime2 },
        //{ header: 'EventLogCleared2', key: 'eventLogCleared2', width: wchEventLogCleared2 },
        //{ header: 'totalRunDays2', key: 'totalRunDays2', width: wchTotalRunDays2 },
        { header: 'ACInputVoltage2', key: 'acInputVoltage2', width: wchACInputVoltage2 },
        { header: 'OutputVoltage2', key: 'outputVoltage2', width: wchOutputVoltage2 },

        { header: 'CurrentAmpRating2', key: 'currentAmpRating2', width: wchCurrentAmpRating2 },
        { header: 'PowerSupplyAlertProfile2', key: 'powerSupplyAlertProfile2', width: wchPowerSupplyAlertProfile2 },
        { header: 'EgisNumber2', key: 'egisNumber2', width: wchEgisNumber2 },
        { header: 'GlobalId2', key: 'globalId2', width: wchGlobalId2 },




        //{ header: 'CurrentAmpOutput2', key: 'currentAmpOutput2', width: wchCurrentAmpOutput2 },
        //{ header: 'PimAlphaDocInstalled2', key: 'pimAlphaDocInstalled2', width: wchPimAlphaDocInstalled2 },
        //{ header: 'AlphaAppsCardInstalled2', key: 'alphaAppsCardInstalled2', width: wchAlphaAppsCardInstalled2 },
        //{ header: 'ControllerCardType2', key: 'controllerCardType2', width: wchControllerCardType2 },
        //{ header: 'DcReady2', key: 'dcReady2', width: wchDcReady2 },
        //{ header: 'OutputCurrentAmps12', key: 'outputCurrentAmps12', width: wchOutputCurrentAmps12 },
        //{ header: 'OutputCurrentAmps22', key: 'outputCurrentAmps22', width: wchOutputCurrentAmps22 },
        //{ header: 'FirmwareVersion2', key: 'firmwareVersion2', width: wchFirmwareVersion2 },
        //{ header: 'CpnDateCode2', key: 'cpnDateCode2', width: wchCpnDateCode2 },
        //{ header: 'RefurbDate2', key: 'refurbDate2', width: wchRefurbDate2 },
        //{ header: 'DeviceId3', key: 'deviceId3', width: wchDeviceId3 },
        { header: 'Model3', key: 'model3', width: wchModel3 },
        { header: 'SerialNumber3', key: 'serialNumber3', width: wchSerialNumber3 },
        //{ header: 'PowerSupplyEventCount3', key: 'powerSupplyEventCount3', width: wchPowerSupplyEventCount3 },
        //{ header: 'PowerSupplyEventTime3', key: 'powerSupplyEventTime3', width: wchPowerSupplyEventTime3 },
        //{ header: 'EventLogCleared3', key: 'eventLogCleared3', width: wchEventLogCleared3 },
        //{ header: 'totalRunDays3', key: 'totalRunDays3', width: wchTotalRunDays3 },
        { header: 'ACInputVoltage3', key: 'acInputVoltage3', width: wchACInputVoltage3 },
        { header: 'OutputVoltage3', key: 'outputVoltage3', width: wchOutputVoltage3 },

        { header: 'CurrentAmpRating3', key: 'currentAmpRating3', width: wchCurrentAmpRating3 },
        { header: 'PowerSupplyAlertProfile3', key: 'powerSupplyAlertProfile3', width: wchPowerSupplyAlertProfile3 },
        { header: 'EgisNumber3', key: 'egisNumber3', width: wchEgisNumber3 },
        { header: 'GlobalId3', key: 'globalId3', width: wchGlobalId3 },

        //{ header: 'CurrentAmpOutput3', key: 'currentAmpOutput3', width: wchCurrentAmpOutput3 },
        //{ header: 'PimAlphaDocInstalled3', key: 'pimAlphaDocInstalled3', width: wchPimAlphaDocInstalled3 },
        //{ header: 'AlphaAppsCardInstalled3', key: 'alphaAppsCardInstalled3', width: wchAlphaAppsCardInstalled3 },
        //{ header: 'ControllerCardType3', key: 'controllerCardType3', width: wchControllerCardType3 },
        //{ header: 'DcReady3', key: 'dcReady3', width: wchDcReady3 },
        //{ header: 'OutputCurrentAmps13', key: 'outputCurrentAmps13', width: wchOutputCurrentAmps13 },
        //{ header: 'OutputCurrentAmps23', key: 'outputCurrentAmps23', width: wchOutputCurrentAmps23 },
        //{ header: 'FirmwareVersion3', key: 'firmwareVersion3', width: wchFirmwareVersion3 },
        //{ header: 'CpnDateCode3', key: 'cpnDateCode3', width: wchCpnDateCode3 },
        //{ header: 'RefurbDate3', key: 'refurbDate3', width: wchRefurbDate3 },
        // { header: 'DeviceId4', key: 'deviceId4', width: wchDeviceId4 },
        // { header: 'Model4', key: 'model4', width: wchModel4 },
        // { header: 'SerialNumber4', key: 'serialNumber4', width: wchSerialNumber4 },
        // { header: 'PowerSupplyEventCount4', key: 'powerSupplyEventCount4', width: wchPowerSupplyEventCount4 },
        // { header: 'PowerSupplyEventTime4', key: 'powerSupplyEventTime4', width: wchPowerSupplyEventTime4 },
        // { header: 'EventLogCleared4', key: 'eventLogCleared4', width: wchEventLogCleared4 },
        // { header: 'totalRunDays4', key: 'totalRunDays4', width: wchTotalRunDays4 },
        // { header: 'ACInputVoltage4', key: 'acInputVoltage4', width: wchACInputVoltage4 },
        // { header: 'OutputVoltage4', key: 'outputVoltage4', width: wchOutputVoltage4 },
        // { header: 'CurrentAmpOutput4', key: 'currentAmpOutput4', width: wchCurrentAmpOutput4 },
        // { header: 'PimAlphaDocInstalled4', key: 'pimAlphaDocInstalled4', width: wchPimAlphaDocInstalled4 },
        // { header: 'AlphaAppsCardInstalled4', key: 'alphaAppsCardInstalled4', width: wchAlphaAppsCardInstalled4 },
        // //{ header: 'ControllerCardType4', key: 'controllerCardType4', width: wchControllerCardType4 },
        // { header: 'DcReady4', key: 'dcReady4', width: wchDcReady4 },
        // { header: 'OutputCurrentAmps14', key: 'outputCurrentAmps14', width: wchOutputCurrentAmps14 },
        // { header: 'OutputCurrentAmps24', key: 'outputCurrentAmps24', width: wchOutputCurrentAmps24 },
        // { header: 'FirmwareVersion4', key: 'firmwareVersion4', width: wchFirmwareVersion4 },
        // { header: 'CpnDateCode4', key: 'cpnDateCode4', width: wchCpnDateCode4 },
        // { header: 'RefurbDate4', key: 'refurbDate4', width: wchRefurbDate4 },
        // { header: 'DeviceId5', key: 'deviceId5', width: wchDeviceId5 },
        // { header: 'Model5', key: 'model5', width: wchModel5 },
        // { header: 'SerialNumber5', key: 'serialNumber5', width: wchSerialNumber5 },
        // { header: 'PowerSupplyEventCount5', key: 'powerSupplyEventCount5', width: wchPowerSupplyEventCount5 },
        // { header: 'PowerSupplyEventTime5', key: 'powerSupplyEventTime5', width: wchPowerSupplyEventTime5 },
        // { header: 'EventLogCleared5', key: 'eventLogCleared5', width: wchEventLogCleared5 },
        // { header: 'totalRunDays5', key: 'totalRunDays5', width: wchTotalRunDays5 },
        // { header: 'ACInputVoltage5', key: 'acInputVoltage5', width: wchACInputVoltage5 },
        // { header: 'OutputVoltage5', key: 'outputVoltage5', width: wchOutputVoltage5 },
        // { header: 'CurrentAmpOutput5', key: 'currentAmpOutput5', width: wchCurrentAmpOutput5 },
        // { header: 'PimAlphaDocInstalled5', key: 'pimAlphaDocInstalled5', width: wchPimAlphaDocInstalled5 },
        // { header: 'AlphaAppsCardInstalled5', key: 'alphaAppsCardInstalled5', width: wchAlphaAppsCardInstalled5 },
        // //{ header: 'ControllerCardType5', key: 'controllerCardType5', width: wchControllerCardType5 },
        // { header: 'DcReady5', key: 'dcReady5', width: wchDcReady5 },
        // { header: 'OutputCurrentAmps15', key: 'outputCurrentAmps15', width: wchOutputCurrentAmps15 },
        // { header: 'OutputCurrentAmps25', key: 'outputCurrentAmps25', width: wchOutputCurrentAmps25 },
        // { header: 'FirmwareVersion5', key: 'firmwareVersion5', width: wchFirmwareVersion5 },
        // { header: 'CpnDateCode5', key: 'cpnDateCode5', width: wchCpnDateCode5 },
        // { header: 'RefurbDate5', key: 'refurbDate5', width: wchRefurbDate5 }
      ]
    }
    if (fileType === 'SPATIALNET') {
      //Default Width's
      let egisNumber = 14;
      let latitude = 11;
      let longitude = 11;
      let egisPsName = 14;
      let macAddress = 20;
      let psId = 15;
      let powerSupplyName = 20;

      json.forEach(spatialnetReport => {
        if (spatialnetReport.egisNumber !== null && egisNumber <= spatialnetReport.egisNumber.length) {
          egisNumber = spatialnetReport.egisNumber.length;
        }
        if (spatialnetReport.latitude !== null && latitude <= spatialnetReport.latitude.length) {
          latitude = spatialnetReport.latitude.length;
        }
        if (spatialnetReport.longitude !== null && longitude <= spatialnetReport.longitude.length) {
          longitude = spatialnetReport.longitude.length;
        }
        if (spatialnetReport.egisPsName !== null && egisPsName <= spatialnetReport.egisPsName.length) {
          egisPsName = spatialnetReport.egisPsName.length;
        }
        if (spatialnetReport.macAddress !== null && macAddress <= spatialnetReport.macAddress.length) {
          macAddress = spatialnetReport.macAddress.length;
        }
        if (spatialnetReport.powerSupplyName !== null && powerSupplyName <= spatialnetReport.powerSupplyName.length) {
          powerSupplyName = spatialnetReport.powerSupplyName.length;
        }
      });
      return [
        { header: 'EgisNumber', key: 'egisNumber', width: egisNumber },
        { header: 'Latitude', key: 'latitude', width: latitude },
        { header: 'Longitude', key: 'longitude', width: longitude },
        { header: 'EgisPsName', key: 'egisPsName', width: egisPsName },
        { header: 'MacAddress', key: 'macAddress', width: macAddress },
        { header: 'Power Supply ID', key: 'powerSupplyId', width: psId },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: powerSupplyName }
      ];
    }

    if (fileType === 'RELIABILITY') {
      //Default Width's
      let division = 14;
      let regionName = 11;
      let headendName = 11;
      let communityName = 11;
      let nodeName = 11;
      let powerSupplyId = 11;
      let powerSupplyName = 11;
      let powerSupplyModel = 11;
      let transponderVendor = 11;
      let transponderModel = 15;
      let macAddress = 11;
      let ip = 11;
      let powerSupplyAddress = 11;
      let city = 11;
      let state = 11;
      let zip = 11;
      let gpsLatitude = 11;
      let gpsLongitude = 11;
      let currentStatus = 11;
      let inputVoltage = 11;
      let inputVoltagePresent = 15;
      let outputVoltage = 11;
      let outputCurrent1 = 15;
      let outputCurrent2 = 15;
      let batteryStringVoltage = 15;
      let totalStringsBatteryAlarm = 25;
      let stringsCount = 11;
      let batteriesPerString = 15;
      let totalBatteries = 11;
      let totalBatteryAlarm = 15;
      let type = 11;
      let manufactureDate = 15;
      let inverterStatus = 11;
      let totalInverterAlarm = 15;
      let majorAlarm = 11;
      let totalMajorAlarm = 15;
      let minorAlarm = 11;
      let totalMinorAlarm = 15;
      let tamperAlarm = 11;
      let totalTamperAlarms = 15;
      let createdDate = 30;
      let currentMacFirstSighting = 20;
      let totalOfflineMins = 15;
      let totalOfflineEvents = 15;
      let maxOfflineMins = 11;
      let medianOfflineMins = 20;
      let totalNetworkPowerOfflineMinutes = 30;
      let totalNetworkPowerOfflineEvents = 30;
      let totalCommercialPowerOutageMinutes = 30;
      let networkUptime = 15;
      let commercialPowerUptime = 20;
      let batteryCoverageMinutes = 20;
      let batteryOutageCoverage = 20;
      let standbyEvents = 11;
      let averageMinutesOnBattery = 20;
      let totalMinutesOnBattery = 20;
      let maxMinutesOnBattery = 20;
      let totalAlarms = 11;
      let bootFile = 11;
      let psFw = 11;
      let docFw = 11;
      let appFw = 11;
      let sagFw = 11;
      let avgFailDur = 11;
      let expDur = 11;
      let total = 11;
      let passed = 11;
      let failed = 11;

      json.forEach(reliabilityReport => {
        if (reliabilityReport.division !== null && division <= reliabilityReport.division.length) {
          division = reliabilityReport.division.length;
        }
        if (reliabilityReport.regionName !== null && regionName <= reliabilityReport.regionName.length) {
          regionName = reliabilityReport.regionName.length;
        }
        if (reliabilityReport.headendName !== null && headendName <= reliabilityReport.headendName.length) {
          headendName = reliabilityReport.headendName.length;
        }
        if (reliabilityReport.communityName !== null && communityName <= reliabilityReport.communityName.length) {
          communityName = reliabilityReport.communityName.length;
        }
        if (reliabilityReport.nodeName !== null && nodeName <= reliabilityReport.nodeName.length) {
          nodeName = reliabilityReport.nodeName.length;
        }
        if (reliabilityReport.powerSupplyId !== null && powerSupplyId <= reliabilityReport.powerSupplyId.length) {
          powerSupplyId = reliabilityReport.powerSupplyId.length;
        }
        if (reliabilityReport.powerSupplyName !== null && powerSupplyName <= reliabilityReport.powerSupplyName.length) {
          powerSupplyName = reliabilityReport.powerSupplyName.length;
        }
        if (reliabilityReport.powerSupplyModel !== null && powerSupplyModel <= reliabilityReport.powerSupplyModel.length) {
          powerSupplyModel = reliabilityReport.powerSupplyModel.length;
        }
        if (reliabilityReport.transponderVendor !== null && transponderVendor <= reliabilityReport.transponderVendor.length) {
          transponderVendor = reliabilityReport.transponderVendor.length;
        }
        if (reliabilityReport.transponderModel !== null && transponderModel <= reliabilityReport.transponderModel.length) {
          transponderModel = reliabilityReport.transponderModel.length;
        }
        if (reliabilityReport.macAddress !== null && macAddress <= reliabilityReport.macAddress.length) {
          macAddress = reliabilityReport.macAddress.length;
        }
        if (reliabilityReport.ip !== null && ip <= reliabilityReport.ip.length) {
          ip = reliabilityReport.ip.length;
        }
        if (reliabilityReport.powerSupplyAddress !== null && powerSupplyAddress <= reliabilityReport.powerSupplyAddress.length) {
          powerSupplyAddress = reliabilityReport.powerSupplyAddress.length;
        }
        if (reliabilityReport.city !== null && city <= reliabilityReport.city.length) {
          city = reliabilityReport.city.length;
        }
        if (reliabilityReport.state !== null && state <= reliabilityReport.state.length) {
          state = reliabilityReport.state.length;
        }
        if (reliabilityReport.zip !== null && zip <= reliabilityReport.zip.length) {
          zip = reliabilityReport.zip.length;
        }
        if (reliabilityReport.gpsLatitude !== null && gpsLatitude <= reliabilityReport.gpsLatitude.length) {
          gpsLatitude = reliabilityReport.gpsLatitude.length;
        }
        if (reliabilityReport.gpsLongitude !== null && gpsLongitude <= reliabilityReport.gpsLongitude.length) {
          gpsLongitude = reliabilityReport.gpsLongitude.length;
        }
        if (reliabilityReport.currentStatus !== null && currentStatus <= reliabilityReport.currentStatus.length) {
          currentStatus = reliabilityReport.currentStatus.length;
        }
        if (reliabilityReport.inputVoltage !== null && inputVoltage <= reliabilityReport.inputVoltage.length) {
          inputVoltage = reliabilityReport.inputVoltage.length;
        }
        if (reliabilityReport.inputVoltagePresent !== null && inputVoltagePresent <= reliabilityReport.inputVoltagePresent.length) {
          inputVoltagePresent = reliabilityReport.inputVoltagePresent.length;
        }
        if (reliabilityReport.outputVoltage !== null && outputVoltage <= reliabilityReport.outputVoltage.length) {
          outputVoltage = reliabilityReport.outputVoltage.length;
        }
        if (reliabilityReport.outputCurrent1 !== null && outputCurrent1 <= reliabilityReport.outputCurrent1.length) {
          outputCurrent1 = reliabilityReport.outputCurrent1.length;
        }
        if (reliabilityReport.outputCurrent2 !== null && outputCurrent2 <= reliabilityReport.outputCurrent2.length) {
          outputCurrent2 = reliabilityReport.outputCurrent2.length;
        }
        if (reliabilityReport.batteryStringVoltage !== null && batteryStringVoltage <= reliabilityReport.batteryStringVoltage.length) {
          batteryStringVoltage = reliabilityReport.batteryStringVoltage.length;
        }
        if (reliabilityReport.totalStringsBatteryAlarm !== null && totalStringsBatteryAlarm <= reliabilityReport.totalStringsBatteryAlarm.length) {
          totalStringsBatteryAlarm = reliabilityReport.totalStringsBatteryAlarm.length;
        }
        if (reliabilityReport.stringsCount !== null && stringsCount <= reliabilityReport.stringsCount.length) {
          stringsCount = reliabilityReport.stringsCount.length;
        }
        if (reliabilityReport.batteriesPerString !== null && batteriesPerString <= reliabilityReport.batteriesPerString.length) {
          batteriesPerString = reliabilityReport.batteriesPerString.length;
        }
        if (reliabilityReport.totalBatteries !== null && totalBatteries <= reliabilityReport.totalBatteries.length) {
          totalBatteries = reliabilityReport.totalBatteries.length;
        }
        if (reliabilityReport.totalBatteryAlarm !== null && totalBatteryAlarm <= reliabilityReport.totalBatteryAlarm.length) {
          totalBatteryAlarm = reliabilityReport.totalBatteryAlarm.length;
        }
        if (reliabilityReport.type !== null && type <= reliabilityReport.type.length) {
          type = reliabilityReport.type.length;
        }
        if (reliabilityReport.manufactureDate !== null && manufactureDate <= reliabilityReport.manufactureDate.length) {
          manufactureDate = reliabilityReport.manufactureDate.length;
        }
        if (reliabilityReport.inverterStatus !== null && inverterStatus <= reliabilityReport.inverterStatus.length) {
          inverterStatus = reliabilityReport.inverterStatus.length;
        }
        if (reliabilityReport.totalInverterAlarm !== null && totalInverterAlarm <= reliabilityReport.totalInverterAlarm.length) {
          totalInverterAlarm = reliabilityReport.totalInverterAlarm.length;
        }
        if (reliabilityReport.majorAlarm !== null && majorAlarm <= reliabilityReport.majorAlarm.length) {
          majorAlarm = reliabilityReport.majorAlarm.length;
        }
        if (reliabilityReport.totalMajorAlarm !== null && totalMajorAlarm <= reliabilityReport.totalMajorAlarm.length) {
          totalMajorAlarm = reliabilityReport.totalMajorAlarm.length;
        }
        if (reliabilityReport.minorAlarm !== null && minorAlarm <= reliabilityReport.minorAlarm.length) {
          minorAlarm = reliabilityReport.minorAlarm.length;
        }
        if (reliabilityReport.totalMinorAlarm !== null && totalMinorAlarm <= reliabilityReport.totalMinorAlarm.length) {
          totalMinorAlarm = reliabilityReport.totalMinorAlarm.length;
        }
        if (reliabilityReport.tamperAlarm !== null && tamperAlarm <= reliabilityReport.tamperAlarm.length) {
          tamperAlarm = reliabilityReport.tamperAlarm.length;
        }
        if (reliabilityReport.totalTamperAlarms !== null && totalTamperAlarms <= reliabilityReport.totalTamperAlarms.length) {
          totalTamperAlarms = reliabilityReport.totalTamperAlarms.length;
        }
        if (reliabilityReport.createdDate !== null && createdDate <= reliabilityReport.createdDate.length) {
          createdDate = reliabilityReport.createdDate.length;
        }

        if (reliabilityReport.currentMacFirstSighting !== null && currentMacFirstSighting <= reliabilityReport.currentMacFirstSighting.length) {
          currentMacFirstSighting = reliabilityReport.currentMacFirstSighting.length;
        }
        if (reliabilityReport.totalOfflineMins !== null && totalOfflineMins <= reliabilityReport.totalOfflineMins.length) {
          totalOfflineMins = reliabilityReport.totalOfflineMins.length;
        }
        if (reliabilityReport.totalOfflineEvents !== null && totalOfflineEvents <= reliabilityReport.totalOfflineEvents.length) {
          totalOfflineEvents = reliabilityReport.totalOfflineEvents.length;
        }
        if (reliabilityReport.maxOfflineMins !== null && maxOfflineMins <= reliabilityReport.maxOfflineMins.length) {
          maxOfflineMins = reliabilityReport.maxOfflineMins.length;
        }
        if (reliabilityReport.medianOfflineMins !== null && medianOfflineMins <= reliabilityReport.medianOfflineMins.length) {
          medianOfflineMins = reliabilityReport.medianOfflineMins.length;
        }
        if (reliabilityReport.totalNetworkPowerOfflineMinutes !== null && totalNetworkPowerOfflineMinutes <= reliabilityReport.totalNetworkPowerOfflineMinutes.length) {
          totalNetworkPowerOfflineMinutes = reliabilityReport.totalNetworkPowerOfflineMinutes.length;
        }
        if (reliabilityReport.totalNetworkPowerOfflineEvents !== null && totalNetworkPowerOfflineEvents <= reliabilityReport.totalNetworkPowerOfflineEvents.length) {
          totalNetworkPowerOfflineEvents = reliabilityReport.totalNetworkPowerOfflineEvents.length;
        }
        if (reliabilityReport.totalCommercialPowerOutageMinutes !== null && totalCommercialPowerOutageMinutes <= reliabilityReport.totalCommercialPowerOutageMinutes.length) {
          totalCommercialPowerOutageMinutes = reliabilityReport.totalCommercialPowerOutageMinutes.length;
        }
        if (reliabilityReport.networkUptime !== null && networkUptime <= reliabilityReport.networkUptime.length) {
          networkUptime = reliabilityReport.networkUptime.length;
        }
        if (reliabilityReport.commercialPowerUptime !== null && commercialPowerUptime <= reliabilityReport.commercialPowerUptime.length) {
          commercialPowerUptime = reliabilityReport.commercialPowerUptime.length;
        }
        if (reliabilityReport.batteryCoverageMinutes !== null && batteryCoverageMinutes <= reliabilityReport.batteryCoverageMinutes.length) {
          batteryCoverageMinutes = reliabilityReport.batteryCoverageMinutes.length;
        }
        if (reliabilityReport.batteryOutageCoverage !== null && batteryOutageCoverage <= reliabilityReport.batteryOutageCoverage.length) {
          batteryOutageCoverage = reliabilityReport.batteryOutageCoverage.length;
        }
        if (reliabilityReport.standbyEvents !== null && standbyEvents <= reliabilityReport.standbyEvents.length) {
          standbyEvents = reliabilityReport.standbyEvents.length;
        }
        if (reliabilityReport.averageMinutesOnBattery !== null && averageMinutesOnBattery <= reliabilityReport.averageMinutesOnBattery.length) {
          averageMinutesOnBattery = reliabilityReport.averageMinutesOnBattery.length;
        }
        if (reliabilityReport.totalMinutesOnBattery !== null && totalMinutesOnBattery <= reliabilityReport.totalMinutesOnBattery.length) {
          totalMinutesOnBattery = reliabilityReport.totalMinutesOnBattery.length;
        }
        if (reliabilityReport.maxMinutesOnBattery !== null && maxMinutesOnBattery <= reliabilityReport.maxMinutesOnBattery.length) {
          maxMinutesOnBattery = reliabilityReport.maxMinutesOnBattery.length;
        }
        if (reliabilityReport.totalAlarms !== null && totalAlarms <= reliabilityReport.totalAlarms.length) {
          totalAlarms = reliabilityReport.totalAlarms.length;
        }
        if (reliabilityReport.bootFile !== null && bootFile <= reliabilityReport.bootFile.length) {
          bootFile = reliabilityReport.bootFile.length;
        }
        if (reliabilityReport.psFw !== null && psFw <= reliabilityReport.psFw.length) {
          psFw = reliabilityReport.psFw.length;
        }
        if (reliabilityReport.docFw !== null && docFw <= reliabilityReport.docFw.length) {
          docFw = reliabilityReport.docFw.length;
        }
        if (reliabilityReport.appFw !== null && appFw <= reliabilityReport.appFw.length) {
          appFw = reliabilityReport.appFw.length;
        }
        if (reliabilityReport.sagFw !== null && sagFw <= reliabilityReport.sagFw.length) {
          sagFw = reliabilityReport.sagFw.length;
        }
        if (reliabilityReport.avgFailDur !== null && avgFailDur <= reliabilityReport.avgFailDur.length) {
          avgFailDur = reliabilityReport.avgFailDur.length;
        }
        if (reliabilityReport.expDur !== null && expDur <= reliabilityReport.expDur.length) {
          expDur = reliabilityReport.expDur.length;
        }
        if (reliabilityReport.total !== null && total <= reliabilityReport.total.length) {
          total = reliabilityReport.total.length;
        }
        if (reliabilityReport.passed !== null && passed <= reliabilityReport.passed.length) {
          passed = reliabilityReport.passed.length;
        }
        if (reliabilityReport.failed !== null && failed <= reliabilityReport.failed.length) {
          failed = reliabilityReport.failed.length;
        }

      });
      return [
        { header: 'Division', key: 'division', width: division },
        { header: 'RegionName', key: 'regionName', width: regionName },
        { header: 'HeadendName', key: 'headendName', width: headendName },
        { header: 'CommunityName', key: 'communityName', width: communityName },
        { header: 'NodeName', key: 'nodeName', width: nodeName },
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: powerSupplyId },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: powerSupplyName },
        { header: 'PowerSupplyModel', key: 'powerSupplyModel', width: powerSupplyModel },
        { header: 'TransponderVendor', key: 'transponderVendor', width: transponderVendor },
        { header: 'TransponderModel', key: 'transponderModel', width: transponderModel },
        { header: 'MacAddress', key: 'macAddress', width: macAddress },
        { header: 'IP', key: 'ip', width: ip },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: powerSupplyAddress },
        { header: 'City', key: 'city', width: city },
        { header: 'State', key: 'state', width: state },
        { header: 'Zip', key: 'zip', width: zip },
        { header: 'GpsLatitude', key: 'gpsLatitude', width: gpsLatitude },
        { header: 'GpsLongitude', key: 'gpsLongitude', width: gpsLongitude },
        { header: 'CurrentStatus', key: 'currentStatus', width: currentStatus },
        { header: 'InputVoltage', key: 'inputVoltage', width: inputVoltage },
        { header: 'InputVoltagePresent', key: 'inputVoltagePresent', width: inputVoltagePresent },
        { header: 'OutputVoltage', key: 'outputVoltage', width: outputVoltage },
        { header: 'OutputCurrent1', key: 'outputCurrent1', width: outputCurrent1 },
        { header: 'OutputCurrent2', key: 'outputCurrent2', width: outputCurrent2 },
        { header: 'BatteryStringVoltage', key: 'batteryStringVoltage', width: batteryStringVoltage },
        { header: 'TotalStringsBatteryAlarm', key: 'totalStringsBatteryAlarm', width: totalStringsBatteryAlarm },
        { header: 'StringsCount', key: 'stringsCount', width: stringsCount },
        { header: 'BatteriesPerString', key: 'batteriesPerString', width: batteriesPerString },
        { header: 'TotalBatteries', key: 'totalBatteries', width: totalBatteries },
        { header: 'TotalBatteryAlarm', key: 'totalBatteryAlarm', width: totalBatteryAlarm },
        { header: 'Type', key: 'type', width: type },
        { header: 'ManufactureDate', key: 'manufactureDate', width: manufactureDate },
        { header: 'InverterStatus', key: 'inverterStatus', width: inverterStatus },
        { header: 'TotalInverterAlarm', key: 'totalInverterAlarm', width: totalInverterAlarm },
        { header: 'MajorAlarm', key: 'majorAlarm', width: majorAlarm },
        { header: 'TotalMajorAlarm', key: 'totalMajorAlarm', width: totalMajorAlarm },
        { header: 'MinorAlarm', key: 'minorAlarm', width: minorAlarm },
        { header: 'TotalMinorAlarm', key: 'totalMinorAlarm', width: totalMinorAlarm },
        { header: 'TamperAlarm', key: 'tamperAlarm', width: tamperAlarm },
        { header: 'TotalTamperAlarms', key: 'totalTamperAlarms', width: totalTamperAlarms },
        { header: 'CreatedDate', key: 'createdDate', width: createdDate },
        { header: 'CurrentMacFirstSighting', key: 'currentMacFirstSighting', width: currentMacFirstSighting },
        { header: 'TotalOfflineMins', key: 'totalOfflineMins', width: totalOfflineMins },
        { header: 'TotalOfflineEvents', key: 'totalOfflineEvents', width: totalOfflineEvents },
        { header: 'MaxOfflineMins', key: 'maxOfflineMins', width: maxOfflineMins },
        { header: 'MedianOfflineMins', key: 'medianOfflineMins', width: medianOfflineMins },
        { header: 'TotalNetworkPowerOfflineMinutes', key: 'totalNetworkPowerOfflineMinutes', width: totalNetworkPowerOfflineMinutes },
        { header: 'TotalNetworkPowerOfflineEvents', key: 'totalNetworkPowerOfflineEvents', width: totalNetworkPowerOfflineEvents },
        { header: 'TotalCommercialPowerOutageMinutes', key: 'totalCommercialPowerOutageMinutes', width: totalCommercialPowerOutageMinutes },
        { header: 'NetworkUptime', key: 'networkUptime', width: networkUptime },
        { header: 'CommercialPowerUptime', key: 'commercialPowerUptime', width: commercialPowerUptime },
        { header: 'BatteryCoverageMinutes', key: 'batteryCoverageMinutes', width: batteryCoverageMinutes },
        { header: 'BatteryOutageCoverage', key: 'batteryOutageCoverage', width: batteryOutageCoverage },
        { header: 'StandbyEvents', key: 'standbyEvents', width: standbyEvents },
        { header: 'AverageMinutesOnBattery', key: 'averageMinutesOnBattery', width: averageMinutesOnBattery },
        { header: 'TotalMinutesOnBattery', key: 'totalMinutesOnBattery', width: totalMinutesOnBattery },
        { header: 'MaxMinutesOnBattery', key: 'maxMinutesOnBattery', width: maxMinutesOnBattery },
        { header: 'TotalAlarmsCount', key: 'totalAlarms', width: totalAlarms },
        { header: 'BootFile', key: 'bootFile', width: bootFile },
        { header: 'PsFw', key: 'psFw', width: psFw },
        { header: 'DocFw', key: 'docFw', width: docFw },
        { header: 'AppFw', key: 'appFw', width: appFw },
        { header: 'SagFw', key: 'sagFw', width: sagFw },
        { header: 'AvgFailDur', key: 'avgFailDur', width: avgFailDur },
        { header: 'ExpDur', key: 'expDur', width: expDur },
        { header: 'Total', key: 'total', width: total },
        { header: 'Passed', key: 'passed', width: passed },
        { header: 'Failed', key: 'failed', width: failed },
      ];
    }
    if (fileType === 'VULNERABILITY') {

      //Default Width's
      let regionName = 14;
      let headendName = 11;
      let communityName = 11;
      let nodeName = 11;
      let powerSupplyId = 11;
      let macAddress = 11;
      let ip = 11;
      let powerSupplyName = 11;
      let powerSupplyAddress = 11;
      let city = 15;
      let state = 15;
      let zip = 15;
      let gpsLatitude = 15;
      let gpsLongitude = 15;
      //let offlineStandbys = 15;
      //let standbyStart = 20;
      //let standbyEnd = 20;
      //let duration = 15;
      //let provenStandbyDuration = 20;
      //let lastProvenStandby = 20;
      //let lastPmDate = 20;
      //let alphaPmCertificationReport = 20;
      let underPerfAlert = 20;
      let underPerfPredict = 20;
      let underPerfActual = 20;
      let underPerfAlertStart = 20;
      let underPerfAlertEnd = 20;

      json.forEach(vulnerabilityReport => {
        if (vulnerabilityReport.regionName !== null && regionName <= vulnerabilityReport.regionName.length) {
          regionName = vulnerabilityReport.regionName.length;
        }
        if (vulnerabilityReport.headendName !== null && headendName <= vulnerabilityReport.headendName.length) {
          headendName = vulnerabilityReport.headendName.length;
        }
        if (vulnerabilityReport.communityName !== null && communityName <= vulnerabilityReport.communityName.length) {
          communityName = vulnerabilityReport.communityName.length;
        }
        if (vulnerabilityReport.nodeName !== null && nodeName <= vulnerabilityReport.nodeName.length) {
          nodeName = vulnerabilityReport.nodeName.length;
        }
        if (vulnerabilityReport.powerSupplyId !== null && powerSupplyId <= vulnerabilityReport.powerSupplyId.length) {
          powerSupplyId = vulnerabilityReport.powerSupplyId.length;
        }
        if (vulnerabilityReport.powerSupplyName !== null && powerSupplyName <= vulnerabilityReport.powerSupplyName.length) {
          powerSupplyName = vulnerabilityReport.powerSupplyName.length;
        }
        if (vulnerabilityReport.macAddress !== null && macAddress <= vulnerabilityReport.macAddress.length) {
          macAddress = vulnerabilityReport.macAddress.length;
        }
        if (vulnerabilityReport.ip !== null && ip <= vulnerabilityReport.ip.length) {
          ip = vulnerabilityReport.ip.length;
        }
        if (vulnerabilityReport.powerSupplyName !== null && powerSupplyName <= vulnerabilityReport.powerSupplyName.length) {
          powerSupplyName = vulnerabilityReport.powerSupplyName.length;
        }
        if (vulnerabilityReport.powerSupplyAddress !== null && powerSupplyAddress <= vulnerabilityReport.powerSupplyAddress.length) {
          powerSupplyAddress = vulnerabilityReport.powerSupplyAddress.length;
        }
        if (vulnerabilityReport.city !== null && city <= vulnerabilityReport.city.length) {
          city = vulnerabilityReport.city.length;
        }
        if (vulnerabilityReport.state !== null && state <= vulnerabilityReport.state.length) {
          state = vulnerabilityReport.state.length;
        }
        if (vulnerabilityReport.zip !== null && zip <= vulnerabilityReport.zip.length) {
          zip = vulnerabilityReport.zip.length;
        }
        if (vulnerabilityReport.gpsLatitude !== null && gpsLatitude <= vulnerabilityReport.gpsLatitude.length) {
          gpsLatitude = vulnerabilityReport.gpsLatitude.length;
        }
        if (vulnerabilityReport.gpsLongitude !== null && gpsLongitude <= vulnerabilityReport.gpsLongitude.length) {
          gpsLongitude = vulnerabilityReport.gpsLongitude.length;
        }
        // if (vulnerabilityReport.offlineStandbys !== null && offlineStandbys <= vulnerabilityReport.offlineStandbys.length) {
        //   offlineStandbys = vulnerabilityReport.offlineStandbys.length;
        // }
        // if (vulnerabilityReport.standbyStart !== null && standbyStart <= vulnerabilityReport.standbyStart.length) {
        //   standbyStart = vulnerabilityReport.standbyStart.length;
        // }
        // if (vulnerabilityReport.standbyEnd !== null && standbyEnd <= vulnerabilityReport.standbyEnd.length) {
        //   standbyEnd = vulnerabilityReport.standbyEnd.length;
        // }
        // if (vulnerabilityReport.duration !== null && duration <= vulnerabilityReport.duration.length) {
        //   duration = vulnerabilityReport.duration.length;
        // }
        // if (vulnerabilityReport.provenStandbyDuration !== null && provenStandbyDuration <= vulnerabilityReport.provenStandbyDuration.length) {
        //   provenStandbyDuration = vulnerabilityReport.provenStandbyDuration.length;
        // }
        // if (vulnerabilityReport.lastProvenStandby !== null && lastProvenStandby <= vulnerabilityReport.lastProvenStandby.length) {
        //   lastProvenStandby = vulnerabilityReport.lastProvenStandby.length;
        // }
        // if (vulnerabilityReport.lastPmDate !== null && lastPmDate <= vulnerabilityReport.lastPmDate.length) {
        //   lastPmDate = vulnerabilityReport.lastPmDate.length;
        // }
        // if (vulnerabilityReport.alphaPmCertificationReport !== null && alphaPmCertificationReport <= vulnerabilityReport.alphaPmCertificationReport.length) {
        //   alphaPmCertificationReport = vulnerabilityReport.alphaPmCertificationReport.length;
        // }
        if (vulnerabilityReport.underPerfAlertType !== null && underPerfAlert <= vulnerabilityReport.underPerfAlertType.length) {
          underPerfAlert = vulnerabilityReport.underPerfAlertType.length;
        }
        if (vulnerabilityReport.predictedTime !== null && underPerfPredict <= vulnerabilityReport.predictedTime.length) {
          underPerfPredict = vulnerabilityReport.predictedTime.length;
        }
        if (vulnerabilityReport.actualTime !== null && underPerfActual <= vulnerabilityReport.actualTime.length) {
          underPerfActual = vulnerabilityReport.actualTime.length;
        }
        if (vulnerabilityReport.underPerfAlertStart !== null && underPerfAlertStart <= vulnerabilityReport.underPerfAlertStart.length) {
          underPerfAlertStart = vulnerabilityReport.underPerfAlertStart.length;
        }
        if (vulnerabilityReport.underPerfAlertEnd !== null && underPerfAlertEnd <= vulnerabilityReport.underPerfAlertEnd.length) {
          underPerfAlertEnd = vulnerabilityReport.underPerfAlertEnd.length;
        }

      });
      return [
        { header: 'RegionName', key: 'regionName', width: regionName },
        { header: 'HeadendName', key: 'headendName', width: headendName },
        { header: 'CommunityName', key: 'communityName', width: communityName },
        { header: 'NodeName', key: 'nodeName', width: nodeName },
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: powerSupplyId },
        { header: 'MacAddress', key: 'macAddress', width: macAddress },
        { header: 'IP', key: 'ip', width: ip },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: powerSupplyName },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: powerSupplyAddress },
        { header: 'City', key: 'city', width: city },
        { header: 'State', key: 'state', width: state },
        { header: 'Zip', key: 'zip', width: zip },
        { header: 'GpsLatitude', key: 'gpsLatitude', width: gpsLatitude },
        { header: 'GpsLongitude', key: 'gpsLongitude', width: gpsLongitude },
        // { header: 'OfflineStandbys', key: 'offlineStandbys', width: offlineStandbys },
        // { header: 'StandbyStart', key: 'standbyStart', width: standbyStart },
        // { header: 'StandbyEnd', key: 'standbyEnd', width: standbyEnd },
        // { header: 'Duration', key: 'duration', width: duration },
        // { header: 'ProvenStandbyDuration', key: 'provenStandbyDuration', width: provenStandbyDuration },
        // { header: 'LastProvenStandby', key: 'lastProvenStandby', width: lastProvenStandby },
        { header: 'Alert Type', key: 'underPerfAlertType', width: underPerfAlert },
        { header: 'Alert Start Time', key: 'underPerfAlertStart', width: underPerfAlertStart },
        { header: 'Alert End Time', key: 'underPerfAlertEnd', width: underPerfAlertEnd },
        { header: 'Predicted Runtime', key: 'predictedTime', width: underPerfPredict },
        { header: 'Actual Runtime', key: 'actualTime', width: underPerfActual },
        // { header: 'LastPmDate', key: 'lastPmDate', width: lastPmDate },
        // { header: 'AlphaPmCertificationReport', key: 'alphaPmCertificationReport', width: alphaPmCertificationReport },
      ];
    }
    if (fileType === 'REMOTETEST') {
      let PowerSupplyId = 14;
      let regionName = 14;
      let headendName = 11;
      let communityName = 11;
      let name = 11;
      let powerSupplyName = 15;
      let ip = 11;
      let macAddress = 11;
      let houseNumber = 11;
      let powerSupplyAddress = 20;
      let testStartStringVoltage = 20;
      let testEndStringVoltage = 20;
      let crossStreet = 11;
      let city = 20;
      let state = 20;
      let zip = 20;
      let testStartDate = 20;
      let testEndDate = 20;
      let durationInMins = 20;
      let status = 11;
      let result = 11;
      let action = 11;
      let HierarchyPathLabels = 30;

      json.forEach(remotetestPSReport => {
        if (remotetestPSReport.powerSupplyId !== null && PowerSupplyId <= remotetestPSReport.powerSupplyId.length) {
          PowerSupplyId = remotetestPSReport.powerSupplyId.length;
        }
        if (remotetestPSReport.macAddress !== null && macAddress <= remotetestPSReport.macAddress.length) {
          macAddress = remotetestPSReport.macAddress.length;
        }
        if (remotetestPSReport.city !== null && city <= remotetestPSReport.city.length) {
          city = remotetestPSReport.city.length;
        }
        if (remotetestPSReport.communityName !== null && communityName <= remotetestPSReport.communityName.length) {
          communityName = remotetestPSReport.communityName.length;
        }

        if (remotetestPSReport.headendName !== null && headendName <= remotetestPSReport.headendName.length) {
          headendName = remotetestPSReport.headendName.length;
        }
        if (remotetestPSReport.houseNumber !== null && houseNumber <= remotetestPSReport.houseNumber.length) {
          houseNumber = remotetestPSReport.houseNumber.length;
        }
        if (remotetestPSReport.ip !== null && ip <= remotetestPSReport.ip.length) {
          ip = remotetestPSReport.ip.length;
        }
        if (remotetestPSReport.macAddress !== null && macAddress <= remotetestPSReport.macAddress.length) {
          macAddress = remotetestPSReport.macAddress.length;
        }
        if (remotetestPSReport.powerSupplyName !== null && powerSupplyName <= remotetestPSReport.powerSupplyName.length) {
          powerSupplyName = remotetestPSReport.powerSupplyName.length;
        }
        if (remotetestPSReport.name !== null && name <= remotetestPSReport.name.length) {
          name = remotetestPSReport.name.length;
        }
        if (remotetestPSReport.regionName !== null && regionName <= remotetestPSReport.regionName.length) {
          regionName = remotetestPSReport.regionName.length;
        }
        if (remotetestPSReport.state !== null && state <= remotetestPSReport.state.length) {
          state = remotetestPSReport.state.length;
        }
        if (remotetestPSReport.zip !== null && zip <= remotetestPSReport.zip.length) {
          zip = remotetestPSReport.zip.length;
        }
        if (remotetestPSReport.action !== null && action <= remotetestPSReport.action.length) {
          action = remotetestPSReport.action.length;
        }
        if (remotetestPSReport.result !== null && result <= remotetestPSReport.result.length) {
          result = remotetestPSReport.result.length;
        }

        if (remotetestPSReport.status !== null && status <= remotetestPSReport.status.length) {
          status = remotetestPSReport.status.length;
        }
        if (remotetestPSReport.durationInMins !== null && durationInMins <= remotetestPSReport.durationInMins.length) {
          durationInMins = remotetestPSReport.durationInMins.length;
        }

        if (remotetestPSReport.testStartDate !== null && testStartDate <= remotetestPSReport.testStartDate.length) {
          testStartDate = remotetestPSReport.testStartDate.length;
        }
        if (remotetestPSReport.testEndDate !== null && testEndDate <= remotetestPSReport.testEndDate.length) {
          testEndDate = remotetestPSReport.testEndDate.length;
        }
        if (remotetestPSReport.crossStreet !== null && crossStreet <= remotetestPSReport.crossStreet.length) {
          crossStreet = remotetestPSReport.crossStreet.length;
        }
        if (remotetestPSReport.powerSupplyAddress !== null && powerSupplyAddress <= remotetestPSReport.powerSupplyAddress.length) {
          powerSupplyAddress = remotetestPSReport.powerSupplyAddress.length;
        }

        if (remotetestPSReport.testStartStringVoltage !== null && testStartStringVoltage <= remotetestPSReport.testStartStringVoltage.length) {
          testStartStringVoltage = remotetestPSReport.testStartStringVoltage.length;
        }

        if (remotetestPSReport.testEndStringVoltage !== null && testEndStringVoltage <= remotetestPSReport.testEndStringVoltage.length) {
          testEndStringVoltage = remotetestPSReport.testEndStringVoltage.length;
        }
        if (remotetestPSReport.hierarchyPathLabels !== null && HierarchyPathLabels <= remotetestPSReport.hierarchyPathLabels.length) {
          HierarchyPathLabels = remotetestPSReport.hierarchyPathLabels.length;
        }

      });
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: PowerSupplyId },
        { header: 'RegionName', key: 'regionName', width: regionName },
        { header: 'HeadendName', key: 'headendName', width: headendName },
        { header: 'CommunityName', key: 'communityName', width: communityName },
        { header: 'Node Name', key: 'name', width: name },
        { header: 'Hierarchy Path', key: 'hierarchyPathLabels', width: HierarchyPathLabels },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: powerSupplyName },
        { header: 'IP', key: 'ip', width: ip },
        { header: 'MacAddress', key: 'macAddress', width: macAddress },
        { header: 'HouseNumber', key: 'houseNumber', width: houseNumber },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: powerSupplyAddress },
        { header: 'CrossStreet', key: 'crossStreet', width: crossStreet },
        { header: 'City', key: 'city', width: city },
        { header: 'State', key: 'state', width: state },
        { header: 'Zip', key: 'zip', width: zip },
        { header: 'TestStartDate', key: 'testStartDateValue', width: testStartDate },
        { header: 'TestEndDate', key: 'testEndDateValue', width: testEndDate },
        { header: 'TestStartStringVoltage', key: 'testStartStringVoltage', width: testStartStringVoltage },
        { header: 'TestEndStringVoltage', key: 'testEndStringVoltage', width: testEndStringVoltage },
        { header: 'DurationInMins', key: 'durationInMins', width: durationInMins },
        { header: 'Status', key: 'status', width: status },
        { header: 'Result', key: 'result', width: result },
        { header: 'Action', key: 'action', width: action },

      ];
    }
    if (fileType ==='PSCURRENTCERTIFICATION' || fileType ==='PSCERTIFICATIONHISTORY') {
      let wchAcInputVoltageSpec=20;
      let wchBatteriesReplaced=20;
      let wchBusinessPartnerRestriction=20;
      let wchCity=20;
      let wchCommunityName=20;
      //let wchControllerCardType=20;
      let wchCurrentAmpOutputUsed=20;
      let wchEgisName=20;
      let wchFeedsMultipleNodes=20;
      let wchHeadendName=20;
      let wchHouseNumber=20;
      let wchMacAddress=20;
      let wchMapNumber=20;
      let wchNextGenNode=20;
      let wchNitroCompletionDate=20;
      let wchNode=20;
      let wchOutputVoltageSpec=20;
      let wchPoleNumber=20;
      let wchPowerSupplyId=20;
      let wchPowerSupplyModel=20;
      let wchPowerSupplyNumber=20;
      let wchPowerSupplyType9360=20;
      let wchRegionName=20;
      let wchState=20;
      let wchnwtTeam=20;
      let wchTransponderModel=20;
      let wchZipCode=20;
      let wchAcIndicatorGreenLight=20;
      let wchAerialUnderground=20;
      let wchAlertLevel=20;
      let wchApuBatteryConductance=20;
      let wchApuBatteryConductanceCorrected=24;
      let wchApuBatteryDateCode=20;
      let wchApuBatteryInstallDate=20;
      let wchApuBatteryManufacturerType=21;
      let wchApuBatteryTerminalsCleaned=21;
      let wchApuBatteryTorque=20;
      let wchApuBatteryVoltageNoLoad=20;
      let wchApuChargerCurrentAmps=20;
      let wchApuCompletedBy=20;
      let wchApuDeviceId=20;
      let wchApuEnclosureMake=20;
      let wchApuFrequency=20;
      let wchApuLoadVoltage=20;
      let wchApuMakeModel=20;
      let wchApuNoLoadVoltage=20;
      let wchApuOutputVoltageRating=20;
      let wchApuRunTime=20;
      let wchApuSerialNumber=20;
      let wchApuStarterBatteryChrgrVlt=20;
      let wchApuTestRun=20;
      let wchApuVisitComments=20;
      let wchBatteryBalancerString=25;
      let wchBatteryHeaterMatQuantity=20;
      let wchBatteryHeaterMatType=20;
      let wchBatteryReplacementDate=20;
      let wchBatteryString1Fused=20;
      let wchBatteryString2Fused=20;
      let wchBatteryString3Fused=20;
      let wchBatteryString4Fused=20;
      let wchBootFile=27;
      let wchBootr=20;
      let wchCabinetBatteryCapacity=20;
      let wchCabinetLocked=20;
      let wchCabinetVendor=20;
      let wchCertificationDate=20;
      let wchChangeCleanEnclosureAirFilter=22;
      let wchCheckForGasLeaks=20;
      let wchCheckForRodentDamage=20;
      let wchCheckGroundCabinet=20;
      let wchCheckLampsLed=20;
      let wchCheckLampsLeds=20;
      let wchCheckLaps=20;
      let wchCheckMagneticBreaker=20;
      let wchCheckOilLevel=20;
      let wchCheckOperatingLights=20;
      let wchCheckRegroutPadConduit=20;
      let wchCheckSeizureAltBox=20;
      let wchCleanEnclosure=20;
      let wchCleanUpGarbage=20;
      let wchClearApuEventLog=20;
      let wchClearWeeds=20;
      let wchCoaxTvssPresent=20;
      let wchCommTech=20;
      let wchCompanyAccountNumber=20;
      let wchConfigFile=25;
      let wchCrossStreet=20;
      let wchCurrentAmpRatingSpec=20;
      let wchDateApuInstalled=20;
      let wchDateEntered=20;
      let wchEcmAcm=20;
      let wchElectricMeterNumber=20;
      let wchEnclosureDamageVandalism=20;
      let wchEnclosureSnowShield=20;
      let wchcalculatedRuntime=20;
      let wchFollowUpActionNeeded=20;
      let wchFollowUpNeeded=20;
      let wchFollowUpReason=20;
      let wchGasMeterNumber=20;
      let wchGasMeterReading=20;
      let wchGeneratorDcBusFunction=20;
      let wchGpsLatitude=20;
      let wchGpsLongitude=20;
      let wchGroundMountPadUndermining=21;
      let wchHierarchyPathLabels=50;
      let wchHwRev=20;
      let wchInputSurgeArrestor=20;
      let wchInspectConnectors=20;
      let wchInspectGeneratorAirFilter=20;
      let wchInspectProbes=20;
      let wchInspectSparkPlug=20;
      let wchInspectionDate=20;
      let wchInstallDate11=20;
      let wchInstallDate12=20;
      let wchInstallDate13=20;
      let wchInstallDate14=20;
      let wchInstallDate21=20;
      let wchInstallDate22=20;
      let wchInstallDate23=20;
      let wchInstallDate24=20;
      let wchInstallDate31=20;
      let wchInstallDate32=20;
      let wchInstallDate33=20;
      let wchInstallDate34=20;
      let wchInstallDate41=20;
      let wchInstallDate42=20;
      let wchInstallDate43=20;
      let wchInstallDate44=20;
      let wchInstallDate51=20;
      let wchInstallDate52=20;
      let wchInstallDate53=20;
      let wchInstallDate54=20;
      let wchInstallDate61=20;
      let wchInstallDate62=20;
      let wchInstallDate63=20;
      let wchInstallDate64=20;
      let wchInternalBreaker=20;
      let wchIp=20;
      let wchLocalRemoteIndicator=20;
      let wchLpTankCapacity=20;
      let wchMacAddressPrevious=20;
      let wchMeterPanCondition=20;
      let wchNcpCmts=33;
      let wchNgLp=20;
      let wchNgPressure=20;
      let wchNgProvider=20;
      let wchNitroReasonNotCompleted=20;
      let wchNumberOfBatteries=20;
      let wchNumberTanksInstalled=20;
      let wchOilAddedAmount=20;
      let wchOilFilterTight=20;
      let wchOutputSurgeArrestor=20;
      let wchPhotoUploadedDate=20;
      let wchPowerAccountType=20;
      let wchPowerCoRiserCondition=20;
      let wchPowerSupplyAddress=30;
      let wchPowerSupplyIdLegible=20;
      let wchPowerSupplyName=20;
      let wchPowerSupplyType=20;
      let wchPowersNode=20;
      let wchPsAlertProfile=20;
      let wchPsCertificationId=20;
      let wchReceptacleType=20;
      let wchRecordAsFoundAlarms=20;
      let wchRemoteStandbyOperation2=20;
      let wchRemoteStandbyOperation3=20;
      let wchRemoteStandbyOperation4=20;
      let wchRemoteStandbyOperation5=20;
      let wchSecurityBarPresent=20;
      let wchServiceEntrance=20;
      let wchShowActualLocation=20;
      let wchSpecialLocationDetails=20;
      let wchStandByOperation=20;
      let wchString1Battery1DateCode=20;
      let wchString1Battery2DateCode=20;
      let wchString1Battery3DateCode=20;
      let wchString1Battery4DateCode=20;
      let wchString2Battery1DateCode=20;
      let wchString2Battery2DateCode=20;
      let wchString2Battery3DateCode=20;
      let wchString2Battery4DateCode=20;
      let wchString3Battery1DateCode=20;
      let wchString3Battery2DateCode=20;
      let wchString3Battery3DateCode=20;
      let wchString3Battery4DateCode=20;
      let wchString4Battery1DateCode=20;
      let wchString4Battery2DateCode=20;
      let wchString4Battery3DateCode=20;
      let wchString4Battery4DateCode=20;
      let wchString5Battery1DateCode=20;
      let wchString5Battery2DateCode=20;
      let wchString5Battery3DateCode=20;
      let wchString5Battery4DateCode=20;
      let wchString6Battery1DateCode=20;
      let wchString6Battery2DateCode=20;
      let wchString6Battery3DateCode=20;
      let wchString6Battery4DateCode=20;
      let wchSubmittedBy=20;
      let wchSwRev=28;
      let wchSysDescr=105;
      let wchSysName=20;
      let wchTamperInstalledFunctioning=20;
      let wchTankOneLevel=20;
      let wchTankTwoLevel=20;
      let wchTechnicianName=20;
      let wchTechnicianNtUsername=20;
      let wchTechnicianNumber=20;
      let wchTemperatures=20;
      let wchTestCombustibleGasAlarm=20;
      let wchTestHighTempAlarm=20;
      let wchTestOilPressureAlarm=20;
      let wchTestPadShearAlarm=20;
      let wchTestTamperAlarm=20;
      let wchTestWaterIntrusionAlarm=20;
      let wchTightenHardware=20;
      let wchTransponderVendor=20;
      let wchType11=20;
      let wchType12=20;
      let wchType13=20;
      let wchType14=20;
      let wchType21=20;
      let wchType22=20;
      let wchType23=20;
      let wchType24=20;
      let wchType31=20;
      let wchType32=20;
      let wchType33=20;
      let wchType34=20;
      let wchType41=20;
      let wchType42=20;
      let wchType43=20;
      let wchType44=20;
      let wchType51=20;
      let wchType52=20;
      let wchType53=20;
      let wchType54=20;
      let wchType61=20;
      let wchType62=20;
      let wchType63=20;
      let wchType64=20;
      let wchTypeOfVisit=20;
      let wchUtilityProvider=20;
      let wchVisitStatus=20;
      let wchVisualCabinetInspection=20;
      let wchVoltage11=20;
      let wchVoltage12=20;
      let wchVoltage13=20;
      let wchVoltage14=20;
      let wchVoltage21=20;
      let wchVoltage22=20;
      let wchVoltage23=20;
      let wchVoltage24=20;
      let wchVoltage31=20;
      let wchVoltage32=20;
      let wchVoltage33=20;
      let wchVoltage34=20;
      let wchVoltage41=20;
      let wchVoltage42=20;
      let wchVoltage43=20;
      let wchVoltage44=20;
      let wchVoltage51=20;
      let wchVoltage52=20;
      let wchVoltage53=20;
      let wchVoltage54=20;
      let wchVoltage61=20;
      let wchVoltage62=20;
      let wchVoltage63=20;
      let wchVoltage64=20;
      let wchXocVerified=20;
      let wchbillingCodes= 20;
      let wchmaterialBillingCodes= 20;
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId',width:wchPowerSupplyId},
        { header: 'RegionName', key: 'regionName',width:wchRegionName},
        { header: 'HeadendName', key: 'headendName',width:wchHeadendName},
        { header: 'CommunityName', key: 'communityName',width:wchCommunityName},
        { header: 'Node Name', key: 'node',width:wchNode},
        { header: 'Hierarchy Path',key: 'hierarchyPathLabels',width:wchHierarchyPathLabels},
        { header: 'PowerSupplyName',key: 'powerSupplyName',width:wchPowerSupplyName},
        { header: 'Ip Address',key: 'ip',width:wchIp},
        { header: 'MacAddress', key: 'macAddress',width:wchMacAddress},
        { header: 'CMTS',key: 'ncpCmts',width:wchNcpCmts},
        { header: 'Previous MacAddress',key: 'macAddressPrevious',width:wchMacAddressPrevious},
        // { header: 'ControllerCardType', key: 'controllerCardType',width:wchControllerCardType},
        { header: 'HouseNumber', key: 'houseNumber',width:wchHouseNumber},
        { header: 'PowerSupply Address',key: 'powerSupplyAddress',width:wchPowerSupplyAddress},
        { header: 'CrossStreet',key: 'crossStreet',width:wchCrossStreet},
        { header: 'City', key: 'city',width:wchCity},
        { header: 'State', key: 'state',width:wchState},
        { header: 'ZipCode', key: 'zipCode',width:wchZipCode},
        { header: 'Gps Latitude',key: 'gpsLatitude',width:wchGpsLatitude},
        { header: 'Gps Longitude',key: 'gpsLongitude',width:wchGpsLongitude},
        { header: 'Pole Number', key: 'poleNumber',width:wchPoleNumber},
        { header: 'PowerAccountType',key: 'powerAccountType',width:wchPowerAccountType},
        { header: 'CompanyAccountNumber',key: 'companyAccountNumber',width:wchCompanyAccountNumber},
        { header: 'ElectricMeterNumber',key: 'electricMeterNumber',width:wchElectricMeterNumber},
        { header: 'PowersNode',key: 'powersNode',width:wchPowersNode},
        { header: 'MapNumber', key: 'mapNumber',width:wchMapNumber},
        { header: 'Calculated Runtime(in Minutes)',key: 'calculatedRuntime',width:wchcalculatedRuntime},
        { header: 'FeedsMultipleNodes', key: 'feedsMultipleNodes',width:wchFeedsMultipleNodes},
        { header: 'SpecialLocationDetails',key: 'specialLocationDetails',width:wchSpecialLocationDetails},
        { header: 'ShowActualLocation',key: 'showActualLocation',width:wchShowActualLocation},
        { header: 'PowerSupply Number', key: 'powerSupplyNumber',width:wchPowerSupplyNumber},
        { header: 'NextGenNode', key: 'nextGenNode',width:wchNextGenNode},
        { header: 'PowerSupplyType9360', key: 'powerSupplyType9360',width:wchPowerSupplyType9360},
        { header: 'TransponderVendor',key: 'transponderVendor',width:wchTransponderVendor},
        { header: 'TransponderModel', key: 'transponderModel',width:wchTransponderModel},
        { header: 'PowerSupplyModel', key: 'powerSupplyModel',width:wchPowerSupplyModel},
        { header: 'UtilityProvider',key: 'utilityProvider',width:wchUtilityProvider},
        { header: 'OutputVoltageSpec', key: 'outputVoltageSpec',width:wchOutputVoltageSpec},
        { header: 'AcInputVoltageSpec', key: 'acInputVoltageSpec',width:wchAcInputVoltageSpec},
        { header: 'CurrentAmpRatingSpec',key: 'currentAmpRatingSpec',width:wchCurrentAmpRatingSpec},
        { header: 'CurrentAmpOutputUsed', key: 'currentAmpOutputUsed',width:wchCurrentAmpOutputUsed},
        { header: 'PowerSupplyType',key: 'powerSupplyType',width:wchPowerSupplyType},
        { header: 'PsAlertProfile',key: 'psAlertProfile',width:wchPsAlertProfile},
        { header: 'AerialUnderground',key: 'aerialUnderground',width:wchAerialUnderground},
        { header: 'EgisName', key: 'egisName',width:wchEgisName},

        { header: 'NWTTeam', key: 'nwtTeam',width:wchnwtTeam},

        { header: 'NitroCompletionDate', key: 'nitroCompletionDate',width:wchNitroCompletionDate},
        { header: 'BusinessPartnerRestriction', key: 'businessPartnerRestriction',width:wchBusinessPartnerRestriction},
        { header: 'CertificationDate',key: 'CertificationDateValue',width:wchCertificationDate},
        { header: 'PsCertificationId',key: 'psCertificationId',width:wchPsCertificationId},
        { header: 'TechnicianName',key: 'technicianName',width:wchTechnicianName},
        { header: 'TechnicianNtUsername',key: 'technicianNtUsername',width:wchTechnicianNtUsername},
        { header: 'SubmittedBy',key: 'submittedBy',width:wchSubmittedBy},
        { header: 'TechnicianNumber',key: 'technicianNumber',width:wchTechnicianNumber},
        { header: 'ApuMakeModel',key: 'apuMakeModel',width:wchApuMakeModel},
        { header: 'ApuSerialNumber',key: 'apuSerialNumber',width:wchApuSerialNumber},
        { header: 'ApuDeviceId',key: 'apuDeviceId',width:wchApuDeviceId},
        { header: 'ApuRunTime',key: 'apuRunTime',width:wchApuRunTime},
        { header: 'EcmAcm',key: 'ecmAcm',width:wchEcmAcm},
        { header: 'DateApuInstalled',key: 'DateApuInstalledValue',width:wchDateApuInstalled},
        { header: 'ApuOutputVoltageRating',key: 'apuOutputVoltageRating',width:wchApuOutputVoltageRating},
        { header: 'ApuNoLoadVoltage',key: 'apuNoLoadVoltage',width:wchApuNoLoadVoltage},
        { header: 'ApuLoadVoltage',key: 'apuLoadVoltage',width:wchApuLoadVoltage},
        { header: 'ApuEnclosureMake',key: 'apuEnclosureMake',width:wchApuEnclosureMake},
        { header: 'NgLp',key: 'ngLp',width:wchNgLp},
        { header: 'NgProvider',key: 'ngProvider',width:wchNgProvider},
        { header: 'LpTankCapacity',key: 'lpTankCapacity',width:wchLpTankCapacity},
        { header: 'NumberTanksInstalled',key: 'numberTanksInstalled',width:wchNumberTanksInstalled},
        { header: 'InspectionDate',key: 'inspectionDate',width:wchInspectionDate},
        { header: 'TypeOfVisit',key: 'typeOfVisit',width:wchTypeOfVisit},
        { header: 'XocVerified',key: 'xocVerified',width:wchXocVerified},
        { header: 'CleanEnclosure',key: 'cleanEnclosure',width:wchCleanEnclosure},
        { header: 'TightenHardware',key: 'tightenHardware',width:wchTightenHardware},
        { header: 'InspectConnectors',key: 'inspectConnectors',width:wchInspectConnectors},
        { header: 'InspectProbes',key: 'inspectProbes',width:wchInspectProbes},
        { header: 'MeterPanCondition',key: 'meterPanCondition',width:wchMeterPanCondition},
        { header: 'PowerCoRiserCondition',key: 'powerCoRiserCondition',width:wchPowerCoRiserCondition},
        { header: 'BatteryHeaterMatType',key: 'batteryHeaterMatType',width:wchBatteryHeaterMatType},
        { header: 'BatteryHeaterMatQuantity',key: 'batteryHeaterMatQuantity',width:wchBatteryHeaterMatQuantity},
        { header: 'EnclosureSnowShield',key: 'enclosureSnowShield',width:wchEnclosureSnowShield},
        { header: 'InternalBreaker',key: 'internalBreaker',width:wchInternalBreaker},
        { header: 'ServiceEntrance',key: 'serviceEntrance',width:wchServiceEntrance},
        { header: 'ReceptacleType',key: 'receptacleType',width:wchReceptacleType},
        { header: 'CheckSeizureAltBox',key: 'checkSeizureAltBox',width:wchCheckSeizureAltBox},
        { header: 'PowerSupplyIdLegible',key: 'powerSupplyIdLegible',width:wchPowerSupplyIdLegible},
        { header: 'CheckLampsLed',key: 'checkLampsLed',width:wchCheckLampsLed},
        { header: 'CheckMagneticBreaker',key: 'checkMagneticBreaker',width:wchCheckMagneticBreaker},
        { header: 'VisualCabinetInspection',key: 'visualCabinetInspection',width:wchVisualCabinetInspection},
        { header: 'CabinetLocked',key: 'cabinetLocked',width:wchCabinetLocked},
        { header: 'SecurityBarPresent',key: 'securityBarPresent',width:wchSecurityBarPresent},
        { header: 'CheckGroundCabinet',key: 'checkGroundCabinet',width:wchCheckGroundCabinet},
        { header: 'BatteryString1Fused',key: 'batteryString1Fused',width:wchBatteryString1Fused},
        { header: 'BatteryString2Fused',key: 'batteryString2Fused',width:wchBatteryString2Fused},
        { header: 'BatteryString3Fused',key: 'batteryString3Fused',width:wchBatteryString3Fused},
        { header: 'BatteryString4Fused',key: 'batteryString4Fused',width:wchBatteryString4Fused},
        { header: 'TamperInstalledFunctioning',key: 'tamperInstalledFunctioning',width:wchTamperInstalledFunctioning},
        { header: 'CheckLaps',key: 'checkLaps',width:wchCheckLaps},
        { header: 'CabinetVendor',key: 'cabinetVendor',width:wchCabinetVendor},
        { header: 'CheckOperatingLights',key: 'checkOperatingLights',width:wchCheckOperatingLights},
        { header: 'StandByOperation',key: 'standByOperation',width:wchStandByOperation},
        { header: 'RemoteStandbyOperation2',key: 'remoteStandbyOperation2',width:wchRemoteStandbyOperation2},
        { header: 'RemoteStandbyOperation3',key: 'remoteStandbyOperation3',width:wchRemoteStandbyOperation3},
        { header: 'RemoteStandbyOperation4',key: 'remoteStandbyOperation4',width:wchRemoteStandbyOperation4},
        { header: 'RemoteStandbyOperation5',key: 'remoteStandbyOperation5',width:wchRemoteStandbyOperation5},
        { header: 'InputSurgeArrestor',key: 'inputSurgeArrestor',width:wchInputSurgeArrestor},
        { header: 'OutputSurgeArrestor',key: 'outputSurgeArrestor',width:wchOutputSurgeArrestor},
        { header: 'CoaxTvssPresent',key: 'coaxTvssPresent',width:wchCoaxTvssPresent},
        { header: 'AcIndicatorGreenLight',key: 'acIndicatorGreenLight',width:wchAcIndicatorGreenLight},
        { header: 'LocalRemoteIndicator',key: 'localRemoteIndicator',width:wchLocalRemoteIndicator},
        { header: 'CommTech',key: 'commTech',width:wchCommTech},
        { header: 'FollowUpReason',key: 'followUpReason',width:wchFollowUpReason},
        { header: 'VisitStatus',key: 'visitStatus',width:wchVisitStatus},
        { header: 'CabinetBatteryCapacity',key: 'cabinetBatteryCapacity',width:wchCabinetBatteryCapacity},
        { header: 'FollowUpNeeded',key: 'followUpNeeded',width:wchFollowUpNeeded},
        { header: 'BatteriesReplaced', key: 'batteriesReplaced',width:wchBatteriesReplaced},
        { header: 'BatteryBalancerString',key: 'batteryBalancerString',width:wchBatteryBalancerString},
        { header: 'BatteryReplacementDate',key: 'BatteryReplacementDateValue',width:wchBatteryReplacementDate},
        { header: 'DateEntered',key: 'DateEnteredValue',width:wchDateEntered},
        { header: 'Temperatures',key: 'temperatures',width:wchTemperatures},
        { header: 'NumberOfBatteries',key: 'numberOfBatteries',width:wchNumberOfBatteries},
        { header: 'Manufacturer Type11',key: 'type11',width:wchType11},
        { header: 'Manufacturer Type12',key: 'type12',width:wchType12},
        { header: 'Manufacturer Type13',key: 'type13',width:wchType13},
        { header: 'Manufacturer Type14',key: 'type14',width:wchType14},
        { header: 'Manufacturer Type21',key: 'type21',width:wchType21},
        { header: 'Manufacturer Type22',key: 'type22',width:wchType22},
        { header: 'Manufacturer Type23',key: 'type23',width:wchType23},
        { header: 'Manufacturer Type24',key: 'type24',width:wchType24},
        { header: 'Manufacturer Type31',key: 'type31',width:wchType31},
        { header: 'Manufacturer Type32',key: 'type32',width:wchType32},
        { header: 'Manufacturer Type33',key: 'type33',width:wchType33},
        { header: 'Manufacturer Type34',key: 'type34',width:wchType34},
        { header: 'Manufacturer Type41',key: 'type41',width:wchType41},
        { header: 'Manufacturer Type42',key: 'type42',width:wchType42},
        { header: 'Manufacturer Type43',key: 'type43',width:wchType43},
        { header: 'Manufacturer Type44',key: 'type44',width:wchType44},
        { header: 'Manufacturer Type51',key: 'type51',width:wchType51},
        { header: 'Manufacturer Type52',key: 'type52',width:wchType52},
        { header: 'Manufacturer Type53',key: 'type53',width:wchType53},
        { header: 'Manufacturer Type54',key: 'type54',width:wchType54},
        { header: 'Manufacturer Type61',key: 'type61',width:wchType61},
        { header: 'Manufacturer Type62',key: 'type62',width:wchType62},
        { header: 'Manufacturer Type63',key: 'type63',width:wchType63},
        { header: 'Manufacturer Type64',key: 'type64',width:wchType64},
        { header: 'String1Battery1DateCode',key: 'string1Battery1DateCode',width:wchString1Battery1DateCode},
        { header: 'String1Battery2DateCode',key: 'string1Battery2DateCode',width:wchString1Battery2DateCode},
        { header: 'String1Battery3DateCode',key: 'string1Battery3DateCode',width:wchString1Battery3DateCode},
        { header: 'String1Battery4DateCode',key: 'string1Battery4DateCode',width:wchString1Battery4DateCode},
        { header: 'String2Battery1DateCode',key: 'string2Battery1DateCode',width:wchString2Battery1DateCode},
        { header: 'String2Battery2DateCode',key: 'string2Battery2DateCode',width:wchString2Battery2DateCode},
        { header: 'String2Battery3DateCode',key: 'string2Battery3DateCode',width:wchString2Battery3DateCode},
        { header: 'String2Battery4DateCode',key: 'string2Battery4DateCode',width:wchString2Battery4DateCode},
        { header: 'String3Battery1DateCode',key: 'string3Battery1DateCode',width:wchString3Battery1DateCode},
        { header: 'String3Battery2DateCode',key: 'string3Battery2DateCode',width:wchString3Battery2DateCode},
        { header: 'String3Battery3DateCode',key: 'string3Battery3DateCode',width:wchString3Battery3DateCode},
        { header: 'String3Battery4DateCode',key: 'string3Battery4DateCode',width:wchString3Battery4DateCode},
        { header: 'String4Battery1DateCode',key: 'string4Battery1DateCode',width:wchString4Battery1DateCode},
        { header: 'String4Battery2DateCode',key: 'string4Battery2DateCode',width:wchString4Battery2DateCode},
        { header: 'String4Battery3DateCode',key: 'string4Battery3DateCode',width:wchString4Battery3DateCode},
        { header: 'String4Battery4DateCode',key: 'string4Battery4DateCode',width:wchString4Battery4DateCode},
        { header: 'String5Battery1DateCode',key: 'string5Battery1DateCode',width:wchString5Battery1DateCode},
        { header: 'String5Battery2DateCode',key: 'string5Battery2DateCode',width:wchString5Battery2DateCode},
        { header: 'String5Battery3DateCode',key: 'string5Battery3DateCode',width:wchString5Battery3DateCode},
        { header: 'String5Battery4DateCode',key: 'string5Battery4DateCode',width:wchString5Battery4DateCode},
        { header: 'String6Battery1DateCode',key: 'string6Battery1DateCode',width:wchString6Battery1DateCode},
        { header: 'String6Battery2DateCode',key: 'string6Battery2DateCode',width:wchString6Battery2DateCode},
        { header: 'String6Battery3DateCode',key: 'string6Battery3DateCode',width:wchString6Battery3DateCode},
        { header: 'String6Battery4DateCode',key: 'string6Battery4DateCode',width:wchString6Battery4DateCode},
        { header: 'InstallDate11',key: 'installDate11',width:wchInstallDate11},
        { header: 'InstallDate12',key: 'installDate12',width:wchInstallDate12},
        { header: 'InstallDate13',key: 'installDate13',width:wchInstallDate13},
        { header: 'InstallDate14',key: 'installDate14',width:wchInstallDate14},
        { header: 'InstallDate21',key: 'installDate21',width:wchInstallDate21},
        { header: 'InstallDate22',key: 'installDate22',width:wchInstallDate22},
        { header: 'InstallDate23',key: 'installDate23',width:wchInstallDate23},
        { header: 'InstallDate24',key: 'installDate24',width:wchInstallDate24},
        { header: 'InstallDate31',key: 'installDate31',width:wchInstallDate31},
        { header: 'InstallDate32',key: 'installDate32',width:wchInstallDate32},
        { header: 'InstallDate33',key: 'installDate33',width:wchInstallDate33},
        { header: 'InstallDate34',key: 'installDate34',width:wchInstallDate34},
        { header: 'InstallDate41',key: 'installDate41',width:wchInstallDate41},
        { header: 'InstallDate42',key: 'installDate42',width:wchInstallDate42},
        { header: 'InstallDate43',key: 'installDate43',width:wchInstallDate43},
        { header: 'InstallDate44',key: 'installDate44',width:wchInstallDate44},
        { header: 'InstallDate51',key: 'installDate51',width:wchInstallDate51},
        { header: 'InstallDate52',key: 'installDate52',width:wchInstallDate52},
        { header: 'InstallDate53',key: 'installDate53',width:wchInstallDate53},
        { header: 'InstallDate54',key: 'installDate54',width:wchInstallDate54},
        { header: 'InstallDate61',key: 'installDate61',width:wchInstallDate61},
        { header: 'InstallDate62',key: 'installDate62',width:wchInstallDate62},
        { header: 'InstallDate63',key: 'installDate63',width:wchInstallDate63},
        { header: 'InstallDate64',key: 'installDate64',width:wchInstallDate64},
        { header: 'Voltage11',key: 'voltage11',width:wchVoltage11},
        { header: 'Voltage12',key: 'voltage12',width:wchVoltage12},
        { header: 'Voltage13',key: 'voltage13',width:wchVoltage13},
        { header: 'Voltage14',key: 'voltage14',width:wchVoltage14},
        { header: 'Voltage21',key: 'voltage21',width:wchVoltage21},
        { header: 'Voltage22',key: 'voltage22',width:wchVoltage22},
        { header: 'Voltage23',key: 'voltage23',width:wchVoltage23},
        { header: 'Voltage24',key: 'voltage24',width:wchVoltage24},
        { header: 'Voltage31',key: 'voltage31',width:wchVoltage31},
        { header: 'Voltage32',key: 'voltage32',width:wchVoltage32},
        { header: 'Voltage33',key: 'voltage33',width:wchVoltage33},
        { header: 'Voltage34',key: 'voltage34',width:wchVoltage34},
        { header: 'Voltage41',key: 'voltage41',width:wchVoltage41},
        { header: 'Voltage42',key: 'voltage42',width:wchVoltage42},
        { header: 'Voltage43',key: 'voltage43',width:wchVoltage43},
        { header: 'Voltage44',key: 'voltage44',width:wchVoltage44},
        { header: 'Voltage51',key: 'voltage51',width:wchVoltage51},
        { header: 'Voltage52',key: 'voltage52',width:wchVoltage52},
        { header: 'Voltage53',key: 'voltage53',width:wchVoltage53},
        { header: 'Voltage54',key: 'voltage54',width:wchVoltage54},
        { header: 'Voltage61',key: 'voltage61',width:wchVoltage61},
        { header: 'Voltage62',key: 'voltage62',width:wchVoltage62},
        { header: 'Voltage63',key: 'voltage63',width:wchVoltage63},
        { header: 'Voltage64',key: 'voltage64',width:wchVoltage64},
        { header: 'ApuCompletedBy',key: 'apuCompletedBy',width:wchApuCompletedBy},
        { header: 'ApuBatteryManufacturerType',key: 'apuBatteryManufacturerType',width:wchApuBatteryManufacturerType},
        { header: 'ApuBatteryDateCode',key: 'apuBatteryDateCode',width:wchApuBatteryDateCode},
        { header: 'ApuBatteryInstallDate',key: 'ApuBatteryInstallDateValue',width:wchApuBatteryInstallDate},
        { header: 'ApuBatteryVoltageNoLoad',key: 'apuBatteryVoltageNoLoad',width:wchApuBatteryVoltageNoLoad},
        { header: 'ApuBatteryConductance',key: 'apuBatteryConductance',width:wchApuBatteryConductance},
        { header: 'ApuBatteryConductanceCorrected',key: 'apuBatteryConductanceCorrected',width:wchApuBatteryConductanceCorrected},
        { header: 'ApuBatteryTorque',key: 'apuBatteryTorque',width:wchApuBatteryTorque},
        { header: 'ApuBatteryTerminalsCleaned',key: 'apuBatteryTerminalsCleaned',width:wchApuBatteryTerminalsCleaned},
        { header: 'ApuStarterBatteryChrgrVlt',key: 'apuStarterBatteryChrgrVlt',width:wchApuStarterBatteryChrgrVlt},
        { header: 'ApuChargerCurrentAmps',key: 'apuChargerCurrentAmps',width:wchApuChargerCurrentAmps},
        { header: 'FollowUpActionNeeded',key: 'followUpActionNeeded',width:wchFollowUpActionNeeded},
        { header: 'RecordAsFoundAlarms',key: 'recordAsFoundAlarms',width:wchRecordAsFoundAlarms},
        { header: 'ApuTestRun',key: 'apuTestRun',width:wchApuTestRun},
        { header: 'CheckOilLevel',key: 'checkOilLevel',width:wchCheckOilLevel},
        { header: 'OilAddedAmount',key: 'oilAddedAmount',width:wchOilAddedAmount},
        { header: 'OilFilterTight',key: 'oilFilterTight',width:wchOilFilterTight},
        { header: 'InspectGeneratorAirFilter',key: 'inspectGeneratorAirFilter',width:wchInspectGeneratorAirFilter},
        { header: 'InspectSparkPlug',key: 'inspectSparkPlug',width:wchInspectSparkPlug},
        { header: 'ClearApuEventLog',key: 'clearApuEventLog',width:wchClearApuEventLog},
        { header: 'ApuFrequency',key: 'apuFrequency',width:wchApuFrequency},
        { header: 'TankOneLevel',key: 'tankOneLevel',width:wchTankOneLevel},
        { header: 'TankTwoLevel',key: 'tankTwoLevel',width:wchTankTwoLevel},
        { header: 'GasMeterNumber',key: 'gasMeterNumber',width:wchGasMeterNumber},
        { header: 'GasMeterReading',key: 'gasMeterReading',width:wchGasMeterReading},
        { header: 'NgPressure',key: 'ngPressure',width:wchNgPressure},
        { header: 'ChangeCleanEnclosureAirFilter',key: 'changeCleanEnclosureAirFilter',width:wchChangeCleanEnclosureAirFilter},
        { header: 'CheckForRodentDamage',key: 'checkForRodentDamage',width:wchCheckForRodentDamage},
        { header: 'CheckLampsLeds',key: 'checkLampsLeds',width:wchCheckLampsLeds},
        { header: 'ClearWeeds',key: 'clearWeeds',width:wchClearWeeds},
        { header: 'CheckRegroutPadConduit',key: 'checkRegroutPadConduit',width:wchCheckRegroutPadConduit},
        { header: 'GroundMountPadUndermining',key: 'groundMountPadUndermining',width:wchGroundMountPadUndermining},
        { header: 'EnclosureDamageVandalism',key: 'enclosureDamageVandalism',width:wchEnclosureDamageVandalism},
        { header: 'CleanUpGarbage',key: 'cleanUpGarbage',width:wchCleanUpGarbage},
        { header: 'TestOilPressureAlarm',key: 'testOilPressureAlarm',width:wchTestOilPressureAlarm},
        { header: 'TestHighTempAlarm',key: 'testHighTempAlarm',width:wchTestHighTempAlarm},
        { header: 'GeneratorDcBusFunction',key: 'generatorDcBusFunction',width:wchGeneratorDcBusFunction},
        { header: 'CheckForGasLeaks',key: 'checkForGasLeaks',width:wchCheckForGasLeaks},
        { header: 'TestCombustibleGasAlarm',key: 'testCombustibleGasAlarm',width:wchTestCombustibleGasAlarm},
        { header: 'TestTamperAlarm',key: 'testTamperAlarm',width:wchTestTamperAlarm},
        { header: 'TestWaterIntrusionAlarm',key: 'testWaterIntrusionAlarm',width:wchTestWaterIntrusionAlarm},
        { header: 'TestPadShearAlarm',key: 'testPadShearAlarm',width:wchTestPadShearAlarm},
        { header: 'ApuVisitComments',key: 'apuVisitComments',width:wchApuVisitComments},
        { header: 'Alert Level',key: 'alertLevel',width:wchAlertLevel},
        { header: 'BootFile',key: 'bootFile',width:wchBootFile},
        { header: 'Bootr',key: 'bootr',width:wchBootr},
        { header: 'ConfigFile',key: 'configFile',width:wchConfigFile},
        { header: 'HwRev',key: 'hwRev',width:wchHwRev},
        //{ header: 'NitroReasonNotCompleted',key: 'nitroReasonNotCompleted',width:wchNitroReasonNotCompleted},
        //{ header: 'PhotoUploadedDate',key: 'PhotoUploadedDateValue',width:wchPhotoUploadedDate},
        { header: 'SwRev',key: 'swRev',width:wchSwRev},
        { header: 'SysDescr',key: 'sysDescr',width:wchSysDescr},
        { header: 'SysName',key: 'sysName',width:wchSysName},
        { header: 'Billing Codes',key:'billingCodes',width:wchbillingCodes},
        { header: 'Material Codes',key:'materialBillingCodes',width:wchmaterialBillingCodes}
      ];
    }
    if (fileType === 'DELETEDPS') {

      //Default Width's
      let regionName = 14;
      let headendName = 11;
      let communityName = 11;
      let nodeName = 11;
      let powerSupplyId = 11;
      let macAddress = 11;
      let ip = 11;
      let powerSupplyName = 11;
      let cmts = 15;
      let previousMacAddress = 15;
      let alertProfile = 15;
      // let controllerCardType = 15;
      let houseNumber = 15;
      let addressLine1 = 15;
      let crossStreet = 20;
      let city = 20;
      let state = 15;
      let zipCode = 20;
      let latitude = 20;
      let longitude = 20;
      let poleNumber = 20;
      let powerCompany = 20;
      let team = 20;
      let powersNode = 20;
      let meterNumber = 20;
      let mapNumber = 20;
      let node2 = 20;
      let node3 = 20;
      let node4 = 20;
      let node5 = 20;
      let node6 = 20;
      let node7 = 20;
      let node8 = 20;
      let node9 = 20;
      let node10 = 20;
      let node11 = 20;
      let node12 = 20;
      let node13 = 20;
      let node14 = 20;
      let node15 = 20;
      let batteries = 20;
      let miscellaneous = 20;
      let calculatedRuntime = 20;
      let standByStatus = 20;
      let feedsMultipleNodes = 20;
      let powerSupplyNumber = 20;
      let nextGenNode = 20;
      let powerSupplyType9360 = 20;
      let transponderVendor = 20;
      let transponderModel = 20;
      let powerSupplyModel = 20;
      let outputVoltageSpec = 20;
      let acInputVoltageSpec = 20;
      let currentAmpRatingSpec = 20;
      let currentAmpOutputUsed = 20;
      let batteriesReplaced = 20;
      let batteryBalancerString = 20;
      let aerialOrUg = 20;
      let egisName = 20;
      let globalId = 20;
      let nwtTeam = 20;
      let nitroCompletionDate = 20;
      let nitroReasonNotCompleted = 20;
      let deletedDate = 20;
      let deletedNt = 20;
      let deletedBy = 20;
      let wchVisitStatus=25;
      let wchFollowUpReason=33;
      let wchBusinessPartnerRestriction=20;

      json.forEach(deletedPSReport => {
        if (deletedPSReport.regionName !== null && regionName <= deletedPSReport.regionName.length) {
          regionName = deletedPSReport.regionName.length;
        }
        if (deletedPSReport.headendName !== null && headendName <= deletedPSReport.headendName.length) {
          headendName = deletedPSReport.headendName.length;
        }
        if (deletedPSReport.communityName !== null && communityName <= deletedPSReport.communityName.length) {
          communityName = deletedPSReport.communityName.length;
        }
        if (deletedPSReport.node !== null && nodeName <= deletedPSReport.node.length) {
          nodeName = deletedPSReport.node.length;
        }
        if (deletedPSReport.powerSupplyId !== null && powerSupplyId <= deletedPSReport.powerSupplyId.length) {
          powerSupplyId = deletedPSReport.powerSupplyId.length;
        }
        if (deletedPSReport.powerSupplyName !== null && powerSupplyName <= deletedPSReport.powerSupplyName.length) {
          powerSupplyName = deletedPSReport.powerSupplyName.length;
        }
        if (deletedPSReport.macAddress !== null && macAddress <= deletedPSReport.macAddress.length) {
          macAddress = deletedPSReport.macAddress.length;
        }
        if (deletedPSReport.ipAddress !== null && ip <= deletedPSReport.ipAddress.length) {
          ip = deletedPSReport.ipAddress.length;
        }
        if (deletedPSReport.cmts !== null && cmts <= deletedPSReport.cmts.length) {
          cmts = deletedPSReport.cmts.length;
        }
        if (deletedPSReport.previousMacAddress !== null && previousMacAddress <= deletedPSReport.previousMacAddress.length) {
          previousMacAddress = deletedPSReport.previousMacAddress.length;
        }
        if (deletedPSReport.city !== null && city <= deletedPSReport.city.length) {
          city = deletedPSReport.city.length;
        }
        if (deletedPSReport.state !== null && state <= deletedPSReport.state.length) {
          state = deletedPSReport.state.length;
        }
        if (deletedPSReport.zipCode !== null && zipCode <= deletedPSReport.zipCode.length) {
          zipCode = deletedPSReport.zipCode.length;
        }
        if (deletedPSReport.latitude !== null && latitude <= deletedPSReport.latitude.length) {
          latitude = deletedPSReport.latitude.length;
        }
        if (deletedPSReport.longitude !== null && longitude <= deletedPSReport.longitude.length) {
          longitude = deletedPSReport.longitude.length;
        }
        if (deletedPSReport.alertProfile !== null && alertProfile <= deletedPSReport.alertProfile.length) {
          alertProfile = deletedPSReport.alertProfile.length;
        }
        // if (deletedPSReport.controllerCardType !== null && controllerCardType <= deletedPSReport.controllerCardType.length) {
        //   controllerCardType = deletedPSReport.controllerCardType.length;
        // }
        if (deletedPSReport.houseNumber !== null && houseNumber <= deletedPSReport.houseNumber.length) {
          houseNumber = deletedPSReport.houseNumber.length;
        }
        if (deletedPSReport.addressLine1 !== null && addressLine1 <= deletedPSReport.addressLine1.length) {
          addressLine1 = deletedPSReport.addressLine1.length;
        }
        if (deletedPSReport.crossStreet !== null && crossStreet <= deletedPSReport.crossStreet.length) {
          crossStreet = deletedPSReport.crossStreet.length;
        }
        if (deletedPSReport.poleNumber !== null && poleNumber <= deletedPSReport.poleNumber.length) {
          poleNumber = deletedPSReport.poleNumber.length;
        }
        if (deletedPSReport.powerCompany !== null && powerCompany <= deletedPSReport.powerCompany.length) {
          powerCompany = deletedPSReport.powerCompany.length;
        }
        if (deletedPSReport.team !== null && team <= deletedPSReport.team.length) {
          team = deletedPSReport.team.length;
        }
        if (deletedPSReport.powersNode !== null && powersNode <= deletedPSReport.powersNode.length) {
          powersNode = deletedPSReport.powersNode.length;
        }
        if (deletedPSReport.meterNumber !== null && meterNumber <= deletedPSReport.meterNumber.length) {
          meterNumber = deletedPSReport.meterNumber.length;
        }
        if (deletedPSReport.mapNumber !== null && mapNumber <= deletedPSReport.mapNumber.length) {
          mapNumber = deletedPSReport.mapNumber.length;
        }
        if (deletedPSReport.node2 !== null && node2 <= deletedPSReport.node2.length) {
          node2 = deletedPSReport.node2.length;
        }
        if (deletedPSReport.node3 !== null && node3 <= deletedPSReport.node3.length) {
          node3 = deletedPSReport.node3.length;
        }
        if (deletedPSReport.node4 !== null && node4 <= deletedPSReport.node4.length) {
          node4 = deletedPSReport.node4.length;
        }
        if (deletedPSReport.node5 !== null && node5 <= deletedPSReport.node5.length) {
          node5 = deletedPSReport.node5.length;
        }
        if (deletedPSReport.node6 !== null && node6 <= deletedPSReport.node6.length) {
          node6 = deletedPSReport.node6.length;
        }
        if (deletedPSReport.node7 !== null && node7 <= deletedPSReport.node7.length) {
          node7 = deletedPSReport.node7.length;
        }
        if (deletedPSReport.node8 !== null && node8 <= deletedPSReport.node8.length) {
          node8 = deletedPSReport.node8.length;
        }
        if (deletedPSReport.node9 !== null && node9 <= deletedPSReport.node9.length) {
          node9 = deletedPSReport.node9.length;
        }
        if (deletedPSReport.node10 !== null && node10 <= deletedPSReport.node10.length) {
          node10 = deletedPSReport.node10.length;
        }
        if (deletedPSReport.node11 !== null && node11 <= deletedPSReport.node11.length) {
          node11 = deletedPSReport.node11.length;
        }
        if (deletedPSReport.node12 !== null && node12 <= deletedPSReport.node12.length) {
          node12 = deletedPSReport.node12.length;
        }
        if (deletedPSReport.node13 !== null && node13 <= deletedPSReport.node13.length) {
          node13 = deletedPSReport.node13.length;
        }
        if (deletedPSReport.node14 !== null && node14 <= deletedPSReport.node14.length) {
          node14 = deletedPSReport.node14.length;
        }
        if (deletedPSReport.node15 !== null && node15 <= deletedPSReport.node15.length) {
          node15 = deletedPSReport.node15.length;
        }
        if (deletedPSReport.batteries !== null && batteries <= deletedPSReport.batteries.length) {
          batteries = deletedPSReport.batteries.length;
        }
        if (deletedPSReport.miscellaneous !== null && miscellaneous <= deletedPSReport.miscellaneous.length) {
          miscellaneous = deletedPSReport.miscellaneous.length;
        }
        if (deletedPSReport.calculatedRuntime !== null && calculatedRuntime <= deletedPSReport.calculatedRuntime.length) {
          calculatedRuntime = deletedPSReport.calculatedRuntime.length;
        }
        if (deletedPSReport.standByStatus !== null && standByStatus <= deletedPSReport.standByStatus.length) {
          standByStatus = deletedPSReport.standByStatus.length;
        }
        if (deletedPSReport.feedsMultipleNodes !== null && feedsMultipleNodes <= deletedPSReport.feedsMultipleNodes.length) {
          feedsMultipleNodes = deletedPSReport.feedsMultipleNodes.length;
        }
        if (deletedPSReport.powerSupplyNumber !== null && powerSupplyNumber <= deletedPSReport.powerSupplyNumber.length) {
          powerSupplyNumber = deletedPSReport.powerSupplyNumber.length;
        }
        if (deletedPSReport.nextGenNode !== null && nextGenNode <= deletedPSReport.nextGenNode.length) {
          nextGenNode = deletedPSReport.nextGenNode.length;
        }
        if (deletedPSReport.powerSupplyType9360 !== null && powerSupplyType9360 <= deletedPSReport.powerSupplyType9360.length) {
          powerSupplyType9360 = deletedPSReport.powerSupplyType9360.length;
        }
        if (deletedPSReport.transponderVendor !== null && transponderVendor <= deletedPSReport.transponderVendor.length) {
          transponderVendor = deletedPSReport.transponderVendor.length;
        }
        if (deletedPSReport.transponderModel !== null && transponderModel <= deletedPSReport.transponderModel.length) {
          transponderModel = deletedPSReport.transponderModel.length;
        }
        if (deletedPSReport.powerSupplyModel !== null && powerSupplyModel <= deletedPSReport.powerSupplyModel.length) {
          powerSupplyModel = deletedPSReport.powerSupplyModel.length;
        }
        if (deletedPSReport.outputVoltageSpec !== null && outputVoltageSpec <= deletedPSReport.outputVoltageSpec.length) {
          outputVoltageSpec = deletedPSReport.outputVoltageSpec.length;
        }
        if (deletedPSReport.acInputVoltageSpec !== null && acInputVoltageSpec <= deletedPSReport.acInputVoltageSpec.length) {
          acInputVoltageSpec = deletedPSReport.acInputVoltageSpec.length;
        }
        if (deletedPSReport.currentAmpRatingSpec !== null && currentAmpRatingSpec <= deletedPSReport.currentAmpRatingSpec.length) {
          currentAmpRatingSpec = deletedPSReport.currentAmpRatingSpec.length;
        }
        if (deletedPSReport.currentAmpOutputUsed !== null && currentAmpOutputUsed <= deletedPSReport.currentAmpOutputUsed.length) {
          currentAmpOutputUsed = deletedPSReport.currentAmpOutputUsed.length;
        }
        if (deletedPSReport.batteriesReplaced !== null && batteriesReplaced <= deletedPSReport.batteriesReplaced.length) {
          batteriesReplaced = deletedPSReport.batteriesReplaced.length;
        }
        if (deletedPSReport.batteryBalancerString !== null && batteryBalancerString <= deletedPSReport.batteryBalancerString.length) {
          batteryBalancerString = deletedPSReport.batteryBalancerString.length;
        }
        // if (deletedPSReport.batteryBalancerString2 !== null && batteryBalancerString2 <= deletedPSReport.batteryBalancerString2.length) {
        //   batteryBalancerString2 = deletedPSReport.batteryBalancerString2.length;
        // }
        // if (deletedPSReport.batteryBalancerString3 !== null && batteryBalancerString3 <= deletedPSReport.batteryBalancerString3.length) {
        //   batteryBalancerString3 = deletedPSReport.batteryBalancerString3.length;
        // }
        // if (deletedPSReport.batteryBalancerString4 !== null && batteryBalancerString4 <= deletedPSReport.batteryBalancerString4.length) {
        //   batteryBalancerString4 = deletedPSReport.batteryBalancerString4.length;
        // }
        // if (deletedPSReport.batteryBalancerString5 !== null && batteryBalancerString5 <= deletedPSReport.batteryBalancerString5.length) {
        //   batteryBalancerString5 = deletedPSReport.batteryBalancerString5.length;
        // }
        // if (deletedPSReport.batteryBalancerString6 !== null && batteryBalancerString6 <= deletedPSReport.batteryBalancerString6.length) {
        //   batteryBalancerString6 = deletedPSReport.batteryBalancerString6.length;
        // }
        if (deletedPSReport.aerialOrUg !== null && aerialOrUg <= deletedPSReport.aerialOrUg.length) {
          aerialOrUg = deletedPSReport.aerialOrUg.length;
        }
        if (deletedPSReport.egisName !== null && egisName <= deletedPSReport.egisName.length) {
          egisName = deletedPSReport.egisName.length;
        }
        if (deletedPSReport.globalId !== null && globalId <= deletedPSReport.globalId.length) {
          globalId = deletedPSReport.globalId.length;
        }
        if (deletedPSReport.nwtTeam !== null && nwtTeam <= deletedPSReport.nwtTeam.length) {
          nwtTeam = deletedPSReport.nwtTeam.length;
        }
        if (deletedPSReport.nitroCompletionDate !== null && nitroCompletionDate <= deletedPSReport.nitroCompletionDate.length) {
          nitroCompletionDate = deletedPSReport.nitroCompletionDate.length;
        }
        if (deletedPSReport.powerAccountType !== null && nitroReasonNotCompleted <= deletedPSReport.powerAccountType.length) {
          nitroReasonNotCompleted = deletedPSReport.powerAccountType.length;
        }
        if (deletedPSReport.deletedDate !== null && deletedDate <= deletedPSReport.deletedDate.length) {
          deletedDate = deletedPSReport.deletedDate.length;
        }
        if (deletedPSReport.deletedNt !== null && deletedNt <= deletedPSReport.deletedNt.length) {
          deletedNt = deletedPSReport.deletedNt.length;
        }
        if (deletedPSReport.deletedBy !== null && deletedBy <= deletedPSReport.deletedBy.length) {
          deletedBy = deletedPSReport.deletedBy.length;
        }
        if(deletedPSReport.visitStatus !== null && wchVisitStatus <= deletedPSReport.visitStatus.length) {
          wchVisitStatus=deletedPSReport.visitStatus.length;
        }
        if(deletedPSReport.followUpReason !== null && wchFollowUpReason <= deletedPSReport.followUpReason.length) {
          wchFollowUpReason=deletedPSReport.followUpReason.length;
        }
        if(deletedPSReport.businessPartnerRestriction !== null && wchBusinessPartnerRestriction <= deletedPSReport.businessPartnerRestriction.length) {
        wchBusinessPartnerRestriction=deletedPSReport.businessPartnerRestriction.length;
        }
      });
      return [
        { header: 'RegionName', key: 'regionName', width: regionName },
        { header: 'HeadendName', key: 'headendName', width: headendName },
        { header: 'CommunityName', key: 'communityName', width: communityName },
        { header: 'NodeName', key: 'node', width: nodeName },
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: powerSupplyId },
        { header: 'MacAddress', key: 'macAddress', width: macAddress },
        { header: 'IP', key: 'ipAddress', width: ip },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: powerSupplyName },
        { header: 'CMTS', key: 'cmts', width: cmts },
        { header: 'HouseNumber', key: 'houseNumber', width: houseNumber },
        { header: 'AddressLine1', key: 'addressLine1', width: addressLine1 },
        { header: 'CrossStreet', key: 'crossStreet', width: crossStreet },
        { header: 'City', key: 'city', width: city },
        { header: 'State', key: 'state', width: state },
        { header: 'Zip', key: 'zipCode', width: zipCode },
        { header: 'GpsLatitude', key: 'latitude', width: latitude },
        { header: 'GpsLongitude', key: 'longitude', width: longitude },
        { header: 'PreviousMacAddress', key: 'previousMacAddress', width: previousMacAddress },
        { header: 'AlertProfile', key: 'alertProfile', width: alertProfile },
        // { header: 'ControllerCardType', key: 'controllerCardType', width: controllerCardType },
        { header: 'PoleNumber', key: 'poleNumber', width: poleNumber },
        { header: 'PowerCompany', key: 'powerCompany', width: powerCompany },
        { header: 'Team', key: 'team', width: team },
        { header: 'PowersNode', key: 'powersNode', width: powersNode },
        { header: 'PowerAccountType', key: 'powerAccountType', width: nitroReasonNotCompleted },
        { header: 'MeterNumber', key: 'meterNumber', width: meterNumber },
        { header: 'MapNumber', key: 'mapNumber', width: mapNumber },
        { header: 'Node2', key: 'node2', width: node2 },
        { header: 'Node3', key: 'node3', width: node3 },
        { header: 'Node4', key: 'node4', width: node4 },
        { header: 'Node5', key: 'node5', width: node5 },
        { header: 'Node6', key: 'node6', width: node6 },
        { header: 'Node7', key: 'node7', width: node7 },
        { header: 'Node8', key: 'node8', width: node8 },
        { header: 'Node9', key: 'node9', width: node9 },
        { header: 'Node10', key: 'node10', width: node10 },
        { header: 'Node11', key: 'node11', width: node11 },
        { header: 'Node12', key: 'node12', width: node12 },
        { header: 'Node13', key: 'node13', width: node13 },
        { header: 'Node14', key: 'node14', width: node14 },
        { header: 'Node15', key: 'node15', width: node15 },
        { header: 'Batteries', key: 'batteries', width: batteries },
        { header: 'Miscellaneous', key: 'miscellaneous', width: miscellaneous },
        { header: 'CalculatedRuntime(in Minutes)', key: 'calculatedRuntime', width: calculatedRuntime },
        { header: 'StandByStatus', key: 'standByStatus', width: standByStatus },
        { header: 'FeedsMultipleNodes', key: 'feedsMultipleNodes', width: feedsMultipleNodes },
        { header: 'PowerSupplyNumber', key: 'powerSupplyNumber', width: powerSupplyNumber },
        { header: 'NextGenNode', key: 'nextGenNode', width: nextGenNode },
        { header: 'PowerSupplyType9360', key: 'powerSupplyType9360', width: powerSupplyType9360 },
        { header: 'TransponderVendor', key: 'transponderVendor', width: transponderVendor },
        { header: 'TransponderModel', key: 'transponderModel', width: transponderModel },
        { header: 'PowerSupplyModel', key: 'powerSupplyModel', width: powerSupplyModel },
        { header: 'OutputVoltageSpec', key: 'outputVoltageSpec', width: outputVoltageSpec },
        { header: 'AcInputVoltageSpec', key: 'acInputVoltageSpec', width: acInputVoltageSpec },
        { header: 'CurrentAmpRatingSpec', key: 'currentAmpRatingSpec', width: currentAmpRatingSpec },
        { header: 'CurrentAmpOutputUsed', key: 'currentAmpOutputUsed', width: currentAmpOutputUsed },
        { header: 'BatteriesReplaced', key: 'batteriesReplaced', width: batteriesReplaced },
        { header: 'BatteryBalancerString', key: 'batteryBalancerString', width: batteryBalancerString },
        { header: 'AerialOrUg', key: 'aerialOrUg', width: aerialOrUg },
        { header: 'EgisName', key: 'egisName', width: egisName },
        { header: 'Global Identifier', key: 'globalId', width: globalId },
        { header: 'NWTTeam', key: 'nwtTeam', width: nwtTeam },
        { header: 'NitroCompletionDate', key: 'nitroCompletionDate', width: nitroCompletionDate },
        { header: 'DeletedDate', key: 'deletedDate', width: deletedDate },
        { header: 'DeletedNt', key: 'deletedNt', width: deletedNt },
        { header: 'DeletedBy', key: 'deletedBy', width: deletedBy },
        { header: 'FollowUpReason', key: 'followUpReason', width: wchFollowUpReason },
        { header: 'VisitStatus', key: 'visitStatus', width: wchVisitStatus },
        { header: 'BusinessPartnerRestriction', key: 'businessPartnerRestriction', width: wchBusinessPartnerRestriction }
      ];
    }

  }

  getDefinition(fileType) {
    if (fileType === 'RELIABILITY') {
      return [
        { field: "Division", definition: "Division" },
        { field: "RegionName", definition: "Region Name" },
        { field: "Headend Name", definition: "Headend Name" },
        { field: "CommunityName", definition: "Community Name" },
        { field: "NodeName", definition: "Node Name" },
        { field: "PowerSupplyId", definition: "Power Supply Id in PSNB" },
        { field: "PowerSupplyName", definition: "Power Supply Name " },
        { field: "PowerSupplyModel", definition: "Power Supply Model Name" },
        { field: "TransponderVendor", definition: "Transponder Vendor Name" },
        { field: "TransponderModel", definition: "Transponder Model Name" },
        { field: "Mac Address", definition: "MAC Address" },
        { field: "IP", definition: "IP Address" },
        { field: "PowerSupplyAddress", definition: "Power Supply Address" },
        { field: "City", definition: "City" },
        { field: "State", definition: "State" },
        { field: "Zip", definition: "Zip" },
        { field: "GpsLatitude", definition: "Gps Latitude" },
        { field: "GpsLongtitude", definition: "Gps Longtitude" },
        { field: "CurrentStatus", definition: "If active major alert present then 'Alert', else 'Normal'" },
        { field: "InputVoltage", definition: "Input Voltage" },
        { field: "InputVoltagePresent", definition: "Input Voltage Present" },
        { field: "OutputVoltage", definition: "Output voltage" },
        { field: "OuputCurrent", definition: "Output current" },
        { field: "BatteryStringVoltage", definition: "Battery String Voltage" },
        { field: "TotalBatteryStringVoltageAlarm", definition: "alert type = 'string_voltage'" },
        { field: "StringsCount", definition: "Total Strings of Battery (n)" },
        { field: "BatteriesPerString", definition: "Batteries per String (B)" },
        { field: "TotalBatteries", definition: "Total Strings * Batteries per String (n*B)" },
        { field: "TotalBatteryAlarm", definition: "Count of alerts of Type = 'battery_voltage'" },
        { field: "Type", definition: "Battery Type" },
        { field: "ManufactureDate", definition: "Manufacture Date" },
        { field: "InverterStatus", definition: "Running on Inverter: If active inverter alert present then 'On', else 'Off'" },
        { field: "TotalInverterStatusAlarm", definition: "Count of alerts of Type = 'inverter_status'" },
        { field: "MajorAlarm", definition: "If major alert present then 'Alarm', else 'No Alarm'" },
        { field: "TotalMajorAlarm", definition: "Count of major alerts" },
        { field: "MinorAlarm", definition: "If other than major alert present then 'Alarm', else 'No Alarm'" },
        { field: "TotalMinorAlarm", definition: "Count of alerts other than major alerts" },
        { field: "TamperAlarm", definition: "Tamper Alarm" },
        { field: "TotalTamperAlarm", definition: "Count of Tamper Alarm" },
        { field: "CreatedDate", definition: "Power Suppply Created Date" },
        { field: "CurrentMacFirstSighting", definition: "First Alert date for alert type =  'new_ps'" },
        { field: "TotalOfflineMinutes", definition: "Total Alert Duration for Last 30 days for Alert type = 'loss_of_comms', 'loss_of_comms_psos', 'online_not_detecting_ps' and 'loss_of_comms_unknown'" },
        { field: "TotalOfflineEvents", definition: "Total Alert count for Alert type = 'loss_of_comms', 'online_not_detecting_ps', 'loss_of_comms_unknown' and 'loss_of_comms_psos'" },
        { field: "MaxOfflineDuration", definition: "Max Alert Duration for Alert type = 'loss_of_comms', 'online_not_detecting_ps', 'loss_of_comms_unknown' and 'loss_of_comms_psos'" },
        { field: "MedianOfflineMinutes", definition: "Median Alert Duration for Alert type = 'loss_of_comms', 'online_not_detecting_ps', 'loss_of_comms_unknown' and 'loss_of_comms_psos'" },
        { field: "TotalNetworkPowerOfflineMinutes", definition: "Total alert duration for Alert type = 'loss_of_comms', 'online_not_detecting_ps', 'loss_of_comms_unknown' and 'loss_of_comms_psos' during the report time period" },
        { field: "TotalNetworkPowerOfflineEvents", definition: "Total alert events for Alert type = 'loss_of_comms', 'online_not_detecting_ps' and 'loss_of_comms_psos', 'loss_of_comms_unknown' during the report time period" },
        { field: "TotalCommericalPowerOutageMinutes", definition: "Total alert duration for Alert type = 'inverter_status' during the report time period" },
        { field: "NetworkUptime", definition: "((Report Days*24*60 - TOTAL-NETWORK-POWER-OFFLINE-MINUTES)/(Report Days*24*60))*100" },
        { field: "CommercialPowerUptime", definition: "((Report Days*24*60 - TOTAL-COMMERCIAL-POWER-OUTAGE-MINUTES)/(Report Days*24*60))*100" },
        { field: "Battery Coverage Minutes", definition: "Total alert duration Type = 'inverter_status'" },
        { field: "Battery outage coverage", definition: "Battery Time / (Battery Time + Loss of Comms on battery) *100" },
        { field: "StandbyEvents", definition: "Count of alerts of Type = 'inverter_status'" },
        { field: "AverageMinutesOnBattery", definition: "Average alert duration Type = 'inverter_status'" },
        { field: "TotalMinutesOnBattery", definition: "Total alert duration Type = 'inverter_status'" },
        { field: "MaxMinutesOnBattery", definition: "Maximum alert duration Type = 'inverter_status'" },
        { field: "TotalAlarmsCount", definition: "Total Alarms Count" },
        { field: "BootFile", definition: "Power Supply boot File" },
        { field: "PsFw", definition: "PS-FW" },
        { field: "DocFw", definition: "DOC_FW" },
        { field: "AppFw", definition: "APP_FW" },
        { field: "SagFw", definition: "SAG_FW" },
        { field: "AvgFailDur", definition: "AVG_FAIL_DUR" },
        { field: "ExpDur", definition: "EXP_DUR" },
        { field: "Total", definition: "TOTAL" },
        { field: "Passed", definition: "PASSED" },
        { field: "Failed", definition: "FAILED" }
      ];
    }
    if (fileType === 'VULNERABILITY') {
      return [
        { field: "RegionName", definition: "Region Name" },
        { field: "HeadendName", definition: "Head End Name" },
        { field: "CommunityName", definition: "Community Name" },
        { field: "NodeName", definition: "Node Name" },
        { field: "PowerSupplyId", definition: "Power Supply Id in PSNB" },
        { field: "MacAddress", definition: "MAC Address" },
        { field: "IP", definition: "IP Address" },
        { field: "PowerSupplyName", definition: "Power Supply Name" },
        { field: "PowerSupplyAddress", definition: "Power Supply Physical Address" },
        { field: "City", definition: "City" },
        { field: "Zip", definition: "Zip" },
        { field: "GpsLatitude", definition: "GPS Latitude" },
        { field: "GpsLongitude", definition: "GPS Longitude" },
        // { field: "OfflineStandbys", definition: "Number of instances off Standbys where PS went offline in the time period of the report" },
        // { field: "StandbyStart", definition: 'Starting time of shortest duration standby outage that failed to last 2 hours on batteries ("the outage")' },
        // { field: "StandbyEnd", definition: "Timestamp that the batteries failed or TX went offline for the outage" },
        // { field: "Duration", definition: "Amount of time on batteries for the outage" },
        // { field: "ProvenStandbyDuration", definition: "Longest proven standby duration for the PS, due to either remote test or unexpected standby, in the last 9 months" },
        // { field: "LastProvenStandby", definition: "Date timestamp at which Proven Standby Duration was recorded" },
        { field: "Alert Type", definition: "Under Performing PS Alert Type" },
        { field: "Alert Start Time", definition: "Under Performing PS Alert Start Time" },
        { field: "Alert End Time", definition: "Under Performing PS Alert End Time" },
        { field: "Predicted Runtime", definition: "Under Performing PS Alert Predicted Runtime" },
        { field: "Actual Runtime", definition: "Under Performing PS Alert Actual Runtime" },
        // { field: "LastPmDate", definition: "Last Preventive Maintenance Date as recorded" },
        // { field: "AlphaPmCertification", definition: "Report	Link to the PM Cert Report PDF" }
      ];
    }
  }
}
